import React, { Component } from 'react';
import './AgentTableMenuOverride.css';
import customStyle from '../../Assets/CSS/stylesheet_UHS'
import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';
import Popover from '@material-ui/core/Popover';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import { Modal,Toast  } from "react-bootstrap";
import { createMuiTheme, withStyles, MuiThemeProvider } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import MUIDataTable from "mui-datatables";
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import PublishIcon from '@material-ui/icons/Publish';
import InfoIcon from '@material-ui/icons/Info';
import TableCell from '@material-ui/core/TableCell';
import ScreenShareIcon from '@material-ui/icons/ScreenShare';
import XLSX from "xlsx";
import './readExcel.css'
import TransactionTable from './TransactionTable'
import Tooltip from "@material-ui/core/Tooltip";
import validator from 'validator'
// import CommonErrorModal from '../Screens/Enrollment/CommonPopup/CommonErrorModal'
import {
    FormControl,
    InputLabel,
    Select,
    Typography,
    TextField, Grid,
    Box,
    Checkbox,
    ListItemText,
    CircularProgress,
} from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Sample from '../CommonScreens/sampleTextField';
import SampleName from '../CommonScreens/sampleTextFieldName';
import Fab from "@material-ui/core/Fab";
import RefreshIcon from '@material-ui/icons/Refresh';
import axios from 'axios';
import configurations from "../../configurations";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import moment from "moment";
import Loader from "../loader";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Tabs from "@material-ui/core/Tabs";
import Tab from '@material-ui/core/Tab';
import { getQueryParams } from "../authentication/utils";
import { TrendingUpRounded, Close } from '@material-ui/icons';
import CommonDropDwn from "../CommonScreens/CommonDropDwn_1";
// import exportToExcel from './exportToExcel';
import { exportDefaultSpecifier } from '@babel/types';
import MuiPhoneNumber from "material-ui-phone-number";
import CloudDownload from '@material-ui/icons/CloudDownload';
import DescriptionIcon from '@material-ui/icons/Description';
import ReceiptIcon from '@material-ui/icons/Receipt';
import ShimmerDashboard from '../../Assets/Loaders/ShimmerEffect';
import { Programs } from "./ProgramTransition"
import { searchEnrolledMembers, getPlansByChannelId } from '../Services/enrollMembersAPI';
import { Chip } from "@mui/material";

const json2csv = require('json2csv').parse;
var convert = require('xml-js');
var validate = require("react-email-validator");

const AntTabs = withStyles(
    customStyle.tabs
)(Tabs);
const CustomTooltip = withStyles({
    tooltip: {
        fontSize: 14,
    },
})(Tooltip);
const AntTab = withStyles(theme => (
    customStyle.tab
))(props => <Tab disableRipple {...props} />);


const CustomButton = withStyles(
    customStyle.viewBtn
)(Button);
const CrudButton = withStyles(
    customStyle.crudBtnAgent,
)(Fab);
const NextButton = withStyles(
    customStyle.doneBtn
)(Button);


const HtmlTooltip = withStyles(theme => ({
    tooltip: {
        backgroundColor: '#fff',//theme.palette.common.black,
        border: '1px solid #000',
        fontSize : '12px',
        maxWidth : '220px',
        marginLeft:'15px',
        color: "#000"
    },
    arrow: {
        color: '#000',
    },
}))(Tooltip);

const uploadContent = {
    color: '#000000',
    fontWeight: '500',
    ul: {
        li: {
            color: '#f30',
            fontWeight: '500'
        }
    }
};

var formData = new FormData();
formData.append("draw", "1");
formData.append("start", "0");
formData.append("length", "10");
formData.append("columns[0].data", "id");
formData.append("columns[0].name", "");
formData.append("columns[0].searchable", "true");
formData.append("columns[0].orderable", "true");
formData.append("columns[0].search.regex", "false");
formData.append("columns[0].search.value", "");

formData.append("columns[1].data", "createdDate");
formData.append("columns[1].name", "");
formData.append("columns[1].searchable", "true");
formData.append("columns[1].orderable", "true");
formData.append("columns[1].search.regex", "false");
formData.append("columns[1].search.value", "");

formData.append("columns[2].data", "email");
formData.append("columns[2].name", "");
formData.append("columns[2].searchable", "true");
formData.append("columns[2].orderable", "true");
formData.append("columns[2].search.regex", "false");
formData.append("columns[2].search.value", "");

formData.append("columns[3].data", "enrollFlag");
formData.append("columns[3].name", "");
formData.append("columns[3].searchable", "true");
formData.append("columns[3].orderable", "false");
formData.append("columns[3].search.regex", "false");
formData.append("columns[3].search.value", "");

formData.append("columns[4].data", "firstName");
formData.append("columns[4].name", "");
formData.append("columns[4].searchable", "true");
formData.append("columns[4].orderable", "true");
formData.append("columns[4].search.regex", "false");
formData.append("columns[4].search.value", "");

formData.append("columns[5].data", "lastName");
formData.append("columns[5].name", "");
formData.append("columns[5].searchable", "true");
formData.append("columns[5].orderable", "true");
formData.append("columns[5].search.regex", "false");
formData.append("columns[5].search.value", "");

formData.append("columns[6].data", "completionStatus");
formData.append("columns[6].name", "");
formData.append("columns[6].searchable", "true");
formData.append("columns[6].orderable", "false");
formData.append("columns[6].search.regex", "false");
formData.append("columns[6].search.value", "");

formData.append("columns[7].data", "empid");
formData.append("columns[7].name", "");
formData.append("columns[7].searchable", "true");
formData.append("columns[7].orderable", "false");
formData.append("columns[7].search.regex", "false");
formData.append("columns[7].search.value", "");

formData.append("columns[8].data", "record");
formData.append("columns[8].name", "");
formData.append("columns[8].searchable", "true");
formData.append("columns[8].orderable", "true");
formData.append("columns[8].search.regex", "false");
formData.append("columns[8].search.value", "");

formData.append("columns[9].data", "inviteStatus");
formData.append("columns[9].name", "");
formData.append("columns[9].searchable", "true");
formData.append("columns[9].orderable", "true");
formData.append("columns[9].search.regex", "false");
formData.append("columns[9].search.value", "");

formData.append("columns[10].data", "status");
formData.append("columns[10].name", "");
formData.append("columns[10].searchable", "true");
formData.append("columns[10].orderable", "true");
formData.append("columns[10].search.regex", "false");
formData.append("columns[10].search.value", "");

formData.append("order[0].column", "0");
formData.append("order[0].dir", "desc");
formData.append("search.regex", "false");
formData.append("search.value", "");

let requestOptions = {
    method: 'POST',
    body: formData,
};

const statusObject = {
  0: "Instructions",
  1: "Setup Family",
  2: "Select Plan",
  3: "Select Add-Ons",
  4: "View Quote",
  5: "Personal Info",
  6: "Set up Payment",
  7: "Select Dates",
  8: "Submit Application",
  9: "Submit Application",
};


const statusOptions = [
  { label: 'ACTIVE', value: 'AC' },
  { label: 'TERMINATED', value: 'TE' },
  { label: 'DELINQUENT', value: 'DQ' },
  { label: 'PRE-CANCEL', value: 'PC' }
];

const statusMap = {
        'AC': 'ACTIVE',
        'ACTIVE': 'ACTIVE',
        'TE': 'TERMINATED',
        'TERMINATED': 'TERMINATED',
        'DQ': 'DELINQUENT',
        'DELINQUENT': 'DELINQUENT',
        'PC': 'PRE-CANCEL',
        'PRE-CANCEL': 'PRE-CANCEL',
        'IN': 'INACTIVE',
        'INACTIVE': 'INACTIVE'
    };

const STATUS_STYLES = {
  ACTIVE: {
    bg: "#E8F5E8",
    color: "#2E7D32",
  },
  TERMINATED: {
    bg: "#FFCDD2",
    color: "#B71C1C",
  },
  "PRE-CANCEL": {
    bg: "#FFF3E0",
    color: "#E65100",
  },
  DELINQUENT: {
    bg: "#FFEBEE",
    color: "#D32F2F",
  },
};

class AgentTable extends Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.notesEndRef = React.createRef();
        this.notesContainerRef = React.createRef();
        this.state = {
            userList: [],
            msgModal: false,
            userValid: false,
            headerList: ["User Id", "User Name", "Email Id", "Status"],
            loaderShow: false,
            createdDate: null,
            userData: [],
            disableProceed: true,
            anchorEl: null,
            modalShow: false,
            open: false,
            addUsermodalShow: false,
            fname: '',
            lname: '',
            email: '',
            phone: '',
            clientId: '',
            associationId: '',
            brokerId: '',
            countryCode: '+1',
            openedPopoverId: null,
            selectedIndex: null,
            selectedUSerData: {},
            errMsg: '',
            code: null,
            viewDetailsModal: false,
            editModal: false,
            searchText: '',
            searchTypeValue: '',
            searchShow: true,
            fName: '',
            lName: '', 
            fl: null, 
            dateAdded: '',
            prefix: '', 
            suffix:'',
            middleName:'',
            statusValue: '',
            userStatusValue: '',
            rowsPerPage: 10,
            count: 10,
            deleteModal: false,
            delEmail: '',
            targetDate: null,
            membersFromDate: null,
            membersToDate: null,
            membersPlanCodes: [],
            membersSelectedPlanCode: '',
            // Only set when user clicks a column to sort
            membersSortOrderName: '',
            membersSortOrderDirection: '',
            resendFlag: false,
            userName: '',
            activeTab: 0,
            viewUserData: [],
            transactionData: [],
            loginData: [],
            reassignHistoryData: [],
            detailsData: {},
            transCount: 0,
            loginCount: 0,
            reassignHistoryCount: 0,
            empid: '',
            page: 0,
            uploadExcelModal: false,
            validationExcelModal:false,
            duplicateEmail:false,
            excelValidation:false,
            validationArr:[],
            uploadFileName: '',
            file: {},
            recData: [],
            finalArr: [],
            showValidation:false,
            fileNameModal:false,
            //inValidData:[],
            inValidEmailData:[],
            inValidRecordData:[],
            successUpload:false,
            invalidMessage:false,
            city:'',
            state:'',
            country:'',
            tempEmail:'',
            checkZip:false,
            checkADDons:null,
            agentList : [],
            selectedAgent : '',
            selectedMemberId: '',
            reAssignAgentModal: false,
            prospectFullName:'',
            selecetedAgentName: '',
            reAssignSuccess: false,
            leadQualificationData:null,
            prospectObj:[],
            showCommonErrorModal:false,
            downloadFinalArr:[],
            exportToExcelArr :[],
            downloadDataFlag : false,
            emailID:"",
            phoneNumber:"",
            inviteStatus:"",
            userTerminated:false,
            sendHipaaAccess: (this.props.clientId.toString() === "5503" || this.props.clientId.toString() === "4364" ),
            prefixSuffix:{},
            viewNotes: false,
            noteInput: '',
            noteError: "",
            notes: [],
            notesError: "",
            circleloaderShow: false,
            errModal: false,
            selectedStatus:process.env.REACT_APP_PORTAL !== 'employer' ? ['DQ','PC'] : ['AC'],
            isDefaultLoad: true,
            fallbackToActive: false,
            invoiceList: [],
            adviceList: [],
            invoiceListLoading: false,
            adviceListLoading: false,
            showInvoiceList: false,
            showAdviceList: false,
            showInvoice: false,
            showAdvice: false,
            invoiceUrl: '',
            adviceUrl: '',
        };
    }

    componentDidUpdate(prevProps) {
        // Enforce prioritization reboot layout if client changes context dynamically
        if (prevProps.clientId !== this.props.clientId) {
            this.setState({
                selectedStatus: process.env.REACT_APP_PORTAL !== 'employer' ? ['DQ', 'PC'] : ['AC'],
                isDefaultLoad: true,
                fallbackToActive: false,
                page: 0,
                searchText: '',
                searchTypeValue: '5'
            });
        }
    }

    scrollToBottom = () => {
        if (this.notesContainerRef.current) {
            this.notesContainerRef.current.scrollTop = this.notesContainerRef.current.scrollHeight;
        }
    }

    componentDidMount() {
        // only fetch if allowed and (no isActive prop or it's true)
        if (this.props.autoFetchOnMount === false) {
            return;
        }
        if (this.props.hasOwnProperty('isActive') && this.props.isActive === false) {
            return;
        }

        this.setState({
            loaderShow: true
        });

        let queryParams = getQueryParams();
        let resolvedEmpid = '';
        if (queryParams && queryParams.empid) {
            resolvedEmpid = queryParams.empid;
        } else {
            resolvedEmpid = this.props.defaultEmpid || '';
        }

        if (process.env.REACT_APP_PORTAL === 'employer') {
            ["DQ", "PC"].forEach(value => {
                const index = statusOptions.findIndex(item => item.value === value);
                if (index > -1) statusOptions.splice(index, 1);
            });
        }
        
        if (this.props.enrollmentFilter === "members") {
            // Keep UI the same; just swap data source to Fabric members search.
            // Default Search By should be Member ID (first dropdown option).
            // Default status filter: Active (userStatusValue 'active' -> AC in Fabric params).
            this.setState({
                empid: resolvedEmpid,
                searchTypeValue: '5',
                searchShow: false,
                userStatusValue: this.state.userStatusValue,
                membersSortOrderName: 'status',
                membersSortOrderDirection: 'asc',
                // Default API sort for Members (no UI arrow until user sorts)
                fabricMembersSort: 'status',
            }, () => {
                this.fetchMembersFromFabric({ page: 0, rows: this.state.rowsPerPage });
            });
            this.fetchMembersPlans();
            return;
        }

        if (queryParams && queryParams.empid) {
            this.setState({ empid: queryParams.empid });
            this.getUserData(queryParams.empid)
        } else {
            this.setState({ empid: this.props.defaultEmpid });
            this.getUserData('NULL');
        }
        axios.get(process.env.REACT_APP_enrollment_base_url + "/addon/getAddonListByClient/"+ this.props.clientId)
                .then((response) => {
                    if(response && response.data.response.length > 0){
                        this.setState({checkADDons: true})
                    }else{
                        this.setState({checkADDons: false})
                    }                    
        });
    }

    applyEnrollmentFilter = () => {
        const { enrollmentFilter } = this.props;

        if (enrollmentFilter === "prospects") {
            formData.set("columns[3].search.value", "false");
        } else if (enrollmentFilter === "members") {
            formData.set("columns[3].search.value", "true");
        }
    }

    getUserByAgentUrl = (includeSearch = true) => {
        const baseUrl = configurations.baseUrl + '/enrollment/getUserByAgent/' + this.props.agentId;
        if (includeSearch && this.state.searchTypeValue === '1' && this.state.searchText && this.state.searchText.trim() !== '') {
            return `${baseUrl}?fullName=${encodeURIComponent(this.state.searchText.trim())}`;
        }
        return baseUrl;
    }

    // ------------------ Start file upload -----------------------------
    filenameModalClose=()=>{
    this.setState({fileNameModal:false})
}

handleInputChange = (e) => {
    const value = e.target.value;
    let errorMessage = "";

    if (value.length >= 125) {
        errorMessage = "Maximum 125 characters allowed.";
    }

    this.setState({ 
        noteInput: value,
        noteError: errorMessage
    });
};

  handleAddNote = () => {
    const { noteInput, notes } = this.state;
    if (noteInput.trim() === '') return;

    const newNote = {
        note: noteInput,
        source: this.state.detailsData.id,
        brokerId: this.props.agentId,
        subId: this.state.data[0].subId
    };

    axios.post(`${process.env.REACT_APP_BASE_URL}/enrollment/create-member-note`, newNote)
    .then(res => {
        this.getNotes(this.state.detailsData.id);
        this.setState({ noteInput: "", noteError: "" }, () => {
            this.scrollToBottom();
        })
    })
  };

    handleDrop = (e) => {
        let dt = e.dataTransfer;
        let files = dt.files;

        this.setState({ uploadFileName: files[0].name ,fileNameModal:true});
        this.handleFiles(files);
    };

    handleFiles = (files) => {
        files = [...files];
        var f = JSON.stringify(files[0].name)
        console.log("File Name===",files[0].name)

        // alert(f)
          if(files && files[0]){
            if(files[0].type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || files[0].type == 'application/vnd.ms-excel'){
                this.setState({invalidMessage:false,fileNameModal:true})
            }else{
                this.setState({fileNameModal:false,invalidMessage:true})
            

            }
         }   
       
        this.previewFile(files)
       
        
    };
    previewFile = (file, e) => {

        var fileReader = new FileReader();
        fileReader.onload = (event) => {
            var getData = event.target.result;
            
            var workbook = XLSX.read(getData, {
                type: "binary"
            });
            workbook.SheetNames.forEach(sheet => {
                let rowObject = XLSX.utils.sheet_to_json(
                    workbook.Sheets[sheet]                    
                );
                
                let jsonObject = JSON.stringify(rowObject);
                this.setState({ recData: this.state.fileNameModal==true?rowObject:null }, () => {
                    console.log("recData===",this.state.recData)
                    this.rename()
                }
                )
            })

        }

        fileReader.readAsBinaryString(file[0])

    };

    /* handleChangefileup(files) {
        this.setState({
            upfile: files
        });
    }

    handleUploadAdd=(newFiles)=>{
        newFiles = newFiles.filter(file => !this.state.uploadFiles.find(f => f.data === file.data));
            this.setState({uploadFiles:[...this.state.uploadFiles, ...newFiles]},()=> console.log("handleUploadAdd======",this.state.uploadFiles))
    } */
    handleUploadSave = () => {
        this.setState({ uploadExcelModal: false })
    }

    // handleChangeFile=(e,fil)=> {

    //     console.log("files----", e);
    //     const files = e.target.files;
    //     console.log("files----------", files);
    //     if (files && files[0]) {
    //     this.setState({ file: files[0] });
    //     }
    //   }
    handleChangeFile = (e) => {

        const files = e.target.files;
        console.log("File Name===",files[0].name)
      
        if (files && files[0] ) {
            if(files[0].type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || files[0].type == 'application/vnd.ms-excel' ){
                var fileName = e.target.files[0].name;
                this.setState({ file: files[0],invalidMessage:false, uploadFileName: fileName,fileNameModal:true }, () => this.previewFile(files));
            }else{
                this.setState({ invalidMessage:true,fileNameModal:false });

            }
            }
          
    }



    renameKey = (obj, old_key, new_key) => {
        if (old_key !== new_key) {
            Object.defineProperty(obj, new_key,
                Object.getOwnPropertyDescriptor(obj, old_key));
            delete obj[old_key];
             if ((new_key === 'firstName' || new_key === 'lastName') && obj[new_key]) {
                obj[new_key] = String(obj[new_key]).toUpperCase();
            }
        }

    }

    normalizeStr = (val) => {
        if (val === undefined || val === null) return '';
        return String(val).trim();
    }

    validateCensusTemplate = (excelData, validExl= false) => {
        if (!excelData || excelData.length === 0) {
            return { valid: false, msg: 'The uploaded file is empty.' };
        }
        const firstRow = excelData[0];
        const keys = Object.keys(firstRow);
        
        // Define required headers for census upload
        const requiredHeaders = validExl ? [
            "Record #",
            "Relationship",
            "First Name",
            "Last Name",
            "Date of Birth",
            "Age",
            "Birth Gender",
            "Zip",
            "Email Address",
            "Phone"
            ] : [
            "record",
            "relationship",
            "firstName",
            "lastName",
            "dob",
            "age",
            "gender",
            "zipCode",
            "email",
            "phone"
        ];
        
        // Normalize keys by trimming whitespace
        const normalizedKeys = keys.map(k => k.trim());
        console.log("normalizedKeys===",normalizedKeys)
        // Check if all required headers are present
        const missingHeaders = requiredHeaders.filter(
            header => !normalizedKeys.includes(header)
        );
        
        if (missingHeaders.length > 0) {
            return {
                valid: false,
                msg: 'This file is not in census upload format. It appears to be an employee list export. Use "Download Template" (new census) or "Download Current Census" (update), then include Relationship, First Name, Last Name, Date of Birth, Age, Birth Gender, and Zip for each household member.'
            };
        }
        
        return { valid: true };
    }

    rename = () => {
        this.setState({ uploadLoaderShow: true})

        // Validate recData contains required columns before processing
        if (!this.state.recData || this.state.recData.length === 0) {
            this.setState({
                fileNameModal: false,
                validationExcelModal: true,
                successUpload: false,
                excelValidation: true,
                uploadLoaderShow: false,
                validationArr: [
                    { record: '', relationship: '', msg: 'This file is not in census upload format. It appears to be an employee list export. Use "Download Template" (new census) or "Download Current Census" (update), then include Relationship, First Name, Last Name, Date of Birth, Age, Birth Gender, and Zip for each household member.' },
                ],
            });
            return;
        }

        const initialTemplateCheck = this.validateCensusTemplate(this.state.recData, true);
        if (!initialTemplateCheck.valid) {
            this.setState({
                fileNameModal: false,
                validationExcelModal: true,
                successUpload: false,
                excelValidation: true,
                uploadLoaderShow: false,
                validationArr: [
                    { record: '', relationship: '', msg: initialTemplateCheck.msg },
                ],
            });
            return;
        }

        // Trim whitespace from Excel column headers (e.g. "Record ", "Email ")
        this.state.recData.forEach((obj) => {
            Object.keys(obj).forEach((key) => {
                const trimmed = key.trim();
                if (trimmed !== key) {
                    this.renameKey(obj, key, trimmed);
                }
            });
        });

        this.state.recData.forEach(obj => {
            Object.entries(obj).map(([key, value]) => {

                if (key === "Record #" || key === "Record") {
                    this.renameKey(obj, key, 'record')
                }

                if (key === "Employee Record") {
                    this.renameKey(obj, 'Employee Record', 'employeeRecord')
                }
                if (key === "Relationship") {
                    this.renameKey(obj, 'Relationship', 'relationship')
                   
                }
                if (key === "First Name") {
                    this.renameKey(obj, 'First Name', 'firstName')
                }
                if (key === "Last Name") {
                    this.renameKey(obj, 'Last Name', 'lastName')
                }
                if (key === "Date of Birth") {
                    var serial = value;
                    this.renameKey(obj, 'Date of Birth', 'dob')

                    var utc_days = Math.floor(serial - 25569);
                    var utc_value = utc_days * 86400;
                    var date_info = new Date(utc_value * 1000);
                    var month
                    var day
                    if ((date_info.getMonth() + 1) < 10) {
                        month = '0' + (date_info.getMonth() + 1)
                    } else {
                        month = (date_info.getMonth() + 1)
                    }
                    if ((date_info.getDate()) < 10) {
                        day = '0' + (date_info.getDate())
                    } else {
                        day = (date_info.getDate())
                    }

                    var x = date_info.getFullYear() + '-' + month + '-' + day

                    obj.dob = x


                }
                if (key === "Age") {
                    this.renameKey(obj, 'Age', 'age')
                }
               
                if (key === "Birth Gender") {
                    this.renameKey(obj, 'Birth Gender', 'gender')
                    const gender = this.normalizeStr(obj.gender);
                    if (gender === 'F' || gender === 'f' || gender.toLowerCase() === 'female') {
                        return (obj.gender = 'FEMALE');
                    }
                    if (gender === 'M' || gender === 'm' || gender.toLowerCase() === 'male') {
                        return (obj.gender = 'MALE');
                    }
                }
                if (key === "Zip") {
                    this.renameKey(obj, 'Zip', 'zipCode')
                }
                if (key === "Email Address" || key === "Email") {
                    this.renameKey(obj, key, 'email')
                }
                if (key === "Phone") {
                    this.renameKey(obj, 'Phone', 'phone');
                }
            })
        
        });


       
        //--- Check for excelsheet validation
        
        let excelData = this.state.recData;

        console.log("excelData===",excelData)

        const templateCheck = this.validateCensusTemplate(excelData);
        if (!templateCheck.valid) {
            this.setState({
                fileNameModal: false,
                validationExcelModal: true,
                successUpload: false,
                excelValidation: true,
                uploadLoaderShow: false,
                validationArr: [
                    { record: '', relationship: '', msg: templateCheck.msg },
                ],
            });
            return;
        }

        let recNumber;
        for (let x = 0; x < excelData.length; x++) {
            const relationship = this.normalizeStr(excelData[x].relationship);

            if((excelData[x].record && relationship === "Employee") || relationship === "Spouse" || relationship === "Child"){
                //let recNumber = excelData[x].record  && typeof(excelData[x].record) !== 'string'? excelData[x].record: excelData[x-1].record ? excelData[x-1].record : excelData[(x-1)-(x-1)].record ; 
                if(relationship === "Employee"){
                    recNumber = excelData[x].record && typeof(excelData[x].record) !== 'string'? excelData[x].record:'NA'; 
                }
                
                if(typeof(excelData[x].record) == 'string'){ // check for blank space
                     let recNum = excelData[x].record.toString();
                    if(!recNum?.trim()){
                    delete excelData[x].record;
                    }
                }
                if(excelData[x].record){
                    let chkRegex = this.checkRegex(excelData[x].record, 'Record' )
                    if(!chkRegex){
                        this.state.validationArr.push({record:recNumber, relationship:excelData[x].relationship, msg:'Record number is not in number format'})
                    }                
                }

               

                if(!excelData[x].age && (!excelData[x].dob || excelData[x].dob=='NaN-NaN-NaN')){
                    // if(!excelData[x].dob || excelData[x].dob=='NaN-NaN-NaN'){
                        this.state.validationArr.push({record:recNumber, relationship:excelData[x].relationship, msg:excelData[x].dob=='NaN-NaN-NaN' ? 'Birth date is invalid' : 'Age or Birth Date missing'})
                    } else{
                        if(excelData[x].age){
                            if(/^\s+$/.test(excelData[x].age)){
                                delete excelData[x].age
                            }else{
                                let chkRegex = this.checkRegex(excelData[x].age, 'Age' )
                            if(!chkRegex){
                             this.state.validationArr.push({record:recNumber, relationship:excelData[x].relationship, msg:'Age is invalid'})
                            }else{ // if age present and type age not between 18 - 86 or  0-26
                                if((relationship === 'Employee' || relationship === 'Spouse') && (excelData[x].age > 17 && excelData[x].age < 86)){
                                this.state.validationArr.push()
                                }
                                else if(relationship === "Child" && (excelData[x].age >= 0 && excelData[x].age < 26)){
                                    this.state.validationArr.push()
                                }else{
                                    this.state.validationArr.push({record:recNumber, relationship:excelData[x].relationship, msg:'Age is invalid'})

                                }
                            }
                            }
                            
                        }
                        if(excelData[x].dob){
                            if(/^\s+$/.test(excelData[x].dob)){
                                delete excelData[x].dob
                            }else{
                            var today = new Date();
                            var birthDate = new Date(excelData[x].dob);
                            var age_now = today.getFullYear() - birthDate.getFullYear();
                            console.log("=age_now===",age_now)
                            var m = today.getMonth() - birthDate.getMonth();
                            if(birthDate.getFullYear() < 1900){
                                delete excelData[x].dob
                            }else{
                                if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                                    age_now--;
                                    console.log("=age_now===",age_now)
                                }
                                if(relationship === "Employee" || relationship === "Spouse"){
                                    if(age_now > 17 && age_now < 86){
                                        excelData[x].age=age_now
                                    }else{
                                this.state.validationArr.push({record:recNumber, relationship:excelData[x].relationship, msg:'The acceptable age for an adult is from 18 to 86 years '})
        
                                    }
                                }else if(relationship === "Child" ){
                                    if(age_now >= 0 && age_now < 26){
                                        excelData[x].age=age_now
                                    }else{
                                        this.state.validationArr.push({record:recNumber, relationship:excelData[x].relationship, msg:'The acceptable age for a child is upto 26 years'})
        
                                    }
                                }
                                }
                            }
                          
                            
                        }
                       
                        
                    }        
                
                // }
                
                // else{
                //     let chkRegex = this.checkRegex(excelData[x].age, 'Age' )
                //     if(!chkRegex){
                //         this.state.validationArr.push({record:recNumber, relationship:excelData[x].relationship, msg:'Age is not in number format'})
                //     }
                    
                // }
    
              // Replace the zipcode validation section (around line 880-950) with:

                if(!excelData[x].zipCode){
                    this.state.validationArr.push({record:recNumber, relationship:excelData[x].relationship, msg:'Zip code is missing'})
                }else{
                    let chkRegex = this.checkRegex(excelData[x].zipCode, 'Zip' )
                    if(!chkRegex){
                        this.state.validationArr.push({record:recNumber, relationship:excelData[x].relationship, msg:'Zip Code is not in correct format'})
                    }else{
                        if(excelData[x].zipCode.toString().length == 4){
                            excelData[x].zipCode = "0"+excelData[x].zipCode
                        }

                        console.log("zipcode-----value in excel====",excelData[x].zipCode)
                        if (!this.zipcodeValidationQueue) {
                            this.zipcodeValidationQueue = [];
                        }
                        
                        let url = `${process.env.REACT_APP_BASE_ROOT_URL}/agency/api/zipcode/lookup?zipcode=${excelData[x].zipCode}`
                        
                        // Capture current index and record data for async callback
                        const currentIndex = x;
                        const currentRecord = excelData[x];
                        const currentRecNumber = recNumber;

                        axios.get(url)
                        .then(response => {                            
                            var result2 = response.data;
                            
                            if (!result2 || !result2.stateAbbreviation) {
                                // Invalid zip code
                                  excelData[currentIndex].state = '';
                                  excelData[currentIndex].city = '';
                                  excelData[currentIndex].country = '';
                                this.state.validationArr.push({
                                    record: currentRecNumber, 
                                    relationship: currentRecord.relationship, 
                                    msg: 'Invalid zipcode'
                                });
                            } else {
                                // Valid zip code - check if state is blacklisted
                                axios.get(`${process.env.REACT_APP_BASE_ROOT_URL}/agency/api/v1/check-state-sellable?agencyId=${this.props.associationId}&stateCode=${result2.stateAbbreviation}`)
                                    .then(response => {
                                        if (response.data.response) {
                                            // State is blacklisted
                                            this.state.validationArr.push({
                                                record: currentRecNumber, 
                                                relationship: currentRecord.relationship, 
                                                msg: `We're sorry. At this time, we are not offering the Universal HealthShare program in this zip code`
                                            })
                                        } else {
                                            // Valid state - update the excelData with validated info
                                            excelData[currentIndex].zipCode = result2.zipcode;
                                            excelData[currentIndex].state = result2.stateAbbreviation;
                                            excelData[currentIndex].city = result2.city;
                                            excelData[currentIndex].country = 'US';
                                        }
                                        this.zipcodeValidationQueue.pop();
                                        if (this.zipcodeValidationQueue.length === 0) {
                                            this.processValidationResults(excelData);
                                        }
                                    })
                                    .catch(error => {
                                        console.log("Error validating state:", error);
                                        this.state.validationArr.push({
                                            record: currentRecNumber, 
                                            relationship: currentRecord.relationship, 
                                            msg: 'Invalid zipcode'
                                        });
                                        this.zipcodeValidationQueue.pop();
                                        if (this.zipcodeValidationQueue.length === 0) {
                                            this.processValidationResults(excelData);
                                        }
                                    });
                            }
                        })
                        .catch(error => {
                            console.log("Error validating zipcode:", error);
                            this.state.validationArr.push({
                                record: currentRecNumber, 
                                relationship: currentRecord.relationship, 
                                msg: 'Invalid zipcode'
                            });
                            this.zipcodeValidationQueue.pop();
                            if (this.zipcodeValidationQueue.length === 0) {
                                this.processValidationResults(excelData);
                            }
                        });
                        this.zipcodeValidationQueue.push({ index: x, record: recNumber });
                    }
                }
                if(!excelData[x].email){
                    excelData[x].email=null
                }else{
                    if(/^\s+$/.test(excelData[x].email)){
                        delete excelData[x].email
                    }else{
                        let chkRegex = this.checkRegex(excelData[x].email, 'email' )
                        if(!chkRegex){
                            this.state.validationArr.push({record:recNumber, relationship:excelData[x].relationship, msg:'Email is invalid'})
                        }
                    }
                   
                }
                
                if(!excelData[x].firstName){
                    excelData[x].firstName=""
                }
                if(!excelData[x].lastName){
                    excelData[x].lastName=""
                }
                let phoneDigits = '';
                if (excelData[x].phone !== undefined && excelData[x].phone !== null) {
                    phoneDigits = String(excelData[x].phone).replace(/\D/g, '');
                }
                if (relationship === 'Employee') {
                    if (!phoneDigits || phoneDigits.length !== 10) {
                        excelData[x].phone = ""
                        this.state.validationArr.push({ record: recNumber, relationship: excelData[x].relationship, msg: 'Phone number should have 10 digits' });
                    } else {
                        excelData[x].phone = phoneDigits;
                    }
                } else {
                    if (phoneDigits && phoneDigits.length > 0) {
                        excelData[x].phone = phoneDigits;
                    } else {
                        excelData[x].phone = "";
                    }
                }
                if(!excelData[x].gender){
                    this.state.validationArr.push({record:recNumber, relationship:excelData[x].relationship, msg:'Birth Gender is missing'})
                }else {
                    if(excelData[x].gender == "MALE" || excelData[x].gender == "FEMALE"){
                        
                    }else{
                        this.state.validationArr.push({record:recNumber, relationship:excelData[x].relationship, msg:'Birth Gender must be either Male or Female'})    
                    }                            
                }
            }else {
                this.state.validationArr = [];
                const rowMsg = relationship
                    ? 'Record Number missing of row ' + (x + 1)
                    : 'Relationship is missing or invalid on row ' +
                      (x + 1) +
                      '. Expected Employee, Spouse, or Child.';
                this.state.validationArr.push({
                    record: '',
                    relationship: relationship || '',
                    msg: rowMsg,
                });
                break
            }
            
        }


        console.log("validationArr===",this.state.validationArr)

        if(this.state.validationArr && this.state.validationArr.length>0){
            this.setState({
                fileNameModal: false,
                validationExcelModal: true,
                successUpload: false,
                excelValidation: true,
                uploadLoaderShow: false
            })
        }else{
            
            this.state.recData = excelData;     
            setTimeout(() => {
                this.setState({uploadLoaderShow: false, fileNameModal:true});
                this.handleUploadFile();
            }, 8000);    
        }

        console.log("excelData FINAL ===",this.state.recData)
               
        // setTimeout(() => {
        //     this.setState({uploadLoaderShow: false, fileNameModal:true});
        //     this.handleUploadFile(); // new change on 21 jan 2022
        // }, 8000);




        // To Check duplicate email in uploaded excel sheet
        /* if(excelData && excelData.length > 0){
            for (let a = 0; a < excelData.length; a++) {
                if(excelData[a].relationship == "Employee"){
                    let findData = excelData.filter(obj => obj.email == excelData[a].email);
                    if(findData && findData.length>1){
                        this.setState({
                            fileNameModal: false,
                            validationExcelModal: true,
                            successUpload: false,
                            duplicateEmail: true
                        })
                        break;
                    }
                }
               
            }
        } */


    }

    processValidationResults = (excelData) => {
    console.log("validationArr===", this.state.validationArr);
    
    if(this.state.validationArr && this.state.validationArr.length > 0){
        this.setState({
            fileNameModal: false,
            validationExcelModal: true,
            successUpload: false,
            excelValidation: true,
            uploadLoaderShow: false
        })
    }else{
        this.state.recData = excelData;     
        setTimeout(() => {
            this.setState({uploadLoaderShow: false, fileNameModal:true});
            this.handleUploadFile();
        }, 8000);    
    }
}
     checkRegex = (val, key)=>{
         
           var reg = new RegExp();

            if(key == 'Record'){

                let recVal = parseInt(val);
                reg = (/^[0-9]*$/);
                console.log(reg.test(recVal));                
                return reg.test(recVal);  // returns a boolean

            }
            if(key == 'Age'){

                let ageVal = parseInt(val);
                reg = (/^[0-9]{1,2}$/);
                console.log(reg.test(ageVal));                
                return reg.test(ageVal);  // returns a boolean

            }
            if(key == 'Zip'){
                let value = val;
                if(typeof(value) == 'string'){
                    value = value.replace(/ +/g, "");
                }
                if(value.toString().length == 4){
                    value = "0" + value
                    console.log("zipvalue====",value)
                }
                console.log("Zipcode value",parseInt(value)); 
                
                let zipVal = value;
                console.log("Zipcode value",zipVal); 
                reg = (/^[0-9]{5}$/);
                console.log("Zipcode value",reg.test(zipVal));                
                return reg.test(zipVal);  // returns a boolean
                
            }
            if(key == 'email'){
                let emailVal = val;
                console.log("email===",val)
                reg = (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/);
               
                // if(emailVal.match(reg)){
                // var txt = emailVal.split("@")[1]
                // var txtCom = txt.split(".com").length - 1 
                // var txtCom1 = txt.split(".com.").length - 1 
                // if(txtCom == 0 || txtCom1  != 0 ){
                //     return false
                // }else {
                //     return true
                // }
                // }

                if (validator.isEmail(emailVal)) {
                    return true
                  } else {
                    return false
                  }



                // return reg.test(emailVal);  // returns a boolean
                
            }
            if(key == 'phone') {
                // let phoneVal = val.replace(/[^0-9]/g, '');
                reg = (/^[0-9]{10}$/);
                return reg.test(val);
            }
     }

  checkZipcodeValidation=(zipcode,recNumber,relationship)=>{
    let url = `${process.env.REACT_APP_BASE_ROOT_URL}/agency/api/zipcode/lookup?zipcode=${zipcode}`

    axios.get(url)
        .then(response => {
            var result2 = response.data;
            
            if (!result2.stateAbbreviation) {
                // Handle invalid zip code
                this.state.validationArr.push({
                    record: recNumber,
                    relationship: relationship,
                    message: "Enter valid zip code"
                });
            } else {
                // Valid zip code - zip code validation passed
                console.log("Zip code validated:", result2);
            }
            this.setState({
                validationArr: this.state.validationArr
            });
        })
        .catch(error => {
            console.log("Zipcode validation error:", error);
            this.state.validationArr.push({
                record: recNumber,
                relationship: relationship,
                message: "Error validating zip code"
            });
            this.setState({
                validationArr: this.state.validationArr
            });
        })
}

   handleUploadFile = () => {
    this.setState({loaderShow:true,invalidMessage:false})

    let USER_DATA = JSON.parse(sessionStorage.getItem('USER_DATA'));
    let getData = this.state.recData;

    console.log("getData===",getData)   
    if (getData && getData.length > 0) {
        
        this.state.finalArr = [];
        const emailMap = {};
        const duplicateEmails = [];
        const recordDetails = [];

        // Check for duplicate emails
        for (let i = 0; i < getData.length; i++) {
            if (getData[i].relationship === "Employee" && getData[i].email) {
                const email = String(getData[i].email).toLowerCase().trim();
                if (emailMap[email]) {
                    if (!duplicateEmails.includes(email)) {
                        duplicateEmails.push(email);
                        recordDetails.push(getData[i]);
                    }
                } else {
                    emailMap[email] = true;
                }
            }
        }
        console.log("Duplicate Emails===", recordDetails);
        
        // If duplicate emails found, show error
        if (duplicateEmails.length > 0) {
            this.setState({
                validationExcelModal: true,
                successUpload: false,
                excelValidation: false,
                duplicateEmail: true,
                errMsg: "The following email addresses are duplicated in the census: " + duplicateEmails.join(", "),
                fileNameModal: false,
                loaderShow: false,
                inValidRecordData: recordDetails
            });
            return;
        }

        // Build finalArr with employees and their dependents
        let prevRecordNum = null;
        let currentEmployee = null;

        for (let i = 0; i < getData.length; i++) {
            const row = getData[i];
            const relationship = this.normalizeStr(row.relationship);
            if (relationship === "Employee" && row.record) {
                // Save previous employee if exists
                if (currentEmployee) {
                    if (currentEmployee.state !== undefined && currentEmployee.state) {
                        this.state.finalArr.push(currentEmployee);
                    } else {
                        this.state.validationArr.push({
                            record: currentEmployee.record, 
                            relationship: currentEmployee.relationship, 
                            msg: `We're sorry. At this time, we are not offering the Universal HealthShare program in this zip code`
                        })
                    }
                }

                // Start new employee record
                currentEmployee = {
                    record: row.record,
                    relationship: row.relationship,
                    firstName: row.firstName || "",
                    lastName: row.lastName || "",
                    dob: row.dob,
                    age: row.age,
                    gender: row.gender,
                    zipCode: row.zipCode,
                    email: row.email ? row.email.toLowerCase() : null,
                    phone: row.phone ? String(row.phone).replace(/\D/g, '') : "",
                    state: row.state || "",
                    city: row.city || "",
                    country: row.country || "",
                    dependentList: []
                };
                prevRecordNum = row.record;

            } else if ((relationship === "Spouse" || relationship === "Child") && prevRecordNum) {
                // Add as dependent to current employee
                if (currentEmployee) {
                    const dependent = {
                        record: prevRecordNum,
                        relationship: row.relationship,
                        firstName: row.firstName || "",
                        lastName: row.lastName || "",
                        dob: row.dob,
                        age: row.age,
                        gender: row.gender,
                        zipCode: row.zipCode || currentEmployee.zipCode,
                        email: row.email ? row.email.toLowerCase() : null,
                        phone: row.phone ? String(row.phone).replace(/\D/g, '') : "",
                        state: row.state || currentEmployee.state,
                        city: row.city || currentEmployee.city,
                        country: row.country || currentEmployee.country
                    };
                    currentEmployee.dependentList.push(dependent);
                }
            }
        }

        // Don't forget to push the last employee
        if (currentEmployee) {
            if (currentEmployee.state !== undefined && currentEmployee.state) {
                this.state.finalArr.push(currentEmployee);
            } else {
                this.state.validationArr.push({
                    record: currentEmployee.record, 
                    relationship: currentEmployee.relationship, 
                    msg: `We're sorry. At this time, we are not offering the Universal HealthShare program in this zip code`
                })
            }
        }

        console.log("Final Array with Dependents:", this.state.finalArr);

        if (this.state.validationArr.length > 0) {
            this.setState({
                validationExcelModal: true,
                excelValidation: true,
                fileNameModal: false,
                loaderShow: false
            })
        } else {
            this.setState({
                fileNameModal: true,
                loaderShow: false
            })
        }
    }
}

uploadButtonClick =()=>{
    this.setState({loaderShow:true,invalidMessage:false})

        let USER_DATA = JSON.parse(sessionStorage.getItem('USER_DATA'));
    
    if (this.state.finalArr && this.state.finalArr.length > 0) {
        const cc = (Intl.DateTimeFormat().resolvedOptions().timeZone == "Asia/Calcutta") ? "+91" : "+1";
        this.state.finalArr = this.state.finalArr.map(rec => {
            if (rec.phone) {
                const last10 = this.getLast10(rec.phone);
                rec.phone = cc + last10;
            }
            if (!rec.zipCode) {
                rec.zipCode = "";
            }
            return rec;
        });
    }

    let dataUploadObj = {
        "empid": this.state.empid,
        "clientId": USER_DATA.clientId,
        "brokerId": USER_DATA.agentId,
        "associationId": USER_DATA.associationId,
        "employeeDtoList": this.state.finalArr,
       
    }
    console.log("=======dataUploadObj====");
    console.log(dataUploadObj);
    console.log(this.state.finalArr);

    axios.post(configurations.baseUrl + '/enrollment/verifyUploadedData', dataUploadObj)
    .then(response => {
        if (response.data.code === 200) {
            // if(response.data.response && (response.data.response.existingEmail && response.data.response.existingEmail.length > 0 || response.data.response.existingRecord && response.data.response.existingRecord.length > 0) ){
            //         console.log("===== RESPONSE existingEmail ======", response.data.response);
                 
            // }else{
                axios.post(configurations.baseUrl + '/enrollment/uploadEmployee', dataUploadObj)
                   .then(response => {
                      if (response) {
                          console.log("=====uploadEmployee RESPONSE======", response);
                          this.setState({uploadExcelModal:false,
                            uploadFileName:'',
                            fileNameModal:false,
                            validationExcelModal:true,
                            successUpload:true,
                            loaderShow:false},()=>this.getUserData(this.state.empid))
                      }

          })

         // }
            

        }
        if(response.data.code === 202){
            this.setState({
                validationExcelModal:true,
                successUpload:false,
                inValidRecordData:response.data.response.existingRecord,
                errMsg:"An employee with the same record number already exists",     //"Existing record number",
                duplicateEmail:false,
                loaderShow:false    
            })
        }
        if(response.data.code === 204){
            //Existing email and record number"
            this.setState({
                validationExcelModal:true,
                successUpload:false,
                inValidRecordData:response.data.response.existingRecord,
                errMsg:"An employee with the same email address and record number already exists " ,//"Existing email and record number",
                loaderShow:false
            })


        }
        if(response.data.code === 206){
            this.setState({validationExcelModal:true,
                successUpload:false,
                inValidRecordData:response.data.response.existingRecord,
                duplicateEmail:true,
                errMsg:"An employee with the same email address already exists " ,//"Existing email",
                loaderShow:false
            })

        }
        // uncomment before deploy 500 code
        // if(response.data.code === 500){
        //     this.setState({
        //         loaderShow: false,
        //         showCommonErrorModal: true,
        //     })

        // }


        // else {
        //     this.setState({
        //         loaderShow: false,
        //         msgModal: true,
        //         errMsg: "Internal server error",
        //         code: 500
        //     });
        // }
        
        

        


        /* if(response.data.response && response.data.response.length>0){
            this.setState({validationExcelModal:true,successUpload:false,inValidData:response.data.response,loaderShow:false})
        }else{
              axios.post(configurations.baseUrl + '/enrollment/uploadEmployee', dataObj)
                 .then(response => {
                    if (response) {
                        this.setState({uploadExcelModal:false,uploadFileName:'',fileNameModal:false,validationExcelModal:true,successUpload:true,loaderShow:false},()=>this.getUserData(this.state.empid))
                    }

        })

        } */


    })
    .catch(error => {
        console.log(error);
        console.log(error.response);
        // if (error.response.status === 500) {                    
            this.setState({
                loaderShow: false,
                // showCommonErrorModal: true,
            });
        // }
    });


}

    invalidOk=()=>{
        this.setState({loaderShow:true})
        let USER_DATA = JSON.parse(sessionStorage.getItem('USER_DATA'));

        let dataObj = {
            "empid": this.state.empid,
            "clientId": USER_DATA.clientId,
            "brokerId": USER_DATA.agentId,
            "associationId": USER_DATA.associationId,
            "employeeDtoList": this.state.finalArr,
        }

        axios.post(configurations.baseUrl + '/enrollment/uploadEmployee', dataObj)
                         .then(response => {
                            if (response) {
                                this.setState({
                                    //validationExcelModal: false,
                                    uploadExcelModal:false,
                                    uploadFileName:'',
                                    fileNameModal:false,
                                    successUpload:true
                                },()=>this.getUserData(this.state.empid))
                            }

                })
                .catch(error => {
                    console.log(error);
                    console.log(error.response);
                    // if (error.response.status === 500) {                    
                        this.setState({
                            loaderShow: false,
                            // showCommonErrorModal: true,
                        });
                    // }
                });

       
    }

    // ------------------ end  file upload -----------------------------

    getUserData = (empid) => {
        if (empid) {
            formData.set("columns[7].search.value", empid);
        } else {
            formData.set("columns[7].search.value", 'NULL');
        }
        formData.set("start", "0");
        formData.set("length", this.state.rowsPerPage.toString());
        formData.set("columns[4].search.value","");
        formData.set("columns[1].search.value", "");
        formData.set("columns[2].search.value", "");
        formData.set("columns[3].search.value", "");
        formData.set("columns[6].search.value", "");
        formData.set("columns[10].search.value", "");
        this.applyEnrollmentFilter();
        fetch(this.getUserByAgentUrl(false), requestOptions)
            .then(response => response.json())
            .then(data => {
                if (data.response && data.response.data) {
                    console.log("getUserData====",data.response.data)
                    this.setState({
                        data: data.response.data,
                        count: data.response.recordsFiltered,
                        createdDate: data.response.createdDate,
                        searchText:'',
                        statusValue:'',
                        targetDate:null,
                        loaderShow: false,
                        circleloaderShow: false
                    },()=>{
                        this.downloadProspectData();
                        // this.state.data.map(val=>{
                        //     this.getUserStatus(val.id);	
                        // })
                        
                    });
                   // ,()=>this.downloadProspectData()
                }

            })
            .catch(error => {
                console.log(error);
                console.log(error.response);
                // if (error.response.status === 500) {                    
                    this.setState({
                        loaderShow: false,
                        circleloaderShow: false,
                        // showCommonErrorModal: true,
                    });
                // }
            });
    }




    getMuiThemeTran = () => createMuiTheme({
        overrides: {
            MUIDataTable: {
                root: {
                    backgroundColor: "#FF000"
                },
                paper: {
                    boxShadow: "none"
                }
            },

            MuiTableRow: {
                root: {
                    '&$selected': {
                        backgroundColor: '#ebf2ff'
                    }
                }
            },
        }
    })

    checkVal1(flag) {
        if (flag === 'ENCODING') {
            if (this.state.cid !== '' && this.state.bid !== '' && this.state.aid !== '' && this.state.baseUrl !== '') {
                this.setState({ genrate: false })
            } else {
                this.setState({ genrate: true })
            }
        } else if (flag === 'USER') {
            if (this.state.fname !== '' && this.state.lname !== '' && this.state.email !== '' && this.state.phone !== '' && this.state.phone.length == 10) {
                this.setState({ userValid: false })
            } else {
                this.setState({ userValid: true })
            }
        }

    }

    checkVal() {
        // this.state.email !== '' && && this.state.phone !== ''
        if(sessionStorage.getItem('EMPLOYER_FLOW') === "YES"){
            if ( this.state.fname !== '' && this.state.lname !== '') {
                this.setState({ userValid: false })
            } else {
                this.setState({ userValid: true })
            }
        }else{
            if ( this.state.fname !== '' && this.state.lname !== '' && this.state.email !== ''&& this.state.phone !== '' && this.state.phone.length == 17) {
                if(this.state.prefixSuffix.prefix === false || this.state.prefixSuffix.suffix === false || this.state.prefixSuffix.middleName === false ){
                    this.setState({ userValid: true })
                }else{
                    this.setState({ userValid: false })
                }
            } else {
                this.setState({ userValid: true })
            }
        }
       
    }





    handleClose = () => {
        this.setState({ open: !this.state.open, anchorEl: null })
    };
    getUserStatus =(id)=>{
        this.setState({
            userTerminated :true,
            // loaderShow: true
        })
        axios.get(process.env.REACT_APP_BASE_URL + '/enrollment/getViewDetails/' + id)
            .then(response => {
                if (response.data.code === 200) {    
                    // if(id == 1638867778513 || id == '1638867778513'){
                    //  console.log("status===",response.data.response.status,id)  

                    // }              
                        if (response.data.response.status === 'TE') {
                            
                            this.setState({
                                userTerminated :true,
                                loaderShow: false
                            },()=>console.log("this.state.userterminated===",this.state.userTerminated))
                        } else {
                            this.setState({
                                userTerminated :false,
                                loaderShow: false
                            })
                        }
                    }else{
                        this.setState({
                            userTerminated :false,
                            loaderShow: false
                        })
                    }
                    
    })
}
    selectMenu = async(index, dataIndex, option, e) => {
        this.setState({
            loaderShow: true
        });

        if (process.env.REACT_APP_PORTAL === 'employer') {
            const row = this.state.data && this.state.data[dataIndex];
            if (!row) {
                this.setState({ loaderShow: false, circleloaderShow: false });
                return;
            }
            if (option === 'View Details') {
                this.openMemberDetailsPlugin(row);
                return;
            }
            if (option === 'Delete') {
                this.setState({
                    loaderShow: false,
                    deleteModal: true,
                    delEmail: row.email,
                    delById: row.fabricId || row.id,
                    userName: `${row.firstName || ''} ${row.lastName || ''}`.trim(),
                });
                return;
            }
            this.setState({ loaderShow: false, circleloaderShow: false });
            return;
        }
      
        // Members tab has its own action menu (View Details / Change Dependents / Change Add-Ons / Re-assign Agent).
        // The legacy `index`-based branching below is for Prospects/Employees and doesn't line up with Members options.
        if (this.props.enrollmentFilter === "members") {
            const row = this.state.data && this.state.data[dataIndex] ? this.state.data[dataIndex] : null;
            if (!row) {
                this.setState({ loaderShow: false, circleloaderShow: false });
                return;
            }

            if (option === "Re-assign Agent") {
                const selectedId = row.fabricId || row.id;
                this.setState({
                    loaderShow: false,
                    circleloaderShow: false,
                    selectedMemberId: selectedId,
                    prospectFullName: `${row.memberFirstName || row.firstName || ""} ${row.memberLastName || row.lastName || ""}`.trim(),
                });
                this.getAllAgents(selectedId);
                return;
            }

            if (option === "View Details") {
                // Keep same behavior as original members tab
                this.openMemberDetailsPlugin(row);
                return;
            }

            // Keep original members-tab behavior for these actions: route through enrollment app
            // via encrypted URL (NOT the member details plugin).
            if (option === "Change Dependents" || option === "Change Add-Ons") {
                const viewDetailsId = row.fabricId || row.id || row.memberId;

                await axios.get(process.env.REACT_APP_BASE_URL + '/enrollment/getViewDetails/' + viewDetailsId)
                    .then(response => {
                        if (response.data.code === 200) {
                            if (Programs?.includes(response.data.response.planName) && this.state.data[dataIndex].enrollFlag) {
                                this.setState({ isTransitioned: true, loaderShow: false })
                                return;
                            } else {
                                const windowReference = window.open();
                                const basePayload = {
                                    clientId: this.props.clientName,
                                    channelName: this.props.clientName,
                                    associationId: this.props.associationId,
                                    brokerId: this.props.agentId,
                                    isAgent: true,
                                    index,
                                    empid: this.state.empid,
                                    // Keep memberId consistent with View Details id
                                    memberId: viewDetailsId,
                                    reEnrolledByAgent: true,
                                };

                                // Keep exact legacy keys/flags per action:
                                // - Change Dependents => isHouseholdUpdate: true
                                // - Change Add-Ons   => isSelectProgram: true
                                const actionFlags =
                                    option === "Change Dependents"
                                        ? { isHouseholdUpdate: true }
                                        : { isSelectProgram: true };

                                const openWithEncryptedState = (encryptObj) => {
                                    axios
                                        .post(configurations.baseUrl + '/encrypt/encryptData', encryptObj)
                                        .then((response) => {
                                            const url = configurations.enrollmentURL + '/login#state=' + response.data.response;
                                            windowReference.location = url;
                                            this.setState({ loaderShow: false, circleloaderShow: false });
                                        })
                                        .catch((error) => {
                                            console.log(error);
                                            console.log(error.response);
                                            this.setState({ loaderShow: false, circleloaderShow: false });
                                            try { windowReference.close(); } catch (e) { }
                                        });
                                };

                                // Ensure we always pass the same values as the legacy/old payload:
                                // subID + user_subId were sometimes missing from Fabric list response.
                                if (!row.subId || !row.email) {
                                    axios
                                        .get(process.env.REACT_APP_BASE_URL + '/enrollment/getViewDetails/' + viewDetailsId)
                                        .then((resp) => {
                                            const details = resp?.data?.response || {};
                                            const resolvedSubId = row.subId || details.subID || details.subId || '';
                                            const resolvedEmail = row.email || details.email || details.user_subId || '';
                                            openWithEncryptedState({
                                                ...basePayload,
                                                ...actionFlags,
                                                subID: resolvedSubId,
                                                user_subId: resolvedEmail,
                                            });
                                        })
                                        .catch(() => {
                                            // fallback with whatever we have
                                            openWithEncryptedState({
                                                ...basePayload,
                                                ...actionFlags,
                                                subID: row.subId || '',
                                                user_subId: row.email || '',
                                            });
                                        });
                                } else {
                                    openWithEncryptedState({
                                        ...basePayload,
                                        ...actionFlags,
                                        subID: row.subId,
                                        user_subId: row.email || "",
                                    });
                                }
                                return;
                            }
                        }
                    })
            }

            this.setState({ loaderShow: false, circleloaderShow: false });
            return;
        }
      
        let obj = {
            "clientId": this.props.clientName,
            "channelName": this.props.clientName,
            "associationId": this.props.associationId,
            "brokerId": this.props.agentId,
            "isAgent": true,
            "user_subId": this.state.data[dataIndex].email,
            //"user_subId": null,
            "index": index,
            'empid': this.state.empid,
            "memberId": this.state.data[dataIndex].id,
            "subID":this.state.data[dataIndex].subId ,   //namita 26 april
            "reEnrolledByAgent" : false,
            
        };
        if(option == "Send Hipaa Auth"){
            console.log("Send Hipaa Auth", this.state.data[dataIndex].id)
            let obj={
                "memberId": this.state.data[dataIndex].id
            }
            let request = {
                "username": "maricopa",
                "password": "QPvcY0n#S1u"
            }
            axios.post(process.env.REACT_APP_csr_base_url + "login", request).then(data=>{
                let bearer = data['headers'].authorization
                var array = bearer.split("Bearer ")
                localStorage.setItem("bearerToken", array[1]);

                axios.post(process.env.REACT_APP_csr_base_url + "csrportal/idencryption", obj, {
                    headers: {
                        Authorization: bearer
                    }
                }).then((res)=>{
                    window.open(process.env.REACT_APP_HIPAA_Common_URL+`Hipaa?query=${encodeURIComponent(res.data)}&token=${array[1]}`)
                    this.setState({
                        loaderShow: false
                    });
                })
                
            })
            
            
        } else if (option === "Notes") {
            this.openMemberDetailsPlugin(this.state.data[dataIndex]);
        } else if (index === 3 && !this.state.data[dataIndex].enrollFlag) {  //Create Quick Quote
            let windowReference = window.open();
            axios.post(configurations.baseUrl + '/encrypt/encryptData', obj)
                .then(response => {
                    let url = configurations.enrollmentURL + '/quick_quote#state=' + response.data.response                    
                    /*window.open(url, '_blank');*/
                    windowReference.location = url;
                    this.setState({
                        loaderShow: false
                    });
                })
                .catch(error => {
                    console.log(error);
                    console.log(error.response);
                    // if (error.response.status === 500) {                    
                        this.setState({
                            loaderShow: false,
                            // showCommonErrorModal: true,
                        });
                    // }
                });
        } else if (index === 2 || (this.state.data[dataIndex].enrollFlag && index == 1) || (this.state.data[dataIndex].enrollFlag && index === 2)) {  //Edit Census
            // if (obj.user_subId == '' || obj.user_subId == null) {
            //     this.setState({
            //         loaderShow: false,
            //         missingModal: true,
            //         missingTitle: "Missing Data",
            //         errMsg: "The email address and phone number of the employee must be entered before you can proceed with Enrollment."
            //     });

            // } 
            axios.get(process.env.REACT_APP_BASE_URL + '/enrollment/getViewDetails/' + this.state.data[dataIndex].id)
                    .then(response => {
                        if (response.data.code === 200) {
                            if (Programs?.includes(response.data.response.planName) && this.state.data[dataIndex].enrollFlag) {
                                this.setState({ isTransitioned: true, loaderShow: false })
                            } else {
                            this.setState({loaderShow: false, })
                        let windowReference = window.open();
                        if(this.state.data[dataIndex].enrollFlag && index == 2){ // enrolled with change program
                                obj.isSelectProgram = true;
                                obj.reEnrolledByAgent = true;  
                            
                           
            }
            else if(this.state.data[dataIndex].enrollFlag && index == 1){// enrolled with edit census

                                // obj.isEditCensus = false;
                                obj.isHouseholdUpdate = true;
                                // obj.fromMember = false;
                                obj.reEnrolledByAgent = true;
            }else{                              // only edit census without enrolled
                obj.isEditCensus = true;
                // obj.fromMember = false;
            }

                axios.post(configurations.baseUrl + '/encrypt/encryptData', obj)
                    .then(response => {
                        let url = configurations.enrollmentURL + '/login#state=' + response.data.response                       
                        /*window.open(url, '_blank');*/
                        windowReference.location = url;
                        this.setState({
                            loaderShow: false
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        console.log(error.response);
                        // if (error.response.status === 500) {                    
                            this.setState({
                                loaderShow: false,
                                // showCommonErrorModal: true,
                            });
                        // }
                    });
                        }}
                        });

        } else if (index === 4 ) {  //Start/Resume Enroll
            let windowReference = window.open();           
                axios.post(configurations.baseUrl + '/encrypt/encryptData', obj)
                    .then(response => {
                        let url = configurations.enrollmentURL + '/login#state=' + response.data.response                        

                        /*window.open(url, '_blank');*/
                        windowReference.location = url;
                        this.setState({
                            loaderShow: false
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        console.log(error.response);
                        // if (error.response.status === 500) {                    
                            this.setState({
                                loaderShow: false,
                                // showCommonErrorModal: true,
                            });
                        // }
                    });

        } else if (index === 5) {  //Send Sign-Up Email
            if (this.state.data[dataIndex].nmiVaultId == null) {
                this.setState({
                    loaderShow: false,
                    missingModal: true,
                    missingTitle: "Message",
                    errMsg: "You must complete all prior steps in the enrollment flow before requesting authorization."
                });
            } else {
            if (obj.user_subId == '' || obj.user_subId == null ||
             this.state.data[dataIndex].phone == '' || 
             this.state.data[dataIndex].phone == null ||
             this.state.data[dataIndex].firstName  == '' || 
             this.state.data[dataIndex].firstName == null ||
             this.state.data[dataIndex].lastName  == '' || 
             this.state.data[dataIndex].lastName == null 

             ) {
                this.setState({
                    loaderShow: false,
                    missingModal: true,
                    missingTitle: "Missing Data",
                    errMsg: "The email address and phone number of the employee must be entered before you can proceed with Enrollment."
                });
            } else {
                if (true) {
                    this.setState({
                        loaderShow: false,
                        circleloaderShow : true
                    });

                    axios.get(process.env.REACT_APP_enrollment_base_url + '/setupfamily/getMemberBySubID/'+this.state.data[dataIndex].subId)
                    .then(response => {
                        if(response.data.response){
                            let data = JSON.parse(JSON.stringify(response.data.response));
                            this.setState({
                                inviteStatus : data.inviteStatus!=null ? moment(data.inviteStatus).format("DD MMM YYYY hh:mm a") : null,
                            },()=>{
                                if(this.state.inviteStatus ==null){
                                    axios.get(process.env.REACT_APP_enrollment_base_url+'/enrollment/registration/' + this.state.data[dataIndex].email + '/' + this.state.data[dataIndex].phone + '/email')
                                    .then(response => {
                                        if (response && response.data.code === 200) {
                                            this.setState({
                                                circleloaderShow: false,
                                                msgModal: true,
                                                errMsg: "Authorization mail sent successfully!",
                                            });
                                        } else if (response.data.code === 202) {
                                            this.setState({
                                                circleloaderShow: false,
                                                msgModal: true,
                                                errMsg: 'The authorization email has been sent to ' +'"'+ this.state.data[dataIndex].email +'"'+'. As the prospect has signed up earlier, for security reasons, they would be required to reset their password.',
                                            });
                                        } else if (response.data.code === 204) {
                                            this.setState({
                                                circleloaderShow: false,
                                                msgModal: true,
                                                errMsg: "The authorization email was RESENT!",
                                            });
                                        } else if (response.data.code === 409) {
                                            this.setState({
                                                circleloaderShow: false,
                                                msgModal: true,
                                                errMsg: "User already exists in the given User Pool.",
                                            });
                                        }else if (response.data.code === 500) {
                                            this.setState({
                                                circleloaderShow: false,
                                                msgModal: true,
                                                errMsg: "Oops! Something's not right. If you're still having trouble, call us on (800) 921-4505",
                                            });
                                        }
                                    })
                                    .catch(error => {
                                        console.log(error);
                                        this.setState({
                                            circleloaderShow: false,
                                            msgModal: true,
                                            errMsg: "Oops! Something's not right. If you're still having trouble, call us on (800) 921-4505",
                                        });
                                    });
                                }else{
                                    this.setState({
                                        circleloaderShow: false,
                                        msgModal: true,
                                        emailID:this.state.data[dataIndex].email,
                                        phoneNumber:this.state.data[dataIndex].phone,
                                        errMsg:`Authorization link was already sent on ${this.state.inviteStatus}. If you
                                        proceed to resend link, the prospect will not be able to
                                        sign-up with any previously sent links. \n Are you sure you want to proceed?`
                                    })
                                }
                            })
                        }})





                    // axios.get(configurations.baseUrl + '/agentlogin/inviteEmail/' + this.state.data[dataIndex].email)
                    //     .then(response => {
                    //         this.getUserData(this.state.empid);
                    //         if (response.data.code === 204) {
                    //             this.setState({
                    //                 loaderShow: false,
                    //                 msgModal: true,
                    //                 errMsg: "Invite email sent successfully!",
                    //                 code: 204
                    //             });
                    //         } else if (response.data.code === 202) {
                    //             this.setState({
                    //                 loaderShow: false,
                    //                 msgModal: true,
                    //                 errMsg: "The prospect has already signed-up and created an account. They can login to the enrollment app using the link below. If they need to reset their password, ask them to go to the login page and click on the Forgot your password? ",
                    //                 code: 202
                    //             });
                    //         } 
                    //         // else if (response.data.code === 500) {
                    //         //     this.setState({
                    //         //         loaderShow: false,
                    //         //         showCommonErrorModal:true
                    //         //     });
                    //         // }
                    //         else {
                    //             this.setState({
                    //                 loaderShow: false,
                    //                 msgModal: true,
                    //                 errMsg: "Internal server error",
                    //                 code: 500
                    //             });
                    //         }
                    //     })
                    //     .catch(error => {
                    //         console.log(error);
                    //         console.log(error.response);
                    //         // if (error.response.status === 500) {                    
                    //             this.setState({
                    //                 loaderShow: false,
                    //                 // showCommonErrorModal: true,
                    //             });
                    //         // }
                    //     });
                }
            }
        }

        } else if (index === 1) {
            this.setState({
                loaderShow: false,
                circleloaderShow: false,
            }); 
            let phone = '';
            let countryCode = '';
            if (this.state.data[dataIndex].phone) {
                if (this.state.data[dataIndex].phone.length === 13) {
                    countryCode = this.state.data[dataIndex].phone.substr(0, 3);
                    // phone = this.state.data[dataIndex].phone.substr(3);
                    phone = this.formatPhoneNumber(this.state.data[dataIndex].phone.substr(2));
                } else {
                    countryCode = this.state.data[dataIndex].phone.substr(0, 2);
                    // phone = this.state.data[dataIndex].phone.substr(2);
                    phone = this.formatPhoneNumber(this.state.data[dataIndex].phone);
                }


                this.setState({
                    editModal: true,
                    fname: this.state.data[dataIndex].firstName,
                    lname: this.state.data[dataIndex].lastName,
                    prefix:this.state.data[dataIndex].prefix,
                    suffix:this.state.data[dataIndex].suffix,
                    middleName:this.state.data[dataIndex].middleName,
                    email: this.state.data[dataIndex].email,
                    tempEmail: this.state.data[dataIndex].email,
                    id: this.state.data[dataIndex].id,
                    phone: phone,
                    circleloaderShow : false,
                    countryCode: countryCode
                });



            }else{
                //-- Safal Commented 17 Aug 2021
                // axios.get('https://ipapi.co/json/').then((response) => {
                //     if (response && response.data) {
                //         let data = response.data;
                //         countryCode = data.country_calling_code;

                //         this.setState({
                //             editModal: true,
                //             fname: this.state.data[dataIndex].firstName,
                //             lname: this.state.data[dataIndex].lastName,
                //             email: this.state.data[dataIndex].email,
                //             tempEmail: this.state.data[dataIndex].email,
                //             id: this.state.data[dataIndex].id,
                //             phone: phone,
                //             countryCode: countryCode
                //         });



                //     }
                // }).catch((error) => {
                //     console.log(error);
                // });
                this.setState({loaderShow: false, })
                this.setState({
                    editModal: true,
                    fname: this.state.data[dataIndex].firstName,
                    lname: this.state.data[dataIndex].lastName,
                    email: this.state.data[dataIndex].email,
                    prefix:this.state.data[dataIndex].prefix,
                    suffix:this.state.data[dataIndex].suffix,
                    middleName:this.state.data[dataIndex].middleName,
                    tempEmail: this.state.data[dataIndex].email,
                    id: this.state.data[dataIndex].id,
                    phone: phone,
                    countryCode: "+1"
                });
            }


            /* this.setState({
                editModal: true,
                fname: this.state.data[dataIndex].firstName,
                lname: this.state.data[dataIndex].lastName,
                email: this.state.data[dataIndex].email,
                id: this.state.data[dataIndex].id,
                phone: phone,
                countryCode: countryCode
            }); */


        } else if (index === 6) {  //Delete
            this.setState({ loaderShow: true })
            this.setState({
                loaderShow: false,
                deleteModal: true,
                delEmail: this.state.data[dataIndex].email,
                delById: this.state.data[dataIndex].id,
                userName: this.state.data[dataIndex].firstName + ' ' + this.state.data[dataIndex].lastName
            })

        } else if (index === 7 || (index === 3 && this.state.data[dataIndex].enrollFlag)) {  //Re-assign
            const selectedId = this.state.data[dataIndex].fabricId || this.state.data[dataIndex].id;
            this.setState({ 
                loaderShow: false,
                selectedMemberId: selectedId,
                prospectFullName :  this.state.data[dataIndex].firstName +" "+ this.state.data[dataIndex].lastName, 
            })
            this.getAllAgents(selectedId);
            

        }else if (index === 0 || this.state.data[dataIndex].enrollFlag) {   //View Details
            this.openMemberDetailsPlugin(this.state.data[dataIndex]);

            /*axios.get('https://ipapi.co/json/').then((response) => {
            if (response && response.data) {
                let data = response.data;
                this.setState({
                    countryCode: data.country_calling_code
                });
            }
            axios.get(configurations.baseUrl + '/agentlogin/getUser/' + this.state.data[dataIndex].email)
                    .then(response => {
                        this.setState({
                            loaderShow : false,
                            fname:response.data.response.firstName,
                            lname:response.data.response.lastName,
                            email:response.data.response.email,
                            phone:response.data.response.phone,
                            clientId:response.data.response.clientId,
                            brokerId:response.data.response.brokerId,
                            associationId:response.data.response.associationId
                        })
                    })
                })*/



        }
    }
    formatPhoneNumber = (phoneNumberString) => {
        var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          var intlCode = (match[1] ? '+1 ' : '');
          return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
        }
        return null;
      }

    fetchPluginToken = async () => {
        const tokenUserName = process.env.REACT_APP_AUTH_USERNAME;
        const tokenUserPassword = process.env.REACT_APP_AUTH_TOKEN_PASS;
        const loginUrl = process.env.REACT_APP_csr_base_url + 'login';

        const response = await axios.post(loginUrl, {
            username: tokenUserName,
            password: tokenUserPassword,
        });

        const authHeader = response?.headers?.authorization || "";
        const token = authHeader.startsWith("Bearer ") ? authHeader.split(" ")[1] : authHeader;

        if (!token) {
            throw new Error("Token not found in authorization header");
        }

        localStorage.setItem("bearerToken", token);
        return token;
    }

    openMemberDetailsPlugin = async (member, pluginType = "member_details") => {
        // Members (Fabric) returns both `id` and `memberId`. View Details should use `id` when available.
        const memberIdSource =
            member?.memberIdSource ||
            member?.member_id_source ||
            member?.fabricId ||
            member?.memberId ||
            member?.id;

        if (!memberIdSource) {
            this.setState({
                loaderShow: false,
                msgModal: true,
                errMsg: "Unable to open member details right now.",
            });
            return;
        }

        if (typeof window?.loadCommonPluginScreen === 'function') {
            // Always fetch a fresh bearer token on every View Details click so the plugin
            // never receives an expired/stale token.
            this.setState({ loaderShow: true });
            let token = "";
            try {
                token = await this.fetchPluginToken();
            } catch (error) {
                console.log("Unable to resolve plugin bearer token", error);
            }

            if (!token) {
                this.setState({
                    loaderShow: false,
                    msgModal: true,
                    errMsg: "Unable to generate token for member details.",
                });
                return;
            }

            const initiatedUser = member.email

            window.loadCommonPluginScreen(memberIdSource, {
                type: pluginType,
                userRole: "AGENT",
                source: "AGENCY",
                initiatedUser,
                token,
                ...(this.props.enrollmentFilter === "prospects" && { statusLabel: statusObject[member.completionStatus] }),
            });
            this.setState({ loaderShow: false });
            return;
        }

        this.setState({
            loaderShow: false,
            msgModal: true,
            errMsg: "Member details plugin is unavailable.",
        });
    }

sendAuthEmail=()=>{
    this.setState({circleloaderShow:true, msgModal:false})
    axios.get(process.env.REACT_APP_enrollment_base_url+'/enrollment/registration/' + this.state.emailID + '/' + this.state.phoneNumber + '/email')
    .then(response => {
        if (response && response.data.code === 200) {
            this.setState({
                circleloaderShow: false,
                msgModal: true,
                emailID:"",
                errMsg: "Authorization mail sent successfully!",
            });
        } else if (response.data.code === 202) {
            this.setState({
                circleloaderShow: false,
                msgModal: true,
                emailID:"",
                errMsg: 'The authorization email has been sent to ' +'"'+  this.state.emailID +'"'+'. As the prospect has signed up earlier, for security reasons, they would be required to reset their password.',
            });
        } else if (response.data.code === 204) {
            this.setState({
                circleloaderShow: false,
                msgModal: true,
                emailID:"",
                errMsg: "The authorization email was RESENT!",
            });
        } else if (response.data.code === 409) {
            this.setState({
                circleloaderShow: false,
                msgModal: true,
                emailID:"",
                errMsg: "User already exists in the given User Pool.",
            });
        }else if (response.data.code === 500) {
            this.setState({
                circleloaderShow: false,
                msgModal: true,
                emailID:"",
                errMsg: "Oops! Something's not right. If you're still having trouble, call us on (800) 921-4505",
            });
        }
    })
    .catch(error => {
        console.log(error);
        this.setState({
            circleloaderShow: false,
            msgModal: true,
            emailID:"",
            errMsg: "Oops! Something's not right. If you're still having trouble, call us on (800) 921-4505",
        });
    });
}
    getDateInUTC = (date, getInMillisecs) => {
        if (date) {
            let newDateTime = date + new Date(date).getTimezoneOffset() * 60 * 1000;
            if (getInMillisecs) {
                return newDateTime
            }
            return new Date(newDateTime)
        }
        return date
    }

    getUSerDetails = (id, email, flag) => {
        console.log("getUSerDetails====",id,email,flag)
      this.setState({loaderShow: false, })
        
        axios.get(process.env.REACT_APP_BASE_URL + '/enrollment/getViewDetails/' + id)
            .then(response => {
                if (response.data.code === 200) {
                    let obj = [];
                    let findLeadData = this.state.data.find(obj => obj.id === id)
                    this.setState({loaderShow: false, })
                        const userInfo = findLeadData.leadQualificationData

                    if (flag && response.data.response.flag) {
                        let paidThroughDate = response.data.response.benefits[0].premiumPaidDate && this.getDateInUTC(response.data.response.benefits[0].premiumPaidDate, true);
                        let newDatePaidThroughDate = 'NA';
                        if (paidThroughDate) {
                            newDatePaidThroughDate = moment(paidThroughDate).format('MMMM DD, YYYY');
                        }

                        let _userStatus = ''
                        if (response.data.response.status === 'TE') {
                            _userStatus = 'TERMINATED';
                        } else {
                            _userStatus = response.data.response.status;
                        }
                        

                        obj = [
                            {
                                key: 'Member ID',
                                value: response.data.response.memberId !=null  ? response.data.response.memberId :'NA' ,
                                type: 'STR'
                            },
                            {
                                key: 'Name',
                                value:`${response.data.response.prefix || ""} ${response.data.response.firstName || ""} ${response.data.response.middleName || ""} ${response.data.response.lastName || ""} ${response.data.response.suffix || ""}`,
                                type: 'STR'
                            },
                            {
                                key: 'Email',
                                value: response.data.response.email,
                                type: 'STR'
                            },
                            {
                                key: 'Phone',
                                value: response.data.response.phoneNo,
                                type: 'STR'
                            }, {
                                key: 'Address',
                                value: response.data.response.addressLine1,
                                type: 'STR'
                            }, {
                                key: 'City',
                                value: response.data.response.city,
                                type: 'STR'
                            }, {
                            }, {
                                key: 'State',
                                value: response.data.response.state,
                                type: 'STR'
                            }, {
                                key: 'Plan Purchased',
                                value: response.data.response.planName == "STX1" ? (<>ST<sub>x</sub>1</>) : response.data.response.planName == "STX2" ? (<>ST<sub>x</sub>2</>) : response.data.response.planName,
                                type: 'STR'
                            }, {
                                key: 'Active Date',
                                value: moment(response.data.response.benefits[0].benefitBegin).format('MMMM DD, YYYY'),
                                type: 'STR'
                            }, {
                                key: 'Paid through date',
                                value: newDatePaidThroughDate,
                                type: 'STR'
                            }, {
                                key: 'Status',
                                value: _userStatus,
                                type: 'STR'
                            }/*,{
                            key : 'Cost Of Program',
                            value : response.data.response.cost_of_program,
                            type : 'STR'
                        }*/, {
                                key: 'Names of dependents and relationship',
                                value: response.data.response.dependents,
                                type: 'ARR'
                            },
                            // {
                            //     key: 'Lead qualification data',
                            //     value:userInfo != null? userInfo:'NA',
                            //     type: 'STR'
                            // }
                        ];
                        this.setState({
                            viewUserData: obj,
                            circleloaderShow: false,
                            detailsData: { memberIdSource: response.data.response.memberIdSource, id: id, email: email, disableFlag: false, enrollFlag: flag }
                        });
                    } else {
                        obj = [
                            {
                                key: 'Name',
                                value: `${response.data.response.prefix || ""} ${response.data.response.firstName || ""} ${response.data.response.middleName || ""} ${response.data.response.lastName || ""} ${response.data.response.suffix || ""}`,
                                type: 'STR'
                            },
                            {
                                key: 'Email',
                                value: response.data.response.email,
                                type: 'STR'
                            },
                            {
                                key: 'Phone',
                                value: response.data.response.phone,
                                type: 'STR'
                            },
                            // {
                            //     key: 'Lead qualification data',
                            //     value:userInfo != null? userInfo:'NA',
                            //     type: 'STR'
                            // }
                        ];
                        this.setState({
                            viewUserData: obj,
                            circleloaderShow: false,
                            detailsData: { memberIdSource: response.data.response.memberIdSource, id: id, email: email, disableFlag: true, enrollFlag: flag }
                        });
                    }
                }
                // else if(response.data.code === 500){
                //     this.setState({
                //         loaderShow: false,
                //         showCommonErrorModal: true,
                //     });
                // }
                
                else {
                    this.setState({
                        viewUserData: [],
                        circleloaderShow: false,
                        detailsData: { memberIdSource: null, id: id, email: email, disableFlag: true, enrollFlag: flag }
                    }, () => {
                        console.log('============ detailsData ========');
                        console.log(this.state.detailsData);
                    });
                }
            })
            .catch(error => {
                console.log(error);
                console.log(error.response);
                // if (error.response.status === 500) {
                    this.setState({circleloaderShow: false})   
                    this.setState({
                        circleloaderShow: false,
                        // showCommonErrorModal: true,
                    });
                // }
            });

    }

    getTransactionDetails = (memberIdSource) => {
        axios.get(process.env.REACT_APP_transaction_base_url + 'transaction/transactionHistory?searchKey=source&searchValue=' + memberIdSource)
            .then(response => {
                this.setState({           
                    circleloaderShow: false,
                })
                if (response.data.code === 200) {
                    this.setState({
                        transactionData: response.data.response,
                        circleloaderShow: false,
                        transCount: response.data.response.recordsFiltered
                    })
                }
                // if(response.data.code === 500){
                //     this.setState({
                //         loaderShow: false,
                //         showCommonErrorModal: true
                //     })
                // }
               
            })
            .catch(error => {
                console.log(error);
                console.log(error.response);
                // if (error.response.status === 500) {
                    
                    this.setState({
                        loaderShow: false,
                        // showCommonErrorModal: true,
                    });
                // }
            });
    }

    getNotes = (memberIdSource) => {
        axios.get(`${process.env.REACT_APP_BASE_URL}/enrollment/member-notes/${memberIdSource}`)
        .then(res => {
            this.setState({           
                circleloaderShow: false,
            })
            if (res.data.response) {
                this.setState({ loaderShow: false, notes: res.data.response, notesError: "" }, () => {
                    this.scrollToBottom();
                })
            } else {
                this.setState({ loaderShow: false, notesError: res.data.message, notes: [] })
            }
        })
    }

    getReassignHistory = (memberIdSource) =>{
        axios.get(process.env.REACT_APP_BASE_URL + "/agentlogin/reassignListByMember/1/10/"+ memberIdSource)
                .then((response) => {
                    this.setState({           
                        circleloaderShow: false,
                    })
                    console.log("======== getReassignHistory ========");
                    console.log(response);
                    console.log(response.data.response.reasignData);
                    if(response && response.data.response.reasignData.length > 0){
                        this.setState({
                            reassignHistoryData: response.data.response.reasignData,
                            loaderShow: false,
                            reassignHistoryCount: response.data.response.reasignData ? response.data.response.reasignData.length : 0
                        })
                    }else {
                        this.setState({
                            reassignHistoryData: [],
                            loaderShow: false,
                            reassignHistoryCount: 0
                        })
                    }
                })
                .catch(error => {
                    console.log(error);
                    console.log(error.response);
                    // if (error.response.status === 500) {
                        this.setState({           
                            circleloaderShow: false,
                        })
                        this.setState({
                            loaderShow: false,
                            // showCommonErrorModal: true,
                        });
                    // }
                });
    }


    addUserModal = () => {
        //-- Safal Commented 17 Aug 2021
        // axios.get('https://ipapi.co/json/').then((response) => {
        //     if (response && response.data) {
        //         let data = response.data;
        //         this.setState({
        //             countryCode: data.country_calling_code
        //         });
        //     }
        // }).catch((error) => {
        //     console.log(error);
        // });
        this.setState({
            addUsermodalShow: true,
            fname: '',
            lname: '',
            phone: '',
            middleName:'',
            prefix:'',
            suffix:'',
            email: '',
            refresh: false,
            editModal: false,
        }, () => this.checkVal1('USER'));
    }

    setUserValue = (value, isValid, { name }) => {
        const fieldMap = {
            'firstname': 'fname',
            'prefix': 'prefix',
            'middleName': 'middleName',
            'lastname': 'lname',
            'suffix': 'suffix',
            'email': 'email',
            'phone': 'phone'
        };
    
        if (name === 'prefix' || name === 'suffix' || name === 'middleName') {
            this.state.prefixSuffix[name] = isValid;
            this.state[name] = isValid ? value.toUpperCase() : "";
        } else if (name === 'email' || name === 'phone') {
            this.state[fieldMap[name]] = isValid ? value : "";
        } else if (fieldMap[name]) {
            this.state[fieldMap[name]] = isValid ? value.toUpperCase() : "";
        }
    
        this.checkVal();
    };
    
    addUser = () => {
        let newPhone = this.state.phone.replace(/[^a-zA-Z0-9]/g, '');
        this.setState({
            loaderShow: true,
            errModal: false,
        });
        let obj={}
        if(sessionStorage.getItem('EMPLOYER_FLOW') === "YES"){

            obj = {
                "firstName": this.state.fname.trim(),
                "lastName": this.state.lname.trim(),
                "phone":this.state.phone? this.state.countryCode + newPhone.substr(1) :null,
                "email": this.state.email?this.state.email:null,
                "clientId": this.props.clientId,
                "associationId": this.props.associationId,
                "brokerId": this.props.agentId,
                empid: this.state.empid,
                "prefix": this.state.prefix,
                "suffix": this.state.suffix,
                "middleName": this.state.middleName,
            };

            if(this.state.email !== ''){

                axios.get(`${configurations.baseUrl}/agentlogin/validateEmail/${this.state.email}/${this.props.agentId}?editFlag=${false}`)
                .then((response) => {
                    console.log("validateemail===", response)
                    if (response.data.code == 200) {
                        this.addUserObj(obj, false);
                    } 
                    // else if(response.data.code == 500){
                    //     this.setState({
                    //         loaderShow: false,
                    //         showCommonErrorModal: true,
                    //     });
                    // }
                    else {
                        this.setState({
                            loaderShow: false,
                            msgModal: true,
                            errMsg: response.data.message,
                            refresh: true
                        });
                        if (response.data.code == 202) {
                            this.setState({
                                errModal: true,
                                userObject: obj
                            })
                        }
                    }
                })
                .catch(error => {
                    console.log(error);
                    console.log(error.response);
                    // if (error.response.status === 500) {
                        
                        this.setState({
                            loaderShow: false,
                            // showCommonErrorModal: true,
                        });
                    // }
                });
                
            }else{
                this.addUserObj(obj, false);
            }
            

        }else{ // For Household
            obj = {
                "firstName": this.state.fname.trim(),
                "lastName": this.state.lname.trim(),
                "phone":this.state.countryCode + newPhone.substr(1),
                "email": this.state.email,
                "clientId": this.props.clientId,
                "associationId": this.props.associationId,
                "brokerId": this.props.agentId,
                empid: this.state.empid,
                "prefix": this.state.prefix,
                "suffix": this.state.suffix,
                "middleName": this.state.middleName,
            };

            if(this.state.email !== ''){

                axios.get(`${configurations.baseUrl}/agentlogin/validateEmail/${this.state.email}/${this.props.agentId}?editFlag=${false}`)
                .then((response) => {
                    console.log("validateemail===", response)
                    if (response.data.code == 200) {
                        this.addUserObj(obj, false);
                    }
                    // else if(response.data.code == 500){
                    //     this.setState({
                    //         loaderShow: false,
                    //         showCommonErrorModal: true,
                    //     });
                    // }                   
                    else {
                        this.setState({
                            loaderShow: false,
                            msgModal: true,
                            errMsg: response.data.message,
                            refresh: true
                        });
                        if (response.data.code == 202) {
                            this.setState({
                                errModal: true,
                                userObject: obj
                            })
                        }
                    }
                })
                .catch(error => {
                    console.log(error);
                    console.log(error.response);
                    // if (error.response.status === 500) {
                        
                        this.setState({
                            loaderShow: false,
                            // showCommonErrorModal: true,
                        });
                    // }
                });
                
            }else{
                this.addUserObj(obj, false);
            }


        }
        
       
        
    }

    addUserObj = (obj, confirmationFlag) => {
        obj = {...obj, email: obj.email.toLowerCase()}
        this.setState({
            loaderShow: true,
            msgModal: false,
            addUsermodalShow: false,
            errModal: false,
        });
        axios.post(configurations.baseUrl + '/agentlogin/addUser?confirmationFlag=' + confirmationFlag, JSON.parse(JSON.stringify(obj)))
            .then(response => {
                this.getUserData(this.state.empid);
                if (this.props.defaultEmpid && this.props.defaultEmpid !== this.state.empid) {
                    let evt = new CustomEvent('REFRESH', { detail: this.state.empid });
                    window.dispatchEvent(evt);
                }
                if (response.data.code === 200) {
                    this.setState({
                        loaderShow: false,
                        msgModal: true,
                        errMsg: sessionStorage.getItem('EMPLOYER_FLOW') === "YES"? "Employee added successfully!" :"Prospect added successfully!",
                        refresh: true,
                        errModal: false,
                    });
                     if (this.props.enrollmentFilter === "members" && this.props.onProspectAdded) {
                        this.props.onProspectAdded();
                    }
                } else if (response.data.code === 202) {
                    this.setState({
                        loaderShow: false,
                        msgModal: true,
                        errMsg: sessionStorage.getItem('EMPLOYER_FLOW') === "YES"? "Employee already registered with this Email ID!":"Prospect already registered!",
                        refresh: true,
                        errModal: false,
                    });
                } 
                // else if (response.data.code === 500) {
                //     this.setState({
                //         loaderShow: false,
                //         showCommonErrorModal: true,
                //     });
                // }
                else {
                    this.setState({
                        loaderShow: false,
                        msgModal: true,
                        errMsg: "Internal server error",
                        refresh: true,
                        errModal: false,
                    })
                }
            })
            .catch(error => {
                console.log(error);
                console.log(error.response);
                // if (error.response.status === 500) {
                    
                    this.setState({
                        loaderShow: false,
                        msgModal: true,
                        errMsg: "An error occurred while adding the user. Please try again.",
                        errModal: false,
                    });
                // }
            });
    }

    // Download Prospect data------------------------
    downloadProspectData = () =>{
       if(this.state.empid)
        axios.get(configurations.baseUrl + '/enrollment/getMemberForDownload/' + this.props.agentId +'/' + this.state.empid )
            .then(data => {

                if (data.data && data.data.response) {
                    this.setState({
                        prospectObj: data.data.response,
                        // count: data.response.recordsFiltered,
                        // createdDate: data.response.createdDate,
                        loaderShow: false
                    },()=>{
                        for (var i = 0; i <= this.state.prospectObj.length; i++) {
                            if (this.state.prospectObj && this.state.prospectObj[i]) {
                                this.setState({ downloadDataFlag : true})
                                var result = this.state.prospectObj.map(function (el) {
                                    var o = Object.assign({}, el);
                                    
                                    o.prospectFname = '';
                                    o.prospectLname='';
                                    o.relationship = '';
                                    o.dob = '';
                                    o.birthGender = '';
                                    o.zipcode='';
                                    o.Age='';
                                    o.emailID='';
                                    o.recordNo='';
                                   
                                    return o;
                                })

                                this.state.prospectObj = result


                            }

                          
                            
                        }
                        
                        
                        this.state.prospectObj && this.state.prospectObj.map((val,index)=>{

                            // normalize parent's phone to last 10 digits; use empty string if none
                            const parentPhoneLast10 = this.getLast10(this.state.prospectObj[index].phone);
                            this.state.prospectObj[index].phone = parentPhoneLast10 ? parentPhoneLast10 : '';

                            if (this.state.prospectObj[index].record == '' ) {
                                this.state.prospectObj[index].recordNo =null;

                            } else {
                                this.state.prospectObj[index].recordNo = this.state.prospectObj[index].record ;

                            }

                            if (this.state.prospectObj[index].relationCode == 'SELF' ) {
                                this.state.prospectObj[index].relationship = 'Employee';

                            } else {
                                this.state.prospectObj[index].relationship = null;

                            }

                            if (this.state.prospectObj[index].firstName == '') {
                                this.state.prospectObj[index].prospectFname = 'NA';

                            } else {
                                this.state.prospectObj[index].prospectFname = this.state.prospectObj[index].firstName;

                            }

                            if (this.state.prospectObj[index].lastName == '') {
                                this.state.prospectObj[index].prospectFname = 'NA';

                            } else {
                                this.state.prospectObj[index].prospectLname = this.state.prospectObj[index].lastName;

                            }

                            if (this.state.prospectObj[index].birthDate == '' || this.state.prospectObj[index].birthDate == null) {
                                this.state.prospectObj[index].dob = 'NA';

                            } else {
                                this.state.prospectObj[index].dob = this.state.prospectObj[index].birthDate;

                            }
                            if (this.state.prospectObj[index].age == '' || this.state.prospectObj[index].age == null) {
                                this.state.prospectObj[index].Age = 'NA';

                            } else {
                                this.state.prospectObj[index].Age = this.state.prospectObj[index].age;

                            }
                            if (this.state.prospectObj[index].genderCode == 'MALE') {
                                this.state.prospectObj[index].birthGender = 'M';

                            } else if (this.state.prospectObj[index].genderCode == 'FEMALE'){
                                this.state.prospectObj[index].birthGender = 'F';

                            }else{
                                this.state.prospectObj[index].birthGender = 'NA';
                            }
                            if (this.state.prospectObj[index].postalCode == '' || this.state.prospectObj[index].postalCode == null) {
                                this.state.prospectObj[index].zipcode = 'NA';

                            } else {
                                this.state.prospectObj[index].zipcode = this.state.prospectObj[index].postalCode;

                            }
                            if (this.state.prospectObj[index].email == '') {
                                this.state.prospectObj[index].emailID = 'NA';

                            } else {
                                this.state.prospectObj[index].emailID = this.state.prospectObj[index].email;

                            }
                            if (this.state.prospectObj[index].phone == '') {
                                this.state.prospectObj[index].phone = 'NA';

                            } else {
                                this.state.prospectObj[index].phone = this.state.prospectObj[index].phone;

                            }

                             this.state.downloadFinalArr.push(this.state.prospectObj[index])

                            // *****************************************************
                            //  Dependent data start here **************************

                            if(this.state.prospectObj[index].dependentDtoList && this.state.prospectObj[index].dependentDtoList.length > 0){

                              
                                let dependentArray=this.state.prospectObj[index].dependentDtoList;


                               dependentArray.map((val,index)=>{

                                    

                                val.recordNo = null ;


                                if(val.relationshipCode == 'SPOUSE'){
                                    dependentArray[index].relationship = 'Spouse';
                                    
                                        dependentArray[index].zipcode = this.state.prospectObj[index].postalCode;
        
                                    
    
                                }
                                 if(val.relationshipCode == 'CHILD'){
                                    dependentArray[index].relationship = 'Child';
                                  
                                        dependentArray[index].zipcode = index > 0 ? this.state.prospectObj[index-1]?.postalCode : this.state.prospectObj[index]?.postalCode;
        
                                    
                                }
                                
                                
                                if (val.firstName == '') {
                                    dependentArray[index].prospectFname = 'NA';
    
                                } else {
                                    dependentArray[index].prospectFname = dependentArray[index].firstName;
    
                                }
    
                                if (val.lastName == '') {
                                    dependentArray[index].prospectFname = 'NA';
    
                                } else {
                                    dependentArray[index].prospectLname = dependentArray[index].lastName;
    
                                }
    
                                if (val.birthDate == '' || val.birthDate == null) {
                                    dependentArray[index].dob = 'NA';
    
                                } else {
                                    dependentArray[index].dob = dependentArray[index].birthDate;
    
                                }
                                if (val.age == '' || val.age == null) {
                                    dependentArray[index].Age= 'NA';
    
                                } else if (val.age == 0 ) {
                                    dependentArray[index].Age = '0';
    
                                }else {
                                    dependentArray[index].Age = dependentArray[index].age;
    
                                }
                                if (val.gender == 'MALE') {
                                    dependentArray[index].birthGender = 'M';
    
                                } else if (val.gender == 'FEMALE'){
                                    dependentArray[index].birthGender = 'F';
    
                                }else{
                                    dependentArray[index].birthGender = '';
                                }

                                this.state.downloadFinalArr.push(dependentArray[index])

                                })
                                

                            }

                           })

                      
                    })
                 //*************************************************************************** */ 
                // ********************** Download template code start here************************


                    let tempData=this.state.downloadFinalArr

                    
                    for(var i=0; i<tempData.length; i++){
                        let tempObj ={
                            "Record #":tempData[i].recordNo == null || tempData[i].recordNo == '' ?  null :tempData[i].recordNo,
                            "Relationship":tempData[i].relationship !=null || tempData[i].relationship !='' ? tempData[i].relationship : "NA",
                            "First Name":tempData[i].prospectFname !=null || tempData[i].prospectFname != ''? tempData[i].prospectFname :'NA',
                            "Last Name":tempData[i].prospectLname,
                            "Date of Birth":tempData[i].dob,
                            "Age":tempData[i].Age,
                            "Birth Gender":tempData[i].birthGender,
                            "Zip":tempData[i].zipcode,
                            "Email Address":tempData[i].emailID,
                            "Phone":tempData[i].phone || ""
                        }
                        this.state.exportToExcelArr.push(tempObj)
                    }

                }

            })
            .catch(error => {
                console.log(error);
                console.log(error.response);
                // if (error.response.status === 500) {
                    
                    this.setState({
                        loaderShow: false,
                        // showCommonErrorModal: true,
                    });
                // }
            });
    }

    getLast10 = (phone) => {
		if (!phone && phone !== 0) return '';
		const digits = ('' + phone).replace(/\D/g, '');
		if (digits.length <= 10) return digits;
		return digits.slice(-10);
	}
 
 downloadProspectCensus = () =>{
    
        // array of objects to save in Excel
        let binary_univers = this.state.exportToExcelArr
       

        let binaryWS = XLSX.utils.json_to_sheet(binary_univers); 

        // Create a new Workbook
        var wb = XLSX.utils.book_new() 

        // Name your sheet
        XLSX.utils.book_append_sheet(wb, binaryWS, 'Sheet1') 

        // export your excel
        XLSX.writeFile(wb, this.props.employerName +' '+ moment().format("MMM DD, YYYY")+'.csv');

 }

  
    // Download Employee data------------------------
    downloadEmployeeData = () =>{
        
    }

    // Upload excel -------------------------------

    uploadData = () => {
        this.setState({ uploadExcelModal: true })
        this.state.finalArr = [];
        console.log("download array---",this.state.downloadFinalArr)
    }

    openInvoiceList = () => {
        const empid = this.state.empid;
        if (!empid) {
            this.setState({ invoiceList: [], showInvoiceList: true, invoiceListLoading: false });
            return;
        }
        this.setState({ showInvoiceList: true, invoiceListLoading: true, invoiceList: [] });
        axios.get(process.env.REACT_APP_BASE_ROOT_URL + `/uhfemployerService/api/v67/invoiceList/${empid}`)
            .then(res => {
                this.setState({
                    invoiceList: Array.isArray(res.data) ? res.data : [],
                    invoiceListLoading: false,
                });
            })
            .catch(err => {
                console.log(err);
                this.setState({ invoiceList: [], invoiceListLoading: false });
            });
    }

    openAdviceList = () => {
        const empid = this.state.empid;
        if (!empid) {
            this.setState({ adviceList: [], showAdviceList: true, adviceListLoading: false });
            return;
        }
        this.setState({ showAdviceList: true, adviceListLoading: true, adviceList: [] });
        axios.get(process.env.REACT_APP_BASE_ROOT_URL + `/uhfemployerService/api/v67/adviceList/${empid}`)
            .then(res => {
                this.setState({
                    adviceList: Array.isArray(res.data) ? res.data : [],
                    adviceListLoading: false,
                });
            })
            .catch(err => {
                console.log(err);
                this.setState({ adviceList: [], adviceListLoading: false });
            });
    }

    openReportInWindow = async (url, type = 'invoice') => {
        if (!url) return;

        let base64URL;
        try {
            base64URL = btoa(unescape(encodeURIComponent(url)));
        } catch (e) {
            base64URL = btoa(url);
        }

        const apiUrl = `${process.env.REACT_APP_REPORT_URL}/report/readS3Data`;

        try {
            const resp = await axios.post(
                apiUrl,
                { encodeUrl: base64URL },
                {
                    headers: { 'Content-Type': 'application/json' },
                    responseType: 'arraybuffer',
                }
            );

            const blob = new Blob([resp.data], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);

            if (type === 'advice') {
                if (this.state.adviceUrl && this.state.adviceUrl.startsWith('blob:')) {
                    URL.revokeObjectURL(this.state.adviceUrl);
                }
                this.setState({
                    showAdvice: true,
                    adviceUrl: blobUrl,
                    showInvoice: false,
                    invoiceUrl: '',
                });
            } else {
                if (this.state.invoiceUrl && this.state.invoiceUrl.startsWith('blob:')) {
                    URL.revokeObjectURL(this.state.invoiceUrl);
                }
                this.setState({
                    showInvoice: true,
                    invoiceUrl: blobUrl,
                    showAdvice: false,
                    adviceUrl: '',
                });
            }
        } catch (err) {
            const msg = err.response
                ? `Failed to fetch report: ${err.response.status} ${err.response.statusText}`
                : `Error fetching report: ${err.message}`;

            this.setState({
                loaderShow: false,
                msgModal: true,
                errMsg: msg,
            });
        }
    }



    // ----------------update User-----------------------
    updateUser = () => {
        this.setState({ errModal: false })
        let newPhone = this.state.phone.replace(/[^a-zA-Z0-9]/g, '');
        let obj = {};

        //console.log("=====id===", this.state.id);

        if(sessionStorage.getItem('EMPLOYER_FLOW') === "YES"){
            obj = {
                "firstName": this.state.fname.trim(),
                "lastName": this.state.lname.trim(),
                "phone":this.state.phone? this.state.countryCode + newPhone.substr(1) :null,
                "email": this.state.email?this.state.email:null,
                "prefix":this.state.prefix,
                "suffix":this.state.suffix,
                "middleName":this.state.middleName,
                "clientId": this.props.clientId,
                "associationId": this.props.associationId,
                "brokerId": this.props.agentId,
                "id": this.state.id
            };
            if(this.state.email == null || this.state.email == ''){
                this.updateUserObj(obj, false);
            }else{
                if(this.state.tempEmail == this.state.email){
                    this.updateUserObj(obj, false);
                }else{
                    axios.get(`${configurations.baseUrl}/agentlogin/validateEmail/${this.state.email}/${this.props.agentId}?editFlag=${true}`)
                    .then((response) => {
                        console.log("validateemail===", response)
                        if (response.data.code == 200) {
                            this.updateUserObj(obj, false);
                        }else {
                            this.setState({
                                loaderShow: false,
                                msgModal: true,
                                errMsg: response.data.message,
                                refresh: true
                            });
                            if (response.data.code == 202) {
                            this.setState({
                                errModal: true,
                                userObject: obj
                            })
                        }
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        console.log(error.response);
                        // if (error.response.status === 500) {
                            
                            this.setState({
                                loaderShow: false,
                                // showCommonErrorModal: true,
                            });
                        // }
                    });
                    
                }
            }
           

        }else{ // Update Household
            obj = {
                "firstName": this.state.fname.trim(),
                "lastName": this.state.lname.trim(),
                "phone": this.state.countryCode + newPhone.substr(1),
                "email": this.state.email,
                "prefix":this.state.prefix,
                "suffix":this.state.suffix,
                "middleName":this.state.middleName,
                "clientId": this.props.clientId,
                "associationId": this.props.associationId,
                "brokerId": this.props.agentId,
                "id": this.state.id
            };
            if(this.state.tempEmail == this.state.email){
                this.updateUserObj(obj, false);
            }else{
                axios.get(`${configurations.baseUrl}/agentlogin/validateEmail/${this.state.email}/${this.props.agentId}?editFlag=${true}`)
                .then((response) => {
                    console.log("validateemail===", response)
                    if (response.data.code == 200) {
                        this.updateUserObj(obj, false);
                    }
                    // else if(response.data.code == 500){
                    //     this.setState({
                    //         loaderShow: false,
                    //         showCommonErrorModal: true,
                    //     });
                    // }
                    
                    else {
                        this.setState({
                            loaderShow: false,
                            msgModal: true,
                            errMsg: response.data.message,
                            refresh: true
                        });
                        if (response.data.code == 202) {
                            this.setState({
                                errModal: true,
                                userObject: obj
                            })
                        }
                    }
                })
                .catch(error => {
                    console.log(error);
                    console.log(error.response);
                    // if (error.response.status === 500) {
                        
                        this.setState({
                            loaderShow: false,
                            // showCommonErrorModal: true,
                        });
                    // }
                });
                
            }

        }

        

    }

    updateUserObj = (obj, confirmationFlag) => {
        obj = {...obj, email: obj.email.toLowerCase()}
        this.setState({
            loaderShow: true,
            msgModal: false,
            editModal: false,
            errModal: false,
        });
        axios.post(configurations.baseUrl + '/agentlogin/updateUser?confirmationFlag=' + confirmationFlag, JSON.parse(JSON.stringify(obj)))
            .then(response => {
                if (response.data.code === 200) {
                    this.getUserData(this.state.empid)
                    this.setState({
                        loaderShow: false,
                        editModal: false,
                        msgModal: true,
                        errMsg: sessionStorage.getItem('EMPLOYER_FLOW') === "YES" ? "Employee Updated Successfully!" : "Prospect Updated Successfully!"
                    });
                } else if (response.data.code === 206) {
                    this.setState({
                        loaderShow: false,
                        editModal: false,
                        msgModal: true,
                        errMsg: response.data.message
                    });
                }else if (response.data.code === 500) {
                    this.setState({
                        loaderShow: false,
                        // editModal: false,
                        // msgModal: true,
                        // errMsg: "INTERNAL_SERVER_ERROR"                       
                           
                        // showCommonErrorModal: true,
                        
                    });
                }

            })
            .catch(error => {
                console.log(error);
                console.log(error.response);
                // if (error.response.status === 500) {
                    
                    this.setState({
                        loaderShow: false,
                        // showCommonErrorModal: true,
                    });
                // }
            });
    }

    // ---------------Search Menu click-------------------

    handleChageSearchType(event) {
        let value = event.target.value;
        const isMembersTab = this.props.enrollmentFilter === "members";
        console.log('== handleChageSearchType ===============');
        console.log(value);
        if (value === '3' && isMembersTab) {
            value = '';
        }
        if (value === '4' && !isMembersTab) {
            value = '';
        }
        if (value === '' || value === null) {
            // Changing filter type to blank should not auto-refresh; it only resets the UI.
            this.setState({ searchShow: true, searchText: '', page: 0 });
        } else {
            if (this.state.searchTypeValue === '0') {
                formData.set("columns[1].search.value", "");
            } else if (this.state.searchTypeValue === '1') {
                formData.set("columns[4].search.value", "");
            } else if (this.state.searchTypeValue === '2') {
                formData.set("columns[2].search.value", "");
            } else if (this.state.searchTypeValue === '3') {
                formData.set("columns[3].search.value", "");
                formData.set("columns[6].search.value", "");
            } else if (this.state.searchTypeValue === '4') {
                formData.set("columns[10].search.value", "");
            }
            this.setState({
                searchTypeValue: value,
                searchShow: false,
                searchText: '',
                rowsPerPage: 10,
                page: 0,
                // Members status must persist even when changing Search By filter.
                userStatusValue: isMembersTab ? (this.state.userStatusValue) : (value === '4' ? this.state.userStatusValue : ''),
                ...(isMembersTab ? { membersFromDate: null, membersToDate: null } : {}),
            }, () => {
                // Changing filter type should not trigger an API call (Members or Prospects).
                // Search will happen on explicit action (Search button, Status selection, Program selection).
            });
        }

    }


    setSearch(event) {
        let value = event.target.value;
        this.setState({
            searchText: value
        }, () => {
            if (this.state.searchText === "" || this.state.searchText === null) {
                this.searchRecord();
            }
        });
    }


    statusChange = (event) => {
        this.setState({ statusValue: event.target.value, searchText: event.target.value }, () => {
            this.searchRecord();
        })
    }

    userStatusChange = (event) => {
        const value = event.target.value;
        const isMembers = this.props.enrollmentFilter === 'members';
        this.setState(
            {
                userStatusValue: value,
                ...(isMembers
                    ? value === 'terminated'
                        ? {
                              fabricMembersSort: '-cancellationReqDate',
                              membersSortOrderName: 'cancellationReqDate',
                              membersSortOrderDirection: 'desc',
                          }
                        : {
                              fabricMembersSort: 'status',
                              membersSortOrderName: 'status',
                              membersSortOrderDirection: 'asc',
                          }
                    : {}),
            },
            () => {
                this.searchRecord();
            },
        );
    }

    clearMembersStatusToActive = () => {
        // Match Refresh: reset status to Active and clear all member search filters, then reload.
        this.refreshTable("screen");
    }

    buildFabricMembersParams = ({ page, rows, sort } = {}) => {
        const limit = rows ?? this.state.rowsPerPage ?? 10;
        const pageNum = page ?? this.state.page ?? 0;
        const offset = pageNum * limit;
        const fabricSort = sort ?? this.state.fabricMembersSort ?? undefined;

        const statusValueStr = Array.isArray(this.state.selectedStatus)
            ? this.state.selectedStatus
            : ['DQ', 'PC'];

        const params = {
            agentId: this.props.agentId,
            statuses: statusValueStr,
            limit,
            offset,
            ...(fabricSort ? { sort: fabricSort } : {}),
        };

        const searchText = String(this.state.searchText || '').trim();

        // Send ONLY the selected filter (besides clientId+status)
        switch (this.state.searchTypeValue) {
            case '5': // Member ID
                if (searchText) params.memberId = searchText;
                break;
            case '6': // First Name
                if (searchText) params.firstName = searchText;
                break;
            case '7': // Last Name
                if (searchText) params.lastName = searchText;
                break;
            case '8': // Agent Name
                if (searchText) params.agentName = searchText;
                break;
            case '9': // Program Name
                if (searchText) params.programName = searchText;
                break;
            case '10': // Program Begin Date
                if (this.state.membersFromDate && this.state.membersToDate) {
                    params.programBeginningDate = [this.state.membersFromDate, this.state.membersToDate];
                }
                break;
            case '11': // Program ID
                if (searchText) params.programId = searchText;
                break;
            case '12': // Agent ID
                if (searchText) params.agentId = searchText;
                break;
            case '13': // Employer ID
                if (searchText) params.employerId = searchText;
                break;
            case '14': // Paid Through Date
                if (this.state.membersFromDate && this.state.membersToDate) {
                    params.paidThroughDate = [this.state.membersFromDate, this.state.membersToDate];
                }
                break;
            case '15': // Program End Date
                if (this.state.membersFromDate && this.state.membersToDate) {
                    params.programEndDate = [this.state.membersFromDate, this.state.membersToDate];
                }
                break;
            case '16': // Cancellation Req Date
                if (this.state.membersFromDate && this.state.membersToDate) {
                    params.cancellationReqDate = [this.state.membersFromDate, this.state.membersToDate];
                }
                break;
            default:
                break;
        }

        // Employer flow: scope Fabric members search to the selected employer and keep default status (AC/TE above).
        const scopedEmployerId = String(
            this.props.selectedEmployerId || this.state.empid || ''
        ).trim();
        if (sessionStorage.getItem('EMPLOYER_FLOW') === 'YES' && scopedEmployerId) {
            params.employerId = scopedEmployerId;
        }

        return params;
    }

    fetchMembersFromFabric = async ({ page, rows, sort } = {}) => {
        try {
            const params = this.buildFabricMembersParams({ page, rows, sort });
            const response = await searchEnrolledMembers(params);
            const totalRecordsCount = Number(response?.totalCount || 0);

            // Intercept empty Delinquent/Pre-Cancel default query to seamlessly fall back to Active records
            if (
                this.state.isDefaultLoad &&
                !this.state.fallbackToActive &&
                totalRecordsCount === 0 &&
                Array.isArray(params.statuses) &&
                (params.statuses.includes("DQ") && params.statuses.includes("PC"))
            ) {
                this.setState({
                    selectedStatus: ['AC']
                }, () => {
                    this.fetchMembersFromFabric({ page, rows, sort });
                });
                return;
            }
            this.setState({
                    fallbackToActive: true,
                    isDefaultLoad: false})
                    
            const rowsData = Array.isArray(response?.data) ? response.data : [];

            const mapped = rowsData.map((m) => ({
                // keep display/actions stable on memberId, but retain Fabric record id for View Details
                id: m.memberId || '',
                fabricId: m.id || '',
                memberId: m.memberId,
                programId: m.programId || '',
                clientId: m.clientId ?? this.props.clientId,
                agentId: m.agentId || '',
                employerId: m.employerId ?? '',
                memberFirstName: m.firstName || '',
                memberLastName: m.lastName || '',
                paidThroughDate: m.paidThroughDate || m.paidThrough || null,
                programBeginningDate: m.programBeginningDate || null,
                programEndDate: m.programEndDate || null,
                status: process.env.REACT_APP_PORTAL === 'employer' ? m.displayStatus || '' : m.status || '',
                programName: m.programName || '',
                cancellationReqDate: m.cancellationReqDate || m.cancellationRequestDate || null,
                agentName: m.agentName || m.agent || '',
                // Members are already enrolled; required for legacy members actions (dependents/add-ons/re-assign)
                enrollFlag: true,
                subId: m.subId || m.subID || m.sub_id || '',
                // keep legacy fields around for any shared helpers
                createdDate: m.programBeginningDate || m.createdDate || null,
                firstName: m.firstName || '',
                lastName: m.lastName || '',
                middleName: m.middleName || '',
                prefix: m.prefix || '',
                suffix: m.suffix || '',
                email: m.email || '',
                inviteStatus: m.inviteStatus || null,
                daysInStatus: m.daysInStatus || '-',
                daysToTermination: m.daysToTermination || '-'
            }));

            this.setState({
                data: mapped,
                count: Number(response?.totalCount || 0),
                loaderShow: false,
                circleloaderShow: false,
                ...(page !== undefined ? { page } : {}),
                ...(rows !== undefined ? { rowsPerPage: rows } : {}),
            });
        } catch (error) {
            console.log('Fabric members search error', error);
            this.setState({ data: [], count: 0, loaderShow: false, circleloaderShow: false });
        }
    }


    changePage = (page, rows) => {
        if (this.props.enrollmentFilter === "members") {
            this.setState({ loaderShow: true }, () => {
                this.fetchMembersFromFabric({ page, rows });
            });
            return;
        }

        this.setState({
            loaderShow: true
        });
        if (page !== undefined && rows) {
            let nextPage = (page * rows)
            formData.set("start", nextPage.toString());
            formData.set("length", rows.toString());
            if (this.props.enrollmentFilter === "members" && this.state.searchTypeValue === '4') {
                if (this.state.userStatusValue === 'active') {
                    formData.set("columns[10].search.value", "AC");
                } else if (this.state.userStatusValue === 'terminated') {
                    formData.set("columns[10].search.value", "TE");
                } else {
                    formData.set("columns[10].search.value", "");
                }
            } else {
                formData.set("columns[10].search.value", "");
            }
            this.applyEnrollmentFilter();

            fetch(this.getUserByAgentUrl(), requestOptions)
                .then(response => response.json())
                .then(data => {
                    if (data.response && data.response.data) {
                        this.setState({ data: data.response.data, rowsPerPage: rows, loaderShow: false, page: page })
                    } else {
                        this.setState({ loaderShow: false })
                    }
                })
                .catch(error => {
                    console.log(error);
                    console.log(error.response);
                    // if (error.response.status === 500) {
                        
                        this.setState({
                            loaderShow: false,
                            // showCommonErrorModal: true,
                        });
                    // }
                });
        }
    }
    /* ========================== server side sorting logic================= */

    sort = (changedColumn, order) => {
        if (this.props.enrollmentFilter === "members") {
            this.sortMembersFabric(changedColumn, order);
            return;
        }

        console.log(changedColumn,order)
        formData.set("start", "0");
        formData.set("order[0].column", changedColumn);
        formData.set("order[0].dir", order);
        if (this.props.enrollmentFilter === "members" && this.state.searchTypeValue === '4') {
            if (this.state.userStatusValue === 'active') {
                formData.set("columns[10].search.value", "AC");
            } else if (this.state.userStatusValue === 'terminated') {
                formData.set("columns[10].search.value", "TE");
            } else {
                formData.set("columns[10].search.value", "");
            }
        } else {
            formData.set("columns[10].search.value", "");
        }
        this.applyEnrollmentFilter();
        fetch(this.getUserByAgentUrl(), requestOptions)
            .then(response => response.json())
            .then(data => {
                if (data.response && data.response.data) {
                    this.setState({ data: data.response.data, count: data.response.recordsFiltered, loaderShow: false })
                } else {
                    this.setState({ loaderShow: false })
                }
            })
            .catch(error => {
                console.log(error);
                console.log(error.response);
                // if (error.response.status === 500) {
                    
                    this.setState({
                        loaderShow: false,
                        // showCommonErrorModal: true,
                    });
                // }
            });
    }

    sortMembersFabric = (changedColumn, direction) => {
        const order = direction === 'asc' ? 'asc' : 'desc';
        // mui-datatables may send either the column "name" or the displayed "label"
        // depending on which callback fired (onTableChange sort vs onColumnSortChange).
        const sortFieldMap = {
            // by column name
            memberId: 'memberId',
            memberFirstName: 'firstName',
            memberLastName: 'lastName',
            paidThroughDate: 'paidThroughDate',
            programBeginningDate: 'programBeginningDate',
            programEndDate: 'programEndDate',
            programName: 'programName',
            cancellationReqDate: 'cancellationReqDate',
            daysInStatus:'daysInStatus',
            daysToTermination:'daysToTermination',
            status:'status',
            // by column label
            "Member ID": 'memberId',
            "Member First Name": 'firstName',
            "Member Last Name": 'lastName',
            "Paid Through Date": 'paidThroughDate',
            "Program Begin Date": 'programBeginningDate',
            "Program Beginning Date": 'programBeginningDate',
            "Program End Date": 'programEndDate',
            "Program Name": 'programName',
            "Cancellation Requested Date": 'cancellationReqDate',
            "Cancellation Req Date": 'cancellationReqDate',
            "Days in Status": 'daysInStatus',
            "Days to Termination": 'daysToTermination',
            "Status":'status'
        };

        const labelToNameMap = {
            "Member ID": "memberId",
            "Member First Name": "memberFirstName",
            "Member Last Name": "memberLastName",
            "Paid Through Date": "paidThroughDate",
            "Program Begin Date": "programBeginningDate",
            "Program Beginning Date": "programBeginningDate",
            "Program End Date": "programEndDate",
            "Program Name": "programName",
            "Cancellation Requested Date": "cancellationReqDate",
            "Cancellation Req Date": "cancellationReqDate",
        };

        const sortKey = labelToNameMap[changedColumn] || changedColumn;
        const field = sortFieldMap[sortKey] || sortFieldMap[changedColumn];
        if (!field) {
            const nextSort = order === 'asc' ? 'programBeginningDate' : '-programBeginningDate';
            this.setState({
                fabricMembersSort: nextSort,
                page: 0,
                membersSortOrderName: 'programBeginningDate',
                membersSortOrderDirection: order,
            }, () => {
                this.fetchMembersFromFabric({ page: 0, rows: this.state.rowsPerPage, sort: nextSort });
            });
            return;
        }

        const nextSort = order === 'asc' ? field : `-${field}`;
        this.setState({
            fabricMembersSort: nextSort,
            page: 0,
            membersSortOrderName: sortKey,
            membersSortOrderDirection: order,
        }, () => {
            this.fetchMembersFromFabric({ page: 0, rows: this.state.rowsPerPage, sort: nextSort });
        });
    };

    /* ========================== server side sorting logic================= */

    /* ========================== server side search logic================= */
    searchRecord = () => {
        if (this.props.enrollmentFilter === "members") {
            this.setState({ loaderShow: true, page: 0 }, () => {
                this.fetchMembersFromFabric({ page: 0, rows: this.state.rowsPerPage });
            });
            return;
        }

        this.setState({
            loaderShow: true
        });

        if (!(this.props.enrollmentFilter === "members" && this.state.searchTypeValue === '4')) {
            formData.set("columns[10].search.value", "");
        }

        this.applyEnrollmentFilter();

        console.log('============ searchRecord ===============');
        console.log(this.state.searchTypeValue);

        if (this.state.searchTypeValue === '0') { //Date search
            // this.state.statusValue=''
            formData.set("start", "0");
            formData.set("columns[1].search.value", this.state.searchText);

            fetch(this.getUserByAgentUrl(), requestOptions)
                .then(response => response.json())
                .then(data => {
                    if (data.response && data.response.data) {
                        this.setState({ data: data.response.data, count: data.response.recordsFiltered, statusValue: '', loaderShow: false })
                    } else {
                        this.setState({ loaderShow: false });
                    }

                })
                .catch(error => {
                    console.log(error);
                    console.log(error.response);
                    // if (error.response.status === 500) {
                        
                        this.setState({
                            loaderShow: false,
                            // showCommonErrorModal: true,
                        });
                    // }
                });
        } else if (this.state.searchTypeValue === '1') { //Prospect name search
            // this.state.targetDate=null
            // this.state.statusValue=''
            formData.set("start", "0");
            formData.set("length", this.state.rowsPerPage.toString());
            formData.set("columns[4].search.value", "");

            fetch(this.getUserByAgentUrl(), requestOptions)
                .then(response => response.json())
                .then(data => {
                    if (data.response && data.response.data) {
                        this.setState({ data: data.response.data, count: data.response.recordsFiltered, targetDate: null, statusValue: '', loaderShow: false })
                    } else {
                        this.setState({ loaderShow: false });
                    }

                })
                .catch(error => {
                    console.log(error);
                    console.log(error.response);
                    // if (error.response.status === 500) {
                        
                        this.setState({
                            loaderShow: false,
                            // showCommonErrorModal: true,
                        });
                    // }
                });
        } else if (this.state.searchTypeValue === '2') {
            // this.state.targetDate=null
            // this.state.statusValue=''
            formData.set("start", "0");
            formData.set("columns[2].search.value", this.state.searchText);

            fetch(this.getUserByAgentUrl(), requestOptions)
                .then(response => response.json())
                .then(data => {
                    if (data.response && data.response.data) {
                        this.setState({ data: data.response.data, count: data.response.recordsFiltered, targetDate: null, statusValue: '', loaderShow: false })
                    } else {
                        this.setState({ loaderShow: false });
                    }

                })
                .catch(error => {
                    console.log(error);
                    console.log(error.response);
                    // if (error.response.status === 500) {
                        
                        this.setState({
                            loaderShow: false,
                            // showCommonErrorModal: true,
                        });
                    // }
                });
        } else if (this.state.searchTypeValue === '3' && this.props.enrollmentFilter !== "members") {
            // this.state.targetDate=null
            // this.state.statusValue=''
            formData.set("start", "0");
            formData.set("columns[3].search.value", "");
            if (this.state.searchText === 'all') {
                formData.set("columns[3].search.value", "");
                formData.set("columns[6].search.value", "");
            } else if (this.state.statusValue === 'true' || this.state.statusValue === true) {
                formData.set("columns[3].search.value", this.state.searchText);
                formData.set("columns[6].search.value", "");
            } else if (this.state.searchText === "8" || this.state.searchText === "9"){
                    formData.set("columns[6].search.value", this.state.searchText);
                    formData.set("columns[3].search.value", false);
                } else if(this.state.searchText === "0" || this.state.searchText === "1"|| this.state.searchText === "2"|| this.state.searchText === "3"
                || this.state.searchText === "4" || this.state.searchText === "5"|| this.state.searchText === "6"
                || this.state.searchText === "7"                
                ) {
                    formData.set("columns[3].search.value", false);
                    formData.set("columns[6].search.value", this.state.searchText);
                }
            this.applyEnrollmentFilter();
            
            fetch(this.getUserByAgentUrl(), requestOptions)
                .then(response => response.json())
                .then(data => {
                    if (data.response && data.response.data) {
                        this.setState({ data: data.response.data, count: data.response.recordsFiltered, targetDate: null, loaderShow: false })
                    } else {
                        this.setState({ loaderShow: false });
                    }

                });
        } else if (this.props.enrollmentFilter === "members" && this.state.searchTypeValue === '4') {
            formData.set("start", "0");
            formData.set("columns[1].search.value", "");
            formData.set("columns[2].search.value", "");
            formData.set("columns[4].search.value", "");
            formData.set("columns[3].search.value", "");
            formData.set("columns[6].search.value", "");
            if (this.state.userStatusValue === 'active') {
                formData.set("columns[10].search.value", "AC");
            } else if (this.state.userStatusValue === 'terminated') {
                formData.set("columns[10].search.value", "TE");
            } else {
                formData.set("columns[10].search.value", "");
            }
            this.applyEnrollmentFilter();

            fetch(this.getUserByAgentUrl(), requestOptions)
                .then(response => response.json())
                .then(data => {
                    if (data.response && data.response.data) {
                        this.setState({ data: data.response.data, count: data.response.recordsFiltered, targetDate: null, statusValue: '', loaderShow: false })
                    } else {
                        this.setState({ loaderShow: false });
                    }

                })
                .catch(error => {
                    console.log(error);
                    console.log(error.response);
                    this.setState({
                        loaderShow: false,
                    });
                });
        }

    }
    /* ========================== server side search logic================= */


    // ==========Date Change=================

    handleDate(event) {
        this.setState({
            targetDate: moment(event).format('YYYY') + '-' + moment(event).format('MM') + '-' + moment(event).format('DD'),
            searchText: moment(event).format('YYYY') + '-' + moment(event).format('MM') + '-' + moment(event).format('DD'),
        });
    }

    handleMembersFromDate = (event) => {
        const from = event ? moment(event).format('YYYY-MM-DD') : null;
        this.setState((prev) => {
            const next = { membersFromDate: from };
            if (from && prev.membersToDate && moment(prev.membersToDate).isBefore(from, 'day')) {
                next.membersToDate = from;
            }
            return next;
        });
    }

    handleMembersToDate = (event) => {
        const to = event ? moment(event).format('YYYY-MM-DD') : null;
        this.setState((prev) => {
            const next = { membersToDate: to };
            if (to && prev.membersFromDate && moment(to).isBefore(prev.membersFromDate, 'day')) {
                next.membersFromDate = to;
            }
            return next;
        });
    }

    fetchMembersPlans = async () => {
        try {
            const channelId = Number(this.props.clientId) || Number(this.props.associationId);
            if (!channelId) return;
            const plans = await getPlansByChannelId(channelId);
            const planCodes = plans
                .map((p) => (p && p.planCode ? String(p.planCode) : ''))
                .filter(Boolean);
            this.setState({ membersPlanCodes: planCodes });
        } catch (e) {
            console.log('Unable to load plans list', e);
            this.setState({ membersPlanCodes: [] });
        }
    }

    handleMembersProgramChange = (event) => {
        const value = event?.target?.value ?? '';
        this.setState({ membersSelectedPlanCode: value, searchText: value }, () => {
            // Selection triggers API call immediately
            this.searchRecord();
        });
    }

    // =========================================

    menuDetails = [
        "View Details",
        sessionStorage.getItem('EMPLOYER_FLOW') === "YES" ? "Edit Employee" : "Edit Prospect",
        // "Notes",
    ]
    menuOptions = [
        "View Details",
        "Edit Prospect Details",
        "Edit Census",
        "Create Quick Quote",
        "Start/Resume Enroll",
        "Send Auth Email",        
        "Delete",     
        "Re-assign Agent",
        // "Notes",
        /*"Change Email"*/
    ];
    /* menuOptions = [
        "Create Quick Quote",
        "Edit Census",
        "Start/Resume Enroll",
        "Send Sign-up Email",
        "Edit Prospect Details",
        "Delete",
        "View Details",
        "Change Email"
    ]; */
   
    menuOptionsHippa = [
        "View Details",
        "Change Dependents",
        "Change Add-Ons",
        "Re-assign Agent", 
        "Send Hipaa Auth",
        // "Notes",
        /*"Change Email"*/
    ];
    menuOptions1 = process.env.REACT_APP_PORTAL === "employer"? [
        "View Details",
    ] : [
        "View Details",
        "Change Dependents",
        "Change Add-Ons",
        "Re-assign Agent",
        // "Notes",
    ];
    menuOptionsEmployer = [
        "View Details",
        "Delete",
    ];

    invoiceColumns = [
        {
            label: "Date Added", name: "createdDate", options: {
                sort: false,
                customBodyRenderLite: (index) => {
                    if (this.state.invoiceList && this.state.invoiceList[index] && this.state.invoiceList[index].invoiceDate) {
                        return moment.utc(this.state.invoiceList[index].invoiceDate).format('MMMM DD, YYYY');
                    }
                    return "";
                }
            }
        },
        {
            label: "Invoice", name: "invoiceLink", options: {
                sort: false,
                customBodyRenderLite: (index) => {
                    if (this.state.invoiceList && this.state.invoiceList[index] && this.state.invoiceList[index].url) {
                        return (
                            <text
                                style={{ cursor: 'pointer', marginBottom: 40, textDecoration: 'underline', color: 'blue' }}
                                onClick={() => this.openReportInWindow(this.state.invoiceList[index].url, 'invoice')}
                            >Invoice Link</text>
                        );
                    }
                    return 'NA';
                }
            }
        },
    ];

    invoiceOptions = {
        selectableRows: false,
        filter: false,
        selectableRowsHeader: false,
        count: 0,
        rowsPerPage: 0,
        search: false,
        serverSide: true,
        viewColumns: false,
        print: false,
        fixedHeader: true,
        page: 0,
        download: false,
        customFooter: () => <div></div>,
    };

    adviceColumns = [
        {
            label: "Date Added", name: "createdDate", options: {
                sort: false,
                customBodyRenderLite: (index) => {
                    if (this.state.adviceList && this.state.adviceList[index] && this.state.adviceList[index].createdDate) {
                        return moment.utc(this.state.adviceList[index].createdDate).format('MMMM DD, YYYY');
                    }
                    return "";
                }
            }
        },
        {
            label: "Advice", name: "adviceLink", options: {
                sort: false,
                customBodyRenderLite: (index) => {
                    if (this.state.adviceList && this.state.adviceList[index] && (this.state.adviceList[index].adviceUrl || this.state.adviceList[index].advoiceUrl)) {
                        const adviceUrl = this.state.adviceList[index].adviceUrl || this.state.adviceList[index].advoiceUrl;
                        return (
                            <text
                                style={{ cursor: 'pointer', marginBottom: 40, textDecoration: 'underline', color: 'blue' }}
                                onClick={() => this.openReportInWindow(adviceUrl, 'advice')}
                            >Advice Link</text>
                        );
                    }
                    return 'NA';
                }
            }
        },
    ];

    adviceOptions = {
        selectableRows: false,
        filter: false,
        selectableRowsHeader: false,
        count: 0,
        rowsPerPage: 0,
        search: false,
        serverSide: true,
        viewColumns: false,
        print: false,
        fixedHeader: true,
        page: 0,
        download: false,
        customFooter: () => <div></div>,
    };

    columns = [
        // { label: "User Id", name: "id" },
        {
            label: "Record ", name: "record",
            options: {
                sort: true,
                display: sessionStorage.getItem('EMPLOYER_FLOW') === "YES" ? true : false,
            }
        },
        {
            label: "Date Added", name: "createdDate", options: {
                sort: true,
                customBodyRenderLite: (index) => {
                    // this.state.dateAdded= (this.state.data[index].createdDate).format('yy-mm-dd');
                    if (this.state.data && this.state.data[index] && this.state.data[index].createdDate) {
                        return moment(this.state.data[index].createdDate).format('MMMM DD, YYYY');
                    } else {
                        return "";
                    }
                }
            }
        },
        {
            label: sessionStorage.getItem('EMPLOYER_FLOW') === "YES" ? "Employee Name" : this.props.enrollmentFilter === "members" ? "Member Name" : "Prospect Name", name: "firstName", options: {
                sort: true,
                customBodyRenderLite: (index) => {
                    if (this.state.data && this.state.data[index] && this.state.data[index].firstName && this.state.data[index].lastName) {
                        return `${this.state.data[index].prefix || ""} ${this.state.data[index].firstName || ""} ${this.state.data[index].middleName || ""} ${this.state.data[index].lastName || ""} ${this.state.data[index].suffix || ""}`;
                    } else {
                        return 'NA';
                    }
                }
            }
        },
        {
            label: "Email ", name: "email", options: {
                sort: true,
            }
        },
        // {
        //     label: "Dependants ", name: "Dependant_data", options: {
        //         sort: false,
        //     }
        // },
        {
            label: "Status", name: "status", options: {
                sort: false,
            
                customBodyRenderLite: (dataIndex) => {
                    if (this.state.data && this.state.data[dataIndex]) {
                        const row = this.state.data[dataIndex];
                        if (this.props.enrollmentFilter === "members") {
                            const userStatus = (row.status || '').toString().toUpperCase();
                            if (userStatus === 'TE' || userStatus === 'TERMINATED') {
                                return <div style={{display: "flex", justifyContent: "flex-start"}}><div style={customStyle.statusBg}><span style={customStyle.statusCaption}>TERMINATED</span></div></div>
                            }
                            if (userStatus === 'AC' || userStatus === 'ACTIVE') {
                                return  <div style={{display: "flex", justifyContent: "flex-start"}}>
                                <div style={customStyle.statusBg1}><span style={customStyle.statusCaption1}>ACTIVE</span></div>
                                </div>
                            }
                            return 'NA';
                        }

                        if (this.state.data && this.state.data[dataIndex] && this.state.data[dataIndex].enrollFlag === true ) {
                            // return <div style={customStyle.statusBg1}><span style={customStyle.statusCaption1}>ENROLLED</span></div>
                            return  <div style={{display: "flex", justifyContent: "flex-start"}}>
                            <div style={customStyle.statusBg1}><span style={customStyle.statusCaption1}>App Success</span></div>
                            </div>

                        }else if (this.state.data && this.state.data[dataIndex] && this.state.data[dataIndex].completionStatus === 0) {
                            return <div style={{display: "flex", justifyContent: "flex-start"}}><div style={customStyle.statusBg}><span style={customStyle.statusCaption}>Instructions</span></div></div>
                        } else if (this.state.data && this.state.data[dataIndex] && this.state.data[dataIndex].completionStatus === 1 ) {
                            return <div style={{display: "flex", justifyContent: "flex-start"}}>
                            <div style={customStyle.statusBgTwoLine}><span style={customStyle.statusCaption}>Setup Family</span></div>
                            </div>
                        } else if (this.state.data && this.state.data[dataIndex] && this.state.data[dataIndex].completionStatus === 2) {
                            return <div style={{display: "flex", justifyContent: "flex-start"}}> 
                            <div style={customStyle.statusBg}><span style={customStyle.statusCaption}>View Quote</span></div>
                            </div>
                        } else if (this.state.data && this.state.data[dataIndex] && this.state.data[dataIndex].completionStatus === 3 ) {
                            return <div style={{display: "flex", justifyContent: "flex-start"}}>
                                <div style={customStyle.statusBgTwoLine}><span style={customStyle.statusCaption}>Check Eligibility</span></div>
                                </div>
                        } else if (this.state.data && this.state.data[dataIndex] && this.state.data[dataIndex].completionStatus === 4) {
                            return <div style={{display: "flex", justifyContent: "flex-start"}}>
                                <div style={customStyle.statusBgTwoLine}><span style={customStyle.statusCaption}>Select Program</span></div>
                                </div>
                        }else if (this.state.data && this.state.data[dataIndex] && this.state.data[dataIndex].completionStatus === 5 && this.state.checkADDons ) {
                            return <div style={{display: "flex", justifyContent: "flex-start"}}>
                                <div style={customStyle.statusBgTwoLine}><span style={customStyle.statusCaption}>Select Add-Ons</span></div>
                                </div>
                        }else if (this.state.data && this.state.data[dataIndex] && this.state.data[dataIndex].completionStatus === 5 && !this.state.checkADDons) {
                            return <div style={{display: "flex", justifyContent: "flex-start"}}>
                                <div style={customStyle.statusBgTwoLine}><span style={customStyle.statusCaption}>Review Choices</span></div>
                                </div>
                        }else if (this.state.data && this.state.data[dataIndex] && this.state.data[dataIndex].completionStatus === 6 && this.state.checkADDons) {
                            return <div style={{display: "flex", justifyContent: "flex-start"}}>
                                <div style={customStyle.statusBgTwoLine}><span style={customStyle.statusCaption}>Review Choices</span></div>
                                </div>
                        }else if (this.state.data && this.state.data[dataIndex] && this.state.data[dataIndex].completionStatus === 6 && !this.state.checkADDons) {
                            return <div style={{display: "flex", justifyContent: "flex-start"}}>
                                <div style={customStyle.statusBgTwoLine}><span style={customStyle.statusCaption}>Setup Payment</span></div>
                                </div>
                        }else if (this.state.data && this.state.data[dataIndex] && this.state.data[dataIndex].completionStatus === 7 && this.state.checkADDons) {
                            return <div style={{display: "flex", justifyContent: "flex-start"}}>
                                <div style={customStyle.statusBgTwoLine}><span style={customStyle.statusCaption}>Setup Payment</span></div>
                                </div>
                        }else if (this.state.data && this.state.data[dataIndex] && this.state.data[dataIndex].completionStatus === 7 || this.state.data[dataIndex].completionStatus === 8 && !this.state.checkADDons ) {
                            return <div style={{display: "flex", justifyContent: "flex-start"}}>
                                <div style={customStyle.statusBgTwoLine}><span style={customStyle.statusCaption}>Submit Application</span></div>
                                </div>
                        }else if (this.state.data && this.state.data[dataIndex] && this.state.data[dataIndex].completionStatus === 8 || this.state.data[dataIndex].completionStatus === 9 && this.state.checkADDons) {
                            return <div style={{display: "flex", justifyContent: "flex-start"}}>
                                <div style={customStyle.statusBgTwoLine}><span style={customStyle.statusCaption}>Submit Application</span></div>
                                </div>
                        }
                    
                    } else {
                        return "";
                    }
                },
            }
        },
        {
             name: "inviteStatus", options: {
                sort: false,
                customBodyRenderLite: (index) => {
                    if (this.state.data && this.state.data[index] && this.state.data[index].inviteStatus) {
                        return   moment(this.state.data[index].inviteStatus).format("MMM DD, YYYY hh:mm A");
                    } else {
                        return 'NA';
                    }
                },
                customHeadRender: ({index, ...column}) => {
                    return (
                        // <span style={{color:'rgba(0, 0, 0, 0.87)'}}>
                        // Last Authorization Sent
                        // <IconButton key={index}>
                        // <InfoIcon/>
                        // </IconButton>
                        // </span>
                        <TableCell key={index} style={{width:'auto',fontWeight:'bold', backgroundColor: "#d5d6e9", paddingLeft: '14px'}}>
                            Last Authorization Sent 
                            <IconButton style={{height:'1px',width:'1px'}}>
                            <HtmlTooltip
                             title="This is the most recent authorization sent by agent or regenerated by prospect. It can be email or text."
                             placement="right"
                            
                         >
                                <InfoIcon/>
                                </HtmlTooltip>   
                            </IconButton>
                        </TableCell>
                    )
                }
            }
        },
        {
            name: "Actions",
            options: {
                filter: false,
                sort: false,
                empty: true,
                // Avoid sticky positioning here; it causes the body scrollbar to overlap the action column.
                setCellProps: () => ({
                    style: { width: 86, minWidth: 86, maxWidth: 86, padding: '0 10px', textAlign: 'center' },
                }),
                setCellHeaderProps: () => ({
                    style: { width: 86, minWidth: 86, maxWidth: 86, padding: '0 10px', textAlign: 'center', whiteSpace: 'nowrap' },
                }),
                customBodyRenderLite: (dataIndex) => {
                    const row = this.state.data && this.state.data[dataIndex] ? this.state.data[dataIndex] : null;
                    const viewDetailsId = row ? (row.fabricId || row.id) : null;
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                            <PopupState variant="popover" popupId="demo-popup-menu" >
                                {(popupState) => (
                                    <React.Fragment>
                                        <IconButton {...bindTrigger(popupState)} style={{ zIndex: 0 }} >
                                            <MoreVertIcon style={{ color: "#2f3192" }} onClick={() => viewDetailsId && this.getUserStatus(viewDetailsId)} />
                                        </IconButton>
                                        <Menu {...bindMenu(popupState)}
                                            onClick={popupState.close}
                                            getContentAnchorEl={null}
                                            anchorOrigin={{
                                                vertical: 'top',
                                                horizontal: 'center'
                                            }}
                                            transformOrigin={{
                                                vertical: -10,
                                                horizontal: 30
                                            }}
                                        >
                                            {
                                                this.state.data && this.state.data[dataIndex] &&
                                                <div className="actionDropMenu">
                                                    {process.env.REACT_APP_PORTAL === 'employer' ? (
                                                        this.menuOptionsEmployer.map((option, index) => (
                                                            <MenuItem
                                                                key={option}
                                                                onClick={() => this.selectMenu(index, dataIndex, option)}
                                                                style={{ fontWeight: 500 }}
                                                            >
                                                                {option}
                                                            </MenuItem>
                                                        ))
                                                    ) : this.state.data && this.state.data[dataIndex] && this.state.data[dataIndex].enrollFlag ?
                                                        this.state.sendHipaaAccess && false ?
                                                            this.menuOptionsHippa.map((option, index) => {
                                                                return <MenuItem key={index} disabled={(this.props.clientId == '6548' || this.props.clientId == 6548) || (this.props.clientId == '4367' || this.props.clientId == 4367) || (this.props.clientId == '5647' || this.props.clientId == 5647) || (this.props.clientId == '5540' || this.props.clientId == 5540) || (this.props.clientId == '4376' || this.props.clientId == 4376) || (this.props.clientId == '5541' || this.props.clientId == 5541) || (this.props.clientId == '4377' || this.props.clientId == 4377) ? index === 2 : this.state.userTerminated == true ? index !== 0 : null} hidden={sessionStorage.getItem('EMPLOYER_FLOW') === "YES" ? index == 3 : ''} onClick={() => this.selectMenu(index, dataIndex, option)} style={{ fontWeight: 500 }}>{option}</MenuItem>
                                                            }) :
                                                            this.menuOptions1.map((option, index) => {
                                                                return <MenuItem key={index}
                                                                    disabled={(this.props.clientId == '6548' || this.props.clientId == 6548)
                                                                        || (this.props.clientId == '4367' || this.props.clientId == 4367)
                                                                        || (this.props.clientId == '5647' || this.props.clientId == 5647)
                                                                        || (this.props.clientId == '5540' || this.props.clientId == 5540)
                                                                        || (this.props.clientId == '4376' || this.props.clientId == 4376)
                                                                        || (this.props.clientId == '5541' || this.props.clientId == 5541)
                                                                        || (this.props.clientId == '4377' || this.props.clientId == 4377)
                                                                        || (this.props.clientId == '4599' || this.props.clientId == 4599)
                                                                        || (this.props.clientId == '5742' || this.props.clientId == 5742)
                                                                        ? index === 2 : (this.state.data[dataIndex].guardian || this.state.userTerminated == true) == true ? index !== 0 : null}
                                                                    hidden={sessionStorage.getItem('EMPLOYER_FLOW') === "YES" ? index == 3 :
                                                                        (this.props.clientId == '4599' || this.props.clientId == 4599)
                                                                        || (this.props.clientId == '5742' || this.props.clientId == 5742) ?
                                                                            index == 1 || index == 2
                                                                            : ''}
                                                                    onClick={() => this.selectMenu(index, dataIndex, option)} style={{ fontWeight: 500 }}>{option}</MenuItem>
                                                            })
                                                        :
                                                        this.menuOptions.map((option, index) => {
                                                            return <MenuItem key={index} value='view' hidden={sessionStorage.getItem('EMPLOYER_FLOW') === "YES" ? index == 7 : ''} onClick={(e) => this.selectMenu(index, dataIndex, option)} style={{ fontWeight: 500 }}>{option}</MenuItem>
                                                        })
                                                    }
                                                </div>
                                            }
                                        </Menu>
                                    </React.Fragment>
                                )}
                            </PopupState>
                        </div>
                    );
                }
            }
        }
    ];

    getMembersColumns = () => {
        const selectedStatus = Array.isArray(this.state.selectedStatus)
            ? this.state.selectedStatus
            : [];
            
        const showDaysInStatus = selectedStatus.includes("DQ");
        const showDaysToTermination = selectedStatus.includes("PC");

        return [
            {
                label: "Member ID",
                name: "memberId",
                options: { sort: true }
            },
            {
                label: "Member First Name",
                name: "memberFirstName",
                options: { sort: true }
            },
            {
                label: "Member Last Name",
                name: "memberLastName",
                options: { sort: true }
            },
            {
                label: "Paid Through Date",
                name: "paidThroughDate",
                options: {
                    sort: true,
                    customBodyRenderLite: (index) => {
                        const v = this.state.data && this.state.data[index] && this.state.data[index].paidThroughDate;
                        if (!v) return '-';
                        return moment(v).isValid() ? moment(v).format('YYYY-MM-DD') : String(v);
                    }
                }
            },
            {
                label: "Program Begin Date",
                name: "programBeginningDate",
                options: {
                    sort: true,
                    customBodyRenderLite: (index) => {
                        const v = this.state.data && this.state.data[index] && this.state.data[index].programBeginningDate;
                        if (!v) return '-';
                        return moment(v).isValid() ? moment(v).format('YYYY-MM-DD') : String(v);
                    }
                }
            },
            {
                label: "Program End Date",
                name: "programEndDate",
                options: {
                    sort: true,
                    customBodyRenderLite: (index) => {
                        const v = this.state.data && this.state.data[index] && this.state.data[index].programEndDate;
                        if (!v) return '-';
                        return moment(v).isValid() ? moment(v).format('YYYY-MM-DD') : String(v);
                    }
                }
            },
            {
                label: "Status",
                name: "status",
                options: {
                    sort: true,
                    customBodyRenderLite: (dataIndex) => {
                        if (this.state.data && this.state.data[dataIndex]) {
                            const row = this.state.data[dataIndex];
                            const userStatus = (row.status || '').toString().toUpperCase();

                            // Helper to safely translate raw API tokens to match STATUS_STYLES keys cleanly
                            const getStatusBadge = (statusKey) => {
                                
                                const mappedKey = statusMap[statusKey];
                                const styles = STATUS_STYLES[mappedKey] || {};
                                
                                return (
                                    <div style={{ display: "flex", justifyContent: "flex-start" }}>
                                        <div style={{
                                            backgroundColor: styles.bg || '#ccc',
                                            color: styles.color || '#000',
                                            padding: '3px 8px',
                                            borderRadius: '4px',
                                            fontWeight: 'bold',
                                            fontSize: '12px'
                                        }}>
                                            {mappedKey ? mappedKey.toUpperCase() : statusKey}
                                        </div>
                                    </div>
                                );
                            };

                            if (['AC', 'ACTIVE', 'TE', 'TERMINATED', 'DQ', 'DELINQUENT', 'PC', 'PRE-CANCEL'].includes(userStatus)) {
                                return getStatusBadge(userStatus);
                            }

                            if (userStatus === 'IN' || userStatus === 'INACTIVE') {
                                return (
                                    <div style={{ display: "flex", justifyContent: "flex-start" }}>
                                        <div style={customStyle.statusBg}>
                                            <span style={customStyle.statusCaption}>INACTIVE</span>
                                        </div>
                                    </div>
                                );
                            }

                            return row.status || '-';
                        }
                        return "";
                    },
                }
            },
            ...(showDaysInStatus ? [{
                label: "Days in Status",
                name: "daysInStatus",
                options: {
                    sort: true,
                    customBodyRenderLite: (index) => {
                        const row = this.state.data && this.state.data[index];
                        const userStatus = String(row?.status || '').toUpperCase();
                        if (userStatus === "DELINQUENT" || userStatus === "DQ") {
                            return row?.daysInStatus ?? '-';
                        }
                        return '-';
                    }
                }
            }] : []),
            ...(showDaysToTermination ? [{
                label: "Days to Termination",
                name: "daysToTermination",
                options: {
                    sort: true,
                    customBodyRenderLite: (index) => {
                        const row = this.state.data && this.state.data[index];
                        const userStatus = String(row?.status || '').toUpperCase();
                        if (userStatus === "PRE-CANCEL" || userStatus === "PC") {
                            return row?.daysToTermination ?? '-';
                        }
                        return '-';
                    }
                }
            }] : []),
            {
                label: "Program Name",
                name: "programName",
                options: { sort: true }
            },
            {
                label: "Cancellation Requested Date",
                name: "cancellationReqDate",
                options: {
                    sort: true,
                    customBodyRenderLite: (index) => {
                        const v = this.state.data && this.state.data[index] && this.state.data[index].cancellationReqDate;
                        if (!v) return '-';
                        return moment(v).isValid() ? moment(v).format('YYYY-MM-DD') : String(v);
                    }
                }
            },
            {
                name: "Actions",
                options: {
                    filter: false,
                    sort: false,
                    empty: true,
                    setCellProps: () => ({
                        style: { width: 86, minWidth: 86, maxWidth: 86, padding: '0 10px', textAlign: 'center' },
                    }),
                    setCellHeaderProps: () => ({
                        style: { width: 86, minWidth: 86, maxWidth: 86, padding: '0 10px', textAlign: 'center', whiteSpace: 'nowrap' },
                    }),
                    customBodyRenderLite: (dataIndex) => {
                        const row = this.state.data && this.state.data[dataIndex] ? this.state.data[dataIndex] : null;
                        const viewDetailsId = row ? (row.fabricId || row.id) : null;
                        const membersLastColIdx = this.getMembersColumns().length - 1;
                        return (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                                <PopupState variant="popover" popupId="demo-popup-menu-members" >
                                    {(popupState) => (
                                        <React.Fragment>
                                            <IconButton {...bindTrigger(popupState)} style={{ zIndex: 0 }} >
                                                <MoreVertIcon style={{ color: "#2f3192" }} onClick={() => viewDetailsId && this.getUserStatus(viewDetailsId)} />
                                            </IconButton>
                                            <Menu {...bindMenu(popupState)}
                                                onClick={popupState.close}
                                                getContentAnchorEl={null}
                                                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                                                transformOrigin={{ vertical: -10, horizontal: 30 }}
                                            >
                                                {this.state.data && this.state.data[dataIndex] &&
                                                    <div className="actionDropMenu">
                                                        {this.menuOptions1.map((option, index) => {
                                                            return (
                                                                <MenuItem
                                                                    key={index}
                                                                    disabled={(this.props.clientId == '6548' || this.props.clientId == 6548) || (this.props.clientId == '4367' || this.props.clientId == 4367) || (this.props.clientId == '5647' || this.props.clientId == 5647) || (this.props.clientId == '5540' || this.props.clientId == 5540) || (this.props.clientId == '4376' || this.props.clientId == 4376) || (this.props.clientId == '5541' || this.props.clientId == 5541) || (this.props.clientId == '4377' || this.props.clientId == 4377) || (this.props.clientId == '4599' || this.props.clientId == 4599) || (this.props.clientId == '5742' || this.props.clientId == 5742) ? index === 2 : (this.state.data[dataIndex].guardian || this.state.userTerminated == true) == true ? index !== 0 : null}
                                                                    hidden={sessionStorage.getItem('EMPLOYER_FLOW') === "YES" ? index == 3 : (this.props.clientId == '4599' || this.props.clientId == 4599) || (this.props.clientId == '5742' || this.props.clientId == 5742) ? index == 1 || index == 2 : ''}
                                                                    onClick={() => this.selectMenu(index, dataIndex, option)}
                                                                    style={{ fontWeight: 500 }}
                                                                >
                                                                    {option}
                                                                </MenuItem>
                                                            );
                                                        })}
                                                    </div>
                                                }
                                            </Menu>
                                        </React.Fragment>
                                    )}
                                </PopupState>
                            </div>
                        );
                    }
                }
            }
        ];
    }

    transactionColumn = [
        {
            label: "Date", name: "createdDate", options: {
                customBodyRenderLite: (dataIndex) => {
                    if (this.state.transactionData.length > 0 && this.state.transactionData[dataIndex].createdDate) {
                        return (moment(this.state.transactionData[dataIndex].createdDate).format('MMMM DD, YYYY'));
                    } else {
                        return ('-');
                    }
                }
            }
        },
        { label: "Transaction ID", name: "transactionId" },
        { label: "Type", name: "indicatorFlag" },
        { label: "Payment Type", name: "type" },
        {
            label: "Amount", name: "transactionAmount", options: {
                customBodyRenderLite: (dataIndex) => {
                    if (this.state.transactionData.length > 0 && this.state.transactionData[dataIndex].transactionAmount) {
                        return ('$ ' + this.state.transactionData[dataIndex].transactionAmount);
                    } else {
                        return ('-');
                    }
                }
            }
        },
        { label: "Authorization", name: "authorizationMessage" },
        { label: "Payment Number", name: "paymentNumber" },
        { label: "Description", name: "reason" },
    ]

    loginColumn = [
        { label: "Email", name: "email" },
        { label: "Last Logged In", name: "lastLoggedin" },
        { label: "IP Origin", name: "ipOrigin" },
    ]

    reAssignHistoryColumn = [
        {
            label: "Date Assigned", name: "createdDate", options: {
                customBodyRenderLite: (dataIndex) => {
                    if (this.state.reassignHistoryData.length > 0 && this.state.reassignHistoryData[dataIndex].createdDate) {
                        return (moment(this.state.reassignHistoryData[dataIndex].createdDate).format('LL'));
                    } else {
                        return ('-');
                    }
                },
              

            }
        },
       
        { label: "Agent", name: "newBrokerId" },
        { label: "Agent Id", name: "newBrokerId" },
        { label: "", name: "" },
        { label: "", name: "" },
        
      
    ]



    handleOk = () => {
        axios.get(configurations.baseUrl + '/agentlogin/deleteUser/' + this.state.delById)
            .then(response => {
                if (response.status === 200) {
                    this.setState({
                        deleteModal: false,
                        msgModal: true,
                        errMsg: 'Delete Successfully !',
                        loaderShow: false,
                        userName: ""
                    }, () => this.getUserData(this.state.empid))
                }
                // if(response.status === 500){
                //     this.setState({
                //         loaderShow: false,
                //         showCommonErrorModal: true,
                //     });
                // }
            })
    }

    handleKeyDown = (e) => {
        if (e.key === "Enter" && !e.shiftKey && !e.altKey) {
            e.preventDefault(); // prevent newline
            this.handleAddNote();
        }
    };


    refreshTable = (val) => {
        if (this.props.enrollmentFilter === "members") {
            // Members tab uses Fabric search; refresh should reset filters and load the default dataset
            // (clientId + Active status only).
            this.setState({
                prospectObj: [],
                downloadFinalArr: [],
                searchTypeValue: '5',
                searchShow: false,
                searchText: '',
                statusValue: '',
                userStatusValue: '',
                targetDate: null,
                membersFromDate: null,
                membersToDate: null,
                membersSelectedPlanCode: '',
                fabricMembersSort: 'status',
                page: 0,
                rowsPerPage: 10,
                loaderShow: !!val,
                circleloaderShow: !val,
                selectedStatus: process.env.REACT_APP_PORTAL !== 'employer' ? ['DQ', 'PC'] : ['AC'],
                isDefaultLoad: true,
                fallbackToActive: false,
                fabricMembersSort: 'status',
                membersSortOrderName: 'status',
                membersSortOrderDirection: 'asc'
            }, () => {
                this.fetchMembersFromFabric({ page: 0, rows: 10 });
            });
            return;
        }

        this.setState({ 
            prospectObj : [],
            downloadFinalArr :[],
            searchTypeValue: '',
            searchShow: true,
            searchText: '',
            statusValue: '',
            userStatusValue: '',
            targetDate: null,
            page: 0,
            loaderShow: !!val,
            circleloaderShow: !val,
        }, () => {
            if (this.props.defaultEmpid !== this.state.empid) {
                let evt = new CustomEvent('REFRESH', { detail: this.state.empid });
                window.dispatchEvent(evt);
            }
            this.getUserData(this.state.empid);
        })
    }

    handleChange = (event, newValue) => {
        this.setState({
            circleloaderShow: true
        });

        if (newValue === 0) {
            this.setState({ viewUserData: [], transactionData: [], loginData: [], reassignHistoryData: [], transCount: 0, loginCount: 0, reassignHistoryCount: 0 });
            this.getUSerDetails(this.state.detailsData.id, this.state.detailsData.email, this.state.detailsData.enrollFlag);
        } else if (newValue === 1) {
            this.setState({ viewUserData: [], transactionData: [], loginData: [], reassignHistoryData: [], transCount: 0, loginCount: 0, reassignHistoryCount: 0 });
            this.getTransactionDetails(this.state.detailsData.memberIdSource);
        } else if (newValue === 3) {
            this.setState({ viewUserData: [], transactionData: [], loginData: [], reassignHistoryData: [], transCount: 0, loginCount: 0, reassignHistoryCount: 0 });
            this.getNotes(this.state.detailsData.id)
        }else if (newValue === 2) {
            this.setState({ viewUserData: [], transactionData: [], loginData: [], reassignHistoryData: [], transCount: 0, loginCount: 0, reassignHistoryCount: 0 });
            this.getReassignHistory(this.state.detailsData.id)
        }
        this.setState({
            activeTab: newValue
        });
    }

    handleChangeStatus = (event) => {
        const value = event.target.value;
        
        // Clean out blank strings from multi-select tracking
        let cleanStatuses = Array.isArray(value)
            ? value.filter(status => status && String(status).trim() !== "")
            : [value].filter(status => status && String(status).trim() !== "");

        // Reset gracefully back to default prioritized views instead of sending a blank object block
        if (cleanStatuses.length === 0) {
            cleanStatuses = ['DQ', 'PC'];
        }

        this.setState({
            selectedStatus: cleanStatuses
        }, () => {
            this.searchRecord();
        });
    };
    // ---------------- Re-assign Agent -----------------------
    getAllAgents =(selectedMemberId)=> {
        axios.get(process.env.REACT_APP_BASE_URL + "/agentlogin/reassignAgentList/"+ selectedMemberId)
                .then((response) => {
                    console.log("======== getAllAgents ========");
                    console.log(response);
                    if(response && response.data.response.length > 0){
                        let arr = [];
                        response.data.response.forEach(obj =>{
                            let getName = obj.firstName +" "+ obj.lastName;
                            let fullname = getName.replace(/\b\w/g, l => l.toUpperCase());
                            arr.push({key :fullname +" ("+ obj.brokerId +") ", value : obj.brokerId})
                        })
                        this.setState({
                            agentList: arr,
                            loaderShow: false,
                            reAssignAgentModal: true
                        })
                    }else {
                        this.setState({
                            msgModal: true,
                            loaderShow: false,
                            errMsg: "No Agent Available to Re-assign"
                        })
                    }   
                })
                .catch(error => {
                    console.log(error);
                    console.log(error.response);
                    // if (error.response.status === 500) {
                        // this.setState({
                        //     loaderShow: false,
                        //     successModal: true,
                        //     popUpMsg: "Oops! Something's not right. If you're still having trouble, call us on (800) 921-4505",
                        // });
                        this.setState({
                            loaderShow: false,
                            // showCommonErrorModal: true,
                        });
                    // }
                });
    }    
    setAgent = (value, isValid, parentDetails) =>{
        if(isValid){
            this.state[parentDetails.name] = value;
        } else {
            this.state[parentDetails.name] = "";
        }

        this.setState({
            refresh : true
        })
    }
    submitReAssignAgent = () => {
        console.log(this.state.selectedAgent);
        let findObj = this.state.agentList.find(obj => obj.value === this.state.selectedAgent);
        if(findObj){
            this.setState({selecetedAgentName: findObj.key.split('(')[0]});
        }
        
        let dataObj = {            
            "memberId":this.state.selectedMemberId,
            "brokerId":this.state.selectedAgent
        }

        axios.post(process.env.REACT_APP_BASE_URL + '/agentlogin/reassignProspect', dataObj)
            .then(response => {
                console.log("======== submitReAssignAgent ========");
                console.log(response);
                if (response.data.code === 200) {    
                    this.setState({
                        loaderShow: false,
                        agentList: [],
                        selectedAgent: '',
                        reAssignAgentModal: false,
                        msgModal: true,
                        reAssignSuccess: true,
                        errMsg: '',
                    });

                    this.refreshTable()

                }
                // if(response.data.code === 500){
                //     this.setState({
                //         loaderShow: false,
                //         showCommonErrorModal: true,
                //     });
                // }
            })
            .catch(error => {
                console.log(error);
                console.log(error.response);
                // if (error.response.status === 500) {
                    // this.setState({
                    //     loaderShow: false,
                    //     successModal: true,
                    //     popUpMsg: "Oops! Something's not right. If you're still having trouble, call us on (800) 921-4505",
                    // });
                    this.setState({
                        loaderShow: false,
                        // showCommonErrorModal: true,
                    });
                // }
            });
                


      
    }

     // click OK button -------------------------------

     uploadExcelOkBtn = () => {
        this.setState({ 
            validationExcelModal: false, 
            loaderShow: false,
            validationArr:[], 
            excelValidation: false,
            inValidRecordData:[]
        });
        this.refreshTable()
    }
    handleDownloadCSV = async () => {
        let data = [];
        const { checkADDons } = this.state;
        const { employerName, clientName, agentId } = this.props;
        const isMembersTab = this.props.enrollmentFilter === "members";
        const allCols = isMembersTab ? this.getMembersColumns() : this.columns;
        const isEmployerFlow = sessionStorage.getItem('EMPLOYER_FLOW') === "YES";
        if (!isMembersTab) {

            formData.set("start", "0");
            formData.set("length", "0");
            const response = await fetch(this.getUserByAgentUrl(false), requestOptions);
            const rowsData = await response.json();
            if (rowsData.response && rowsData.response.data) {
                data = rowsData.response.data;
            }

        } else {
            const params = this.buildFabricMembersParams({ page: 0, rows: 0 });
            const response = await searchEnrolledMembers(params);
            const rowsData = Array.isArray(response?.data) ? response.data : [];
            data = rowsData;
        }

        const cols = allCols.filter((col) => {
            // Always remove 'Actions'
            if (col.name === "Actions") return false;
            
            // Conditionally remove 'record' if it's the employer flow
            if (!isEmployerFlow && col.name === "record") return false;
            
            return true;
        });

        // Mirror the customBodyRenderLite logic for Status so the CSV matches the table.
        const getProspectStatus = (row) => {
            if (!row) return '';
            if (row.enrollFlag === true) return 'App Success';
            switch (row.completionStatus) {
                case 0: return 'Instructions';
                case 1: return 'Setup Family';
                case 2: return 'View Quote';
                case 3: return 'Check Eligibility';
                case 4: return 'Select Program';
                case 5: return checkADDons ? 'Select Add-Ons' : 'Review Choices';
                case 6: return checkADDons ? 'Review Choices' : 'Setup Payment';
                case 7: return checkADDons ? 'Setup Payment' : 'Submit Application';
                case 8: return 'Submit Application';
                case 9: return 'Submit Application';
                default: return 'NA';
            }
        };

        const getMemberStatus = (row) => {
            const userStatus = (row && row.status ? row.status : '').toString().toUpperCase();
            if (userStatus === 'TE' || userStatus === 'TERMINATED') return 'TERMINATED';
            if (userStatus === 'AC' || userStatus === 'ACTIVE') return 'ACTIVE';
            if (userStatus === 'DQ' || userStatus === 'DELINQUENT') return 'DELINQUENT';
            if (userStatus === 'PC' || userStatus === 'PRE-CANCEL') return 'PRE-CANCEL';
            if (userStatus === 'IN' || userStatus === 'INACTIVE') return 'INACTIVE';
            return (row && row.status) ? row.status : 'NA';
        };

        const getHeader = (col) => {
            // The inviteStatus column has no label in the table; use the user-facing header.
            if (col.name === 'inviteStatus') return 'Last Authorization Sent';
            return col.label || col.name;
        };

        const getCellValue = (row, col) => {
            if (!row) return '';
            switch (col.name) {
                case 'status':
                    return isMembersTab ? getMemberStatus(row) : getProspectStatus(row);
                case 'inviteStatus':
                    return row.inviteStatus
                        ? moment(row.inviteStatus).format('MMM DD, YYYY hh:mm A')
                        : 'NA';
                case 'createdDate':
                    return row.createdDate ? moment(row.createdDate).format('MMMM DD, YYYY') : '';
                case 'firstName':
                    if (!isMembersTab) {
                        if (row.firstName && row.lastName) {
                            return `${row.prefix || ''} ${row.firstName || ''} ${row.middleName || ''} ${row.lastName || ''} ${row.suffix || ''}`
                                .replace(/\s+/g, ' ')
                                .trim();
                        }
                        return 'NA';
                    }
                    return row.firstName ?? '';
                case 'memberFirstName':
                    return row.firstName ?? '';
                case 'memberLastName':
                    return row.lastName ?? '';
                case 'daysInStatus':{
                    const value = row?.daysInStatus;
                    return value === 0 || value == null ? '-' : value;
                }
                case 'daysToTermination': {
                    const value = row?.daysToTermination;
                    return value === 0 || value == null ? '-' : value;
                }
                default:
                    return row[col.name] ?? '';
            }
        };

        const escapeCSV = (value) => {
            if (value === null || value === undefined) return '';
            return String(value).replace(/"/g, '""');
        };

        // Prepare worksheet data
        const worksheetData = [
            cols.map(col => getHeader(col)),
            ...data.map(row =>
                cols.map(col => getCellValue(row, col))
            )
        ];

        // Create workbook
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            isMembersTab ? "Members" : "Prospects"
        );

        // Auto-size columns
        worksheet["!cols"] = cols.map(col => ({
            wch: Math.max(
                getHeader(col).length,
                ...data.map(row =>
                    String(getCellValue(row, col) || "").length
                )
            ) + 2
        }));

        const fileName = `${
            isEmployerFlow
                ? (employerName || "Employer").replace(/[<>:"/\\|?*]+/g, "")
                : `${(clientName || "Member").replace(/[<>:"/\\|?*]+/g, "")}_${(agentId || "Member").replace(/[<>:"/\\|?*]+/g, "")}`
        } ${moment().format("MMM DD, YYYY")}.xlsx`;

        XLSX.writeFile(workbook, fileName);
    };
    formatDateTime = (isoString) => {
        const date = new Date(isoString);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        const hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const formattedHour = hours % 12 || 12;

        return `${month}/${day}/${year} ${formattedHour}:${minutes}${ampm}`;
    };


    render() {

        const isMembersTab = this.props.enrollmentFilter === "members";
        const membersLastColIndex = isMembersTab ? (this.getMembersColumns().length - 1) : null;

        const options = {
            sort: true,
            selectableRows: false,
            filter: false,
            selectableRowsHeader: false,
            count: this.state.count,
            rowsPerPage: this.state.rowsPerPage,
            // Use max-height scrolling so header never participates in scroll area
            tableBodyHeight: 'calc(-319px + 100vh)',
            search: false,
            serverSide: true,            
            viewColumns: false,
            print: false,
            fixedHeader: true,
            responsive: "standard",
            textLabels: {
                body: {
                    noMatch: "There are no records to display.",
                },
            },
            sortOrder:
                isMembersTab && this.state.membersSortOrderName && this.state.membersSortOrderDirection
                    ? { name: this.state.membersSortOrderName, direction: this.state.membersSortOrderDirection }
                    : undefined,
            page: this.state.page,
            download: false,
            downloadOptions: {
                filename: this.props.employerName +' '+ moment().format("MMM DD, YYYY")+'.csv',
                customToolbar: () => {
                    if (sessionStorage.getItem('EMPLOYER_FLOW') !== "YES") return null;
                
                    return (
                      <Tooltip title="Download CSV">
                        <IconButton onClick={() => this.tableRef.current.downloadCSV()}>
                        
                        </IconButton>
                      </Tooltip>
                    );
                  }

            },
            onTableChange: (action, tableState) => {
                console.log('============ onTableChange ================');
                console.log(action);
                console.log(tableState);
                switch (action) {
                    case 'changePage':
                        this.changePage(tableState.page, tableState.rowsPerPage);
                        break;
                    case 'changeRowsPerPage':
                        this.changePage(tableState.page, tableState.rowsPerPage);
                        break;
                    case 'sort': {
                        // Ensure sort works consistently in serverSide mode
                        const sortName = tableState?.sortOrder?.name;
                        const sortDir = tableState?.sortOrder?.direction;
                        if (!sortName || !sortDir) break;
                        if (isMembersTab) {
                            this.sortMembersFabric(sortName, sortDir);
                        } else {
                            // Reuse existing prospects sort mapping via onColumnSortChange logic
                            let order = sortDir === 'asc' ? 'asc' : 'desc';
                            let columnIndex = '0';
                            if (sortName === "createdDate") {
                                columnIndex = '1';
                            } else if (sortName === 'email') {
                                columnIndex = '2';
                            } else if (sortName === 'firstName') {
                                columnIndex = '4';
                            } else if (sortName === 'record') {
                                columnIndex = '8';
                            }
                            this.sort(columnIndex, order);
                        }
                        break;
                    }
                    default:
                        break;
                }
            },
            onDownload: (buildHead, buildBody, columns, data) => {

                const fields = [{
                    label: 'Record #',
                    value: 'recordNo'
                }, {
                    label: 'Relationship',
                    value: 'relationship'
                }, {
                    label: 'First Name',
                    value: 'prospectFname'
                }, {
                    label: 'Last Name',
                    value: 'prospectLname'
                },
                {
                    label: 'Date of Birth',
                    value: 'dob'
                },
                {
                    label: 'Age',
                    value: 'Age'
                },
                {
                    label: 'Birth Gender',
                    value: 'birthGender'
                },
                {
                    label: 'Zip',
                    value: 'zipcode'
                },
                {
                    label: 'Email Address',
                    value: 'email'
                },
                {
                    label: 'Phone',
                    value: 'phone'
                },
                ];

                const csv = json2csv(this.state.downloadFinalArr, { fields });

                return csv
            },
            onColumnSortChange: (changedColumn, direction) => {
                if (isMembersTab) {
                    this.sortMembersFabric(changedColumn, direction);
                    return;
                }
                // this.setState({
                //     loaderShow: true
                // });
                let order = 'desc';
                if (direction === 'asc') {
                    order = 'asc';
                }
                let columnIndex = '0';
                if (changedColumn === "createdDate") {
                    columnIndex = '1';
                } else if (changedColumn === 'email') {
                    columnIndex = '2';
                } else if (changedColumn === 'firstName') {
                    columnIndex = '4';
                }else if (changedColumn === 'record') {
                    columnIndex = '8';
                }
                this.sort(columnIndex, order);
            },

            onCellClick: (cellIndex, rowIndex, rowMeta) => {//Namita 23 april
                console.log(rowIndex.colIndex)
                if (isMembersTab) {
                    // Keep same behavior as Prospects: clicking a row opens details, except on the Action column.
                    if (rowIndex.colIndex === membersLastColIndex) {
                        return;
                    }
                    if (rowIndex.colIndex) {
                        this.openMemberDetailsPlugin(this.state.data[rowIndex.dataIndex]);
                    }
                    return;
                }
                if (rowIndex.colIndex && rowIndex.colIndex !== 6 ) {
                    this.openMemberDetailsPlugin(this.state.data[rowIndex.dataIndex]);
                }
            },
            /*customToolbar: () => {
               return <div style={{flexGrow:1}}>
               <Grid container direction="row"
                     justify="center"
                     alignItems="center" spacing={2} >{/!*style={{marginTop:'1%',marginBottom:'1%',marginLeft:'0%'}} *!/}
               {/!*<Grid item xs={12} sm={2} >style={{marginLeft:'-18%',marginRight:'139px'}}
                  <Typography  style={{fontSize:'21px',fontWeight:'bold',width:'200px',marginTop:'13px',marginLeft:'60px',marginRight:'25px'}}> Active Employees</Typography>
               </Grid>*!/}
               <Grid item xs={3} sm={3} > {/!*style={{marginLeft:'10px'}} *!/}
               <FormControl  style={customStyle.formControlStyle}>
               <InputLabel  style={{textAlign:'left'}}>Search By</InputLabel>
                <Select
                    label="Search By"
                    name="name"
                    style={customStyle.searchByStyle}
                    value={this.state.searchTypeValue}
                    onChange={(event) =>this.handleChageSearchType(event)}
                 >
                    <MenuItem value='0' >Date Added</MenuItem>
                    <MenuItem value='1' >{ sessionStorage.getItem('EMPLOYER_FLOW') === "YES" ? "Employee Name" : "Prospect Name" }</MenuItem>
                    <MenuItem value='2' >Email</MenuItem>
                    <MenuItem value='3' >Status</MenuItem>
    
                </Select>
                </FormControl>
               </Grid>
               <Grid item xs={4} sm={4} >{/!*style={{marginLeft:'-10px'}}*!/}

{
    this.state.searchTypeValue === '0'?
    
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                   <KeyboardDatePicker
                //    required
                   autoComplete='off'
                   margin="none"
                   label="Select Date"
                   format="MMMM dd,yyyy"
                   value={this.state.targetDate}
                   onFocus={e => e.target.blur()}
                   style={{width:'100%',marginTop:'-9px',marginLeft:'9%',marginRight:'2%',padding:'0px'}}
                   inputProps={{style: {fontSize:'12.8px', fontFamily: "Roboto, Arial, Helvetica, sans-serif",marginTop:'10px',
                                //    paddingLeft:'7px'
                                }}}
                   InputLabelProps={{style:{paddingRight:10,paddingTop:12,color: 'grey'}}}
                   onChange={(event)=>this.handleDate(event)}
                   variant="filled"
                   KeyboardButtonProps={{
                       'aria-label': 'change date',
                   }}
                   views={["year", "month", "date"]}
                    openTo="year"
                   minDate={new Date('01/01/2020')}
               />
           </MuiPickersUtilsProvider>
       :

       this.state.searchTypeValue === '3'?
        <FormControl  style={customStyle.formControlStyle1}>
            <InputLabel id="demo-simple-select-label" style={{}}
            >Select status</InputLabel>
            <Select name="name" style={customStyle.searchByStyle} value={this.state.statusValue} onChange={(event) =>this.statusChange(event)}>
                <MenuItem value='all'>All Status</MenuItem>
                <MenuItem value='true'>Enrolled</MenuItem>
                <MenuItem value='0' >Instructions</MenuItem>
                <MenuItem value='1' >Set up Family</MenuItem>
                <MenuItem value='2' >View Quote</MenuItem>
                <MenuItem value='3' >Check Eligibility</MenuItem>
                <MenuItem value='4' >Select Program</MenuItem>
                <MenuItem value='5' >Select Add-Ons</MenuItem>
                <MenuItem value='6' >Setup Payment</MenuItem>
                <MenuItem value='7' >Submit Application</MenuItem>
            </Select>
        </FormControl>
        :
        <TextField style={customStyle.textFieldStyle}
            value={this.state.searchText}
            disabled={this.state.searchShow}
            onChange={(event)=>this.setSearch(event)}></TextField>        

        }

</Grid>

                   <Grid item xs={1} sm={1}>
                    <CrudButton color="secondary" style={{marginTop:'7px',boxShadow:'none',width:'46px',height:'46px'}} aria-label="search" disabled={this.state.searchText==''||this.state.targetDate==''} onClick={()=>this.searchRecord()} >
                       <SearchIcon />
                   </CrudButton>
                   </Grid>
                   <Grid item xs={1} sm={1}>
               <CrudButton color="primary" aria-label="add" style={{width:'46px',height:'46px',boxShadow:'none',marginTop:'7px',marginLeft:'3%',backgroundColor:'#e10050'}} onClick={()=>this.addUserModal()} >
               <AddIcon />
               </CrudButton>
               </Grid>
               <Grid item xs={2} sm={1}>
               <CrudButton style={{boxShadow:'none',width:'46px',height:'46px',marginTop:'7px', backgroundColor : '#41b5c2'}} onClick={this.refreshTable}><RefreshIcon /></CrudButton>
               </Grid>
               </Grid>
              </div>
            },*/
            onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => {
                this.state.rowIndex = rowsSelected;
            }

        };
        
        const filterSearch = {
            '0': "Date Added",
            '1': sessionStorage.getItem('EMPLOYER_FLOW') === "YES" ? "Employee Name" : isMembersTab ? "Member Name" : "Prospect Name",
            '2': "Email",
            '3': "Status",
            '4': "User Status",
            '5': "Member ID",
            '6': "Member First Name",
            '7': "Member Last Name",
            '9': "Program Name",
            '10': "Program Begin Date",
            '14': "Paid Through Date",
            '15': "Program End Date",
            '16': "Cancellation Requested Date",
        }
        const transactionOption = {
            selectableRows: false,
            filter: false,
            selectableRowsHeader: false,
            count: this.state.activeTab === 1 ? this.state.transCount : this.state.activeTab === 2 && this.state.loginCount,
            rowsPerPage: 10,
            search: false,
            serverSide: false,
            download: false,
            viewColumns: false,
            print: false,
            fixedHeader: true,
            textLabels: {
                body: {
                    noMatch: "There are no records to display.",
                },
            }
        };

        const reAssignHistoryOption = {
            selectableRows: false,
            filter: false,
            selectableRowsHeader: false,
            count: this.state.reassignHistoryCount,
            rowsPerPage: 10,
            search: false,
            serverSide: false,
            download: false,
            viewColumns: false,
            print: false,
            fixedHeader: true,
            textLabels: {
                body: {
                    noMatch: "There are no records to display.",
                },
            }
        };

        let currentScreen = '';
        if (this.state.activeTab === 0) {
            currentScreen = <div style={{ margin: '15px', borderTop: '1px solid rgba(0, 0, 0, 0.12)', borderBottom: '1px solid rgba(0, 0, 0, 0.12)', fontFamily: "Roboto, Arial, Helvetica, sans-serif", marginTop:61, height:500 }}>
                <Grid item sm={12} xs={12} md={12} lg={12} >
                    {
                        this.state.viewUserData.length > 3 ?
                            this.state.viewUserData.map((row, index, key) => (
                                row.type === 'STR' ?
                                    <div style={{ display: 'flex', borderBottom: '1px solid rgba(0, 0, 0, 0.12)', padding: '10px' }}>
                                        <Grid item xs={3} key={index} sm={3} md={3} lg={2}>
                                            {row.key}
                                        </Grid>
                                        <Grid item xs={3} sm={6} md={6} lg={6} key={index + 'gd'} style={{ fontWeight: 'bold' }}>
                                            {row.value}
                                        </Grid>
                                    </div>
                                    :
                                    row.type === 'ARR' && this.props.clientId != '4599' && this.props.clientId != '5742' &&
                                    <div style={{ display: 'flex', borderBottom: '1px solid rgba(0, 0, 0, 0.12)', padding: '10px' }}>
                                        <Grid item xs={3} key={index + 'sm'} sm={3} md={3} lg={2}>
                                            {row.key}
                                        </Grid>
                                        <Grid item xs={3} sm={6} md={6} lg={6} key={index + 'li'} style={{ fontWeight: 'bold' }}>
                                            {
                                                row.value.length > 0 ?
                                                    <ul style={{ listStyleType: 'none', padding: 0 }}>
                                                        {
                                                            row.value.map((childRow) => (
                                                                <li style={{ width: '100%' }}>
                                                                    <span style={{ float: 'left', width: '50%' }}>{`${childRow.prefix || ""} ${childRow.firstName || ""} ${childRow.middleName || ""} ${childRow.lastName || ""} ${childRow.suffix || ""}`}</span>
                                                                    <span style={{ float: 'right', width: '50%' }}>{childRow.relation}</span>
                                                                </li>
                                                            ))
                                                        }
                                                    </ul>
                                                    :
                                                    <span>NA</span>

                                            }

                                        </Grid>
                                    </div>
                            ))
                            :
                            <div>
                                {
                                    this.state.viewUserData.map((row, index, key) => (
                                        <div style={{ display: 'flex', borderBottom: '1px solid rgba(0, 0, 0, 0.12)', padding: '10px' }}>
                                            <Grid item xs={3} key={index} sm={3} md={3} lg={2}>
                                                {row.key}
                                            </Grid>
                                            <Grid item xs={3} sm={6} md={6} lg={6} key={index + 'gd'} style={{ fontWeight: 'bold' }}>
                                                {row.value}
                                            </Grid>
                                        </div>
                                    ))
                                }
                                <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'center', display: this.state.detailsData.enrollFlag ? 'block' : 'none' }}>
                                    <span style={{ fontWeight: 'bold' }}>Member onboarding in progress
                                       <br />
                                        If it's more than two business days since enrollment, please call agent support: 800-921-4505 option 3.
                                   </span>
                                </Grid>
                            </div>

                    }
                </Grid>
            </div>
        } else if (this.state.activeTab === 1) {
            currentScreen = <Grid item sm={6} xs={6} md={12} lg={12} style={{ fontFamily: "Roboto, Arial, Helvetica, sans-serif", marginTop:61, minHeight:"350px" }}>
                {/* <MuiThemeProvider theme={this.getMuiThemeTran()}>
                    <MUIDataTable
                        //title={"Active Prospects"}
                        data={this.state.transactionData}
                        columns={this.transactionColumn}
                        options={transactionOption}
                    />
                </MuiThemeProvider>
                 */}

<TransactionTable  tableData={this.state.transactionData} clientId = {this.props.clientId}/>
            </Grid>
        } else if (this.state.activeTab === 3) {
            currentScreen = (
                <Grid item sm={12} xs={12} md={12} lg={12} style={{ fontFamily: "Roboto, Arial, Helvetica, sans-serif", padding: "16px", marginTop:61, minHeight:"350px"  }}>
                    <div
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            padding: "16px",
                            backgroundColor: "#f9f9f9",
                            height: "47vh",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >

                        <div
                            ref={this.notesContainerRef}
                            style={{
                                flexGrow: 1,
                                overflowY: "auto",
                                marginBottom: "16px",
                                paddingRight: "8px",
                            }}
                        >
                            {this.state.notesError != "" ? (
                                <p style={{ color: "#777" }}>{this.state.notesError}</p>
                            ) : (
                                <ul style={{ listStyle: "none", padding: 0 }}>
                                    {this.state.notes?.map((note, index) => (
                                        <li
                                            key={index}
                                            style={{
                                                marginBottom: "12px",
                                                padding: "8px",
                                                backgroundColor: "#fff",
                                                borderRadius: "4px",
                                                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "flex-start",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    fontSize: "14px",
                                                    marginBottom: "4px",
                                                    maxWidth: "85%",
                                                    overflowWrap: "anywhere"
                                                }}
                                                dangerouslySetInnerHTML={{ __html: note.note.replace(/\n/g, "<br />") }}
                                            />
                                            <div style={{ fontSize: "12px", color: "#999", textAlign: "end" }}>
                                                {this.formatDateTime(note.createdTime)}
                                            </div>
                                        </li>
                                    ))}
                                    <div ref={this.notesEndRef} />
                                </ul>
                            )}
                        </div>

                        <div style={{ display: "flex", flexDirection: "column", gap: "4px", paddingTop: "8px", borderTop: "1px solid #ccc" }}>
                            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                <textarea
                                    placeholder="Press Enter for a new line"
                                    value={this.state.noteInput}
                                    maxLength={125}
                                    onChange={this.handleInputChange}
                                    // onKeyDown={this.handleKeyDown}
                                    style={{
                                        flexGrow: 1,
                                        padding: "8px",
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                        resize: "none",
                                        height: "80px",
                                        fontFamily: "inherit"
                                    }}
                                />
                                <CustomButton
                                    style={{ margin: 0, marginRight: 10, width: 95, height: 40 }}
                                    disabled={this.state.noteInput.trim() === ""}
                                    onClick={this.handleAddNote}
                                >
                                    ADD
                                </CustomButton>
                            </div>
                            {this.state.noteError && (
                                <div style={{ color: "red", fontSize: "12px" }}>
                                    {this.state.noteError}
                                </div>
                            )}
                        </div>
                    </div>
                </Grid>
            );
        } else if (this.state.activeTab === 2) {
            currentScreen = <Grid item sm={6} xs={6} md={12} lg={12} style={{ fontFamily: "Roboto, Arial, Helvetica, sans-serif", marginTop:61, minHeight:"350px" }}>
                <MuiThemeProvider theme={this.getMuiThemeTran()}>
                    <MUIDataTable
                        //title={"Active Prospects"}
                        data={this.state.reassignHistoryData}
                        columns={this.reAssignHistoryColumn}
                        options={reAssignHistoryOption}
                    />
                </MuiThemeProvider>

            </Grid>
        }

        return (
            <div style={{ minHeight: 400, background: "#fff"}}>
                {
                    this.state.circleloaderShow ? <>
                        <Loader/>
                    </> : ''
                }
                <div style={{ flexGrow: 1, boxShadow: 'none' }}>
                    <Grid container style={{ padding: '10px', background :"#d5d6e9" }}>
                        {/* <Grid item xs={3} sm={3}>
                            <Typography style={{ fontSize: '21px', fontWeight: 'bold', padding: '10px' }}> {sessionStorage.getItem('EMPLOYER_FLOW') === "YES" ? "Active Employees" : "Active Prospects"}</Typography>
                        </Grid> */}
                        <Grid item xs={sessionStorage.getItem('EMPLOYER_FLOW') === "YES" ? 6 : 7} sm={sessionStorage.getItem('EMPLOYER_FLOW') === "YES"  ? 6 : 7} >
                            <Grid container>
                                <Grid item xs={4} sm={4} > {/*style={{marginLeft:'10px'}} */}
                                    <FormControl variant="filled" style={customStyle.formControlStyle} className="agent-search-by-select">
                                        <InputLabel style={{ textAlign: 'left', fontSize: 14 }}>Search By</InputLabel>
                                        <Select
                                            label="Search By"
                                            name="name"
                                            value={this.state.searchTypeValue}
                                            onChange={(event) => this.handleChageSearchType(event)}
                                            MenuProps={{
                                                getContentAnchorEl: null,
                                                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                                                transformOrigin: { vertical: 'top', horizontal: 'left' },
                                            }}
                                        >
                                            {!isMembersTab && <MenuItem value='0' >Date Added</MenuItem>}
                                            {!isMembersTab && <MenuItem value='1' >{sessionStorage.getItem('EMPLOYER_FLOW') === "YES" ? "Employee Name" : "Prospect Name"}</MenuItem>}
                                            {!isMembersTab && <MenuItem value='2' >Email</MenuItem>}
                                            {!isMembersTab && <MenuItem value='3' >Status</MenuItem>}

                                            {isMembersTab && <MenuItem value='5' >Member ID</MenuItem>}
                                            {isMembersTab && <MenuItem value='6' >Member First Name</MenuItem>}
                                            {isMembersTab && <MenuItem value='7' >Member Last Name</MenuItem>}
                                            {isMembersTab && <MenuItem value='9' >Program Name</MenuItem>}
                                            {isMembersTab && <MenuItem value='10' >Program Begin Date</MenuItem>}
                                            {isMembersTab && <MenuItem value='14' >Paid Through Date</MenuItem>}
                                            {isMembersTab && <MenuItem value='15' >Program End Date</MenuItem>}
                                            {isMembersTab && <MenuItem value='16' >Cancellation Requested Date</MenuItem>}

                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid
                                    item
                                    xs={isMembersTab && ['10', '14', '15', '16'].includes(this.state.searchTypeValue) ? 7 : 4}
                                    sm={isMembersTab && ['10', '14', '15', '16'].includes(this.state.searchTypeValue) ? 7 : 4}
                                >{/*style={{marginLeft:'-10px'}}*/}

                                    {
                                        this.state.searchTypeValue === '0' ||
                                        (isMembersTab && ['10', '14', '15', '16'].includes(this.state.searchTypeValue)) ?

                                            (isMembersTab && ['10', '14', '15', '16'].includes(this.state.searchTypeValue)) ? (
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%' }}>
                                                    <div style={{ flex: 1, minWidth: 150 }}>
                                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                        <KeyboardDatePicker
                                                            fullWidth
                                                            autoComplete='off'
                                                            margin="none"
                                                            label="From Date"
                                                            format="MMMM dd,yyyy"
                                                            value={this.state.membersFromDate}
                                                            onFocus={e => e.target.blur()}
                                                            inputProps={{
                                                                style: {
                                                                    backgroundColor: 'white',
                                                                    fontSize: '15.8px',
                                                                    fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                                                                    width: '100%'
                                                                }
                                                            }}
                                                            inputVariant="filled"
                                                            InputLabelProps={{ style: { paddingRight: 10, paddingTop: 0, color: 'grey', width: '100%' } }}
                                                            onChange={(event) => this.handleMembersFromDate(event)}
                                                            variant="filled"
                                                            KeyboardButtonProps={{
                                                                'aria-label': 'change date',
                                                            }}
                                                            views={["year", "month", "date"]}
                                                            openTo="year"
                                                            minDate={new Date('01/01/2020')}
                                                            maxDate={this.state.membersToDate ? new Date(this.state.membersToDate) : undefined}
                                                        />
                                                    </MuiPickersUtilsProvider>
                                                    </div>
                                                    <div style={{ color: '#2f3192', fontWeight: 700, marginTop: 2 }}>to</div>
                                                    <div style={{ flex: 1, minWidth: 150 }}>
                                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                        <KeyboardDatePicker
                                                            fullWidth
                                                            autoComplete='off'
                                                            margin="none"
                                                            label="To Date"
                                                            format="MMMM dd,yyyy"
                                                            value={this.state.membersToDate}
                                                            onFocus={e => e.target.blur()}
                                                            inputProps={{
                                                                style: {
                                                                    backgroundColor: 'white',
                                                                    fontSize: '15.8px',
                                                                    fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                                                                    width: '100%'
                                                                }
                                                            }}
                                                            inputVariant="filled"
                                                            InputLabelProps={{ style: { paddingRight: 10, paddingTop: 0, color: 'grey', width: '100%' } }}
                                                            onChange={(event) => this.handleMembersToDate(event)}
                                                            variant="filled"
                                                            KeyboardButtonProps={{
                                                                'aria-label': 'change date',
                                                            }}
                                                            views={["year", "month", "date"]}
                                                            openTo="year"
                                                            minDate={this.state.membersFromDate ? new Date(this.state.membersFromDate) : new Date('01/01/2020')}
                                                        />
                                                    </MuiPickersUtilsProvider>
                                                    </div>
                                                </div>
                                            ) : (
                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                    <KeyboardDatePicker
                                                        //    required
                                                        fullWidth
                                                        autoComplete='off'
                                                        margin="none"
                                                        label="Select Date"
                                                        format="MMMM dd,yyyy"
                                                        value={this.state.targetDate}
                                                        onFocus={e => e.target.blur()}
                                                        /*style={{width:'100%',marginTop:'-9px',marginLeft:'9%',marginRight:'2%',padding:'0px'}}*/
                                                        inputProps={{
                                                            style: {
                                                                backgroundColor: 'white',
                                                                fontSize: '15.8px', fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                                                                //    paddingLeft:'7px'
                                                                width: '100%'
                                                            }
                                                        }}
                                                        inputVariant="filled"
                                                        InputLabelProps={{ style: { paddingRight: 10, paddingTop: 0, color: 'grey', width: '100%' } }}
                                                        onChange={(event) => this.handleDate(event)}
                                                        variant="filled"
                                                        KeyboardButtonProps={{
                                                            'aria-label': 'change date',
                                                        }}
                                                        views={["year", "month", "date"]}
                                                        openTo="year"
                                                        minDate={new Date('01/01/2020')}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            )
                                            :

                                            this.state.searchTypeValue === '3' ?
                                            this.state.checkADDons ?
                                                <FormControl variant="filled" style={customStyle.formControlStyle1}>
                                                    <InputLabel id="demo-simple-select-label" style={{}}
                                                    >Select Status</InputLabel>
                                                    <Select name="name" style={customStyle.searchByStyle} value={this.state.statusValue} onChange={(event) => this.statusChange(event)}>
                                                        <MenuItem value='all'>All Status</MenuItem>
                                                        <MenuItem value='0' >Instructions</MenuItem>
                                                        <MenuItem value='1' >Set up Family</MenuItem>
                                                        <MenuItem value='2' >View Quote</MenuItem>
                                                        <MenuItem value='3' >Check Eligibility</MenuItem>
                                                        <MenuItem value='4' >Select Program</MenuItem>
                                                        <MenuItem value='5' >Select Add-Ons</MenuItem> 
                                                        <MenuItem value='6' >Review Choices</MenuItem>
                                                        <MenuItem value='7' >Setup Payment</MenuItem>
                                                        <MenuItem value='8' >Submit Application</MenuItem>
                                                    </Select>
                                                </FormControl>
                                                :
                                                <FormControl variant="filled" style={customStyle.formControlStyle1}>
                                                    <InputLabel id="demo-simple-select-label" style={{}}
                                                    >Select Status</InputLabel>
                                                    <Select name="name" style={customStyle.searchByStyle} value={this.state.statusValue} onChange={(event) => this.statusChange(event)}>
                                                        <MenuItem value='all'>All Status</MenuItem>
                                                        <MenuItem value='0' >Instructions</MenuItem>
                                                        <MenuItem value='1' >Set up Family</MenuItem>
                                                        <MenuItem value='2' >View Quote</MenuItem>
                                                        <MenuItem value='3' >Check Eligibility</MenuItem>
                                                        <MenuItem value='4' >Select Program</MenuItem>
                                                        <MenuItem value='5' >Review Choices</MenuItem>
                                                        {/*<MenuItem value='5' >Select Add-Ons</MenuItem> //commented change for add-ons 30-March */}
                                                        <MenuItem value='6' >Setup Payment</MenuItem>
                                                        <MenuItem value='7' >Submit Application</MenuItem>
                                                    </Select>
                                                </FormControl>
                                                :
                                                isMembersTab && this.state.searchTypeValue === '9' ? (
                                                    <FormControl variant="filled" style={customStyle.formControlStyle1}>
                                                        <InputLabel id="demo-simple-program-name-label" style={{ fontSize: 14 }}>Select Program</InputLabel>
                                                        <Select
                                                            labelId="demo-simple-program-name-label"
                                                            name="programName"
                                                            style={customStyle.searchByStyle}
                                                            value={this.state.membersSelectedPlanCode}
                                                            onChange={this.handleMembersProgramChange}
                                                            MenuProps={{
                                                                getContentAnchorEl: null,
                                                                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                                                                transformOrigin: { vertical: 'top', horizontal: 'left' },
                                                            }}
                                                        >
                                                            {this.state.membersPlanCodes.map((code) => (
                                                                <MenuItem key={code} value={code}>{code}</MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                ) : (
                                                    <FormControl variant="filled" style={customStyle.formControlStyle} fullWidth>
                                                        <TextField
                                                            className="agent-search-by-field"
                                                            label={"Search By " + (!this.state.searchShow ? (filterSearch[this.state.searchTypeValue] || "") : "")}
                                                            variant="filled"
                                                            value={this.state.searchText}
                                                            disabled={this.state.searchShow}
                                                            InputLabelProps={{ style: { fontSize: 16 } }}
                                                            onChange={(event) => this.setSearch(event)}
                                                            onKeyDown={(event) => {
                                                                if (event.key === 'Enter') {
                                                                    this.searchRecord();
                                                                }
                                                            }}
                                                            style={{ backgroundColor: "#fff" }}
                                                            fullWidth
                                                        />
                                                    </FormControl>
                                                )

                                    }

                                </Grid>

                            {/* Search button + Members status chip (auto-width, no extra grid gap) */}
                                <Grid
                                    item
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 6,
                                        flex: "0 0 auto",
                                        // When date/date-range filters are shown, add spacing so the Search button doesn't crowd the picker.
                                        marginLeft:
                                            (isMembersTab && ['10', '14', '15', '16'].includes(this.state.searchTypeValue)) ||
                                            (!isMembersTab && this.state.searchTypeValue === '0')
                                                ? 12
                                                : 0,
                                    }}
                                >
                                    {!(isMembersTab && (this.state.searchTypeValue === '4' || this.state.searchTypeValue === '9')) && (
                                        <CustomTooltip title="Search" placement="bottom">
                                            <CrudButton
                                                color="secondary"
                                                style={{ boxShadow: 'none', width: '40px', height: '40px', marginLeft: 0 }}
                                                aria-label="search"
                                                disabled={
                                                    isMembersTab
                                                        ? (
                                                            ['10', '14', '15', '16'].includes(this.state.searchTypeValue)
                                                                ? (!this.state.membersFromDate || !this.state.membersToDate)
                                                                : String(this.state.searchText || '').trim() === ''
                                                        )
                                                        : (this.state.searchText == '' || this.state.targetDate == '')
                                                }
                                                onClick={() => this.searchRecord()}
                                            >
                                                <SearchIcon />
                                            </CrudButton>
                                        </CustomTooltip>
                                    )}

                                    
                                            {/* //    <CustomTooltip
                                            //     title="Add employee"
                                            //     placement="bottom"
                                            // >
                                            //     <CrudButton color="primary" aria-label="add" style={{ width: '46px', height: '46px', boxShadow: 'none', backgroundColor: '#e10050' }} onClick={() => this.addUserModal()} >
                                            //         <AddIcon />
                                            //     </CrudButton>
                                            //     </CustomTooltip> */}
                                    
                            
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* Right-side actions: keep pinned to right */}
                         {isMembersTab && (
                            <FormControl 
                                variant="filled" 
                                style={{ 
                                    backgroundColor: "#FFFFFF", 
                                    width: 'auto',          // Grow with selected chips
                                    minWidth: 250,          // Small baseline footprint
                                    maxWidth: 240,          // THE HARD CEILING
                                    overflow: 'hidden'      // Protect parent layouts
                                }}
                            >
                                <InputLabel style={{ fontSize: 14 }}>Status</InputLabel>
                                <Select
                                    multiple
                                    label='Status'
                                    value={this.state.selectedStatus}
                                    onChange={this.handleChangeStatus}
                                    // Force-override MUI's internal select block styles
                                    MenuProps={{
                                        getContentAnchorEl: null,
                                        anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                                        transformOrigin: { vertical: 'top', horizontal: 'left' },
                                    }}
                                    // CRUCIAL: Overrides internal browser rendering classes
                                    inputProps={{
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            overflowX: 'auto',
                                            overflowY: 'hidden',
                                            whiteSpace: 'nowrap',
                                            maxWidth: '210px', // Prevents internal push against the arrow icon
                                            msOverflowStyle: 'none',  
                                            scrollbarWidth: 'none',   
                                        }
                                    }}
                                    style={{
                                        '& .MuiSelect-select': {
                                            display: 'flex !important',
                                            flexWrap: 'nowrap !important',
                                            overflowX: 'auto !important',
                                            '&::-webkit-scrollbar': { display: 'none !important' }
                                        }
                                    }}
                                    renderValue={(selected) => (
                                        <Box 
                                            display="flex" 
                                            flexWrap="nowrap" // Strict single-line lock
                                            alignItems="center"
                                            style={{ 
                                                gap: 4, 
                                                width: '100%',
                                                overflowX: 'auto', 
                                                overflowY: 'hidden',
                                                msOverflowStyle: 'none',  
                                                scrollbarWidth: 'none',   
                                            }}
                                        >
                                            {selected.map((value) => {
                                                const option = statusOptions.find((item) => item.value === value);
                                                const styles = STATUS_STYLES[option?.label.toLocaleUpperCase()] || {};
                                                return (
                                                    <Chip
                                                        key={value}
                                                        label={option?.label.toLocaleUpperCase()}
                                                        size="small"
                                                        style={{
                                                            backgroundColor: styles.bg,
                                                            color: styles.color,
                                                            fontWeight: 600,
                                                            borderRadius: 4,
                                                            height: 'auto',
                                                            flexShrink: 0 // Stop the browser from crushing the badge
                                                        }}
                                                    />
                                                );
                                            })}
                                        </Box>
                                    )}
                                >
                                    {statusOptions.map((option) => (
                                        <MenuItem key={option.value} value={option.value}
                                            selected={this.state.selectedStatus.includes(option.value)}
                                            style={{
                                            "&.Mui-selected": {
                                                backgroundColor: "#d9d9dbff",
                                            },
                                            "&.Mui-selected:hover": {
                                                backgroundColor: "#d9d9dbff",
                                            },
                                            }}
                                        >
                                            <Checkbox
                                                checked={this.state.selectedStatus.indexOf(option.value) > -1}
                                                sx={{
                                                    color: "#2e3192",
                                                    "&.Mui-checked": {
                                                    color: "#2e3192",
                                                    },
                                                }}
                                            />
                                            <ListItemText primary={option.label} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        )}
                        <Grid
                            item
                            xs={12}
                            sm={sessionStorage.getItem('EMPLOYER_FLOW') === "YES" ? 3 : 2}
                            style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", marginLeft: "auto" }}
                        >
                            {sessionStorage.getItem('EMPLOYER_FLOW') === "YES" ?
                                <Grid item xs={1} sm={1}>
                                    <CustomTooltip
                                        title="Upload employee census records"
                                        placement="bottom"
                                    >
                                        <CrudButton color="primary" aria-label="add" style={{ width: "max-content", height: '40px', boxShadow: 'none', backgroundColor: '#2f3192', marginLeft: 20, borderRadius: 35, fontSize: 12, fontWeight: 700, padding: 11, marginLeft: -115 }} onClick={() => this.uploadData()} >
                                            Upload Census
                                        </CrudButton>
                                    </CustomTooltip>
                                </Grid>
                                :
                                null}
                      
                                        <CustomTooltip
                                            title={`${sessionStorage.getItem("EMPLOYER_FLOW") === "YES" ? "Add employee" : "Add prospect"}`}
                                            placement="bottom"
                                        >
                                                <CrudButton color="primary" aria-label="add" style={{ width: '40px', height: '40px', boxShadow: 'none', backgroundColor: '#2f3192', marginRight: 8 }} onClick={() => this.addUserModal()} >
                                                    <AddIcon />
                                                </CrudButton>
                                           
                                        </CustomTooltip>
                                        { sessionStorage.getItem('EMPLOYER_FLOW') === "YES" &&
                                            <CustomTooltip
                                                title="Invoice"
                                                placement="bottom"
                                            >
                                                <CrudButton aria-label="invoice" style={{ width: '40px', height: '40px', boxShadow: 'none', backgroundColor: '#2f3192', color: '#ffffff', marginRight: 8 }} onClick={() => this.openInvoiceList()} >
                                                    <ReceiptIcon />
                                                </CrudButton>
                                            </CustomTooltip>
                                        }
                                         { sessionStorage.getItem('EMPLOYER_FLOW') === "YES" &&
                                                <CustomTooltip
                                                    title="Advice"
                                                    placement="bottom"
                                                >
                                                    <CrudButton aria-label="advice" style={{ width: '40px', height: '40px', boxShadow: 'none', backgroundColor: '#2f3192', color: '#ffffff', marginRight: 8 }} onClick={() => this.openAdviceList()} >
                                                        <DescriptionIcon />
                                                    </CrudButton>
                                                </CustomTooltip>
                                        }
                                        
                                    <CustomTooltip  title="Refresh" placement="bottom" >
                                            <CrudButton color="primary" aria-label="Refresh" style={{ width: '40px', height: '40px', boxShadow: 'none', backgroundColor: '#2f3192', marginRight: 8 }} onClick={() =>this.refreshTable("screen")}><RefreshIcon /></CrudButton>
                                    </CustomTooltip>
                                     { sessionStorage.getItem('EMPLOYER_FLOW') === "YES" && process.env.REACT_APP_PORTAL !== "employer" &&
                                            <CustomTooltip
                                                title="Send Quote"
                                                placement="bottom"
                                            >
                                                <CrudButton aria-label="Send Quote" style={{ width: '40px', height: '40px', boxShadow: 'none', backgroundColor: '#2f3192', color: '#ffffff', marginRight: 8 }} onClick={() => this.props.handleQuoteMail()} >
                                                    <ScreenShareIcon />
                                                </CrudButton>
                                            </CustomTooltip>
                                        }
                                    {
                                    (() => {
                                        const hasRecords = Array.isArray(this.state.data) && this.state.data.length > 0;
                                        return (
                                            <Tooltip
                                                title={hasRecords ? sessionStorage.getItem('EMPLOYER_FLOW') === "YES" ? "Download employee census records": "Download member census records" : "No records to download"}
                                                placement="bottom"
                                            >
                                                <span>
                                                    <CrudButton
                                                        color="primary"
                                                        aria-label="add"
                                                        disabled={!hasRecords}
                                                        style={{
                                                            width: '40px',
                                                            height: '40px',
                                                            boxShadow: 'none',
                                                            backgroundColor: hasRecords ? '#2f3192' : '#b4b4bb',
                                                            color: '#ffffff',
                                                            marginRight: 8,
                                                            cursor: hasRecords ? 'pointer' : 'not-allowed',
                                                        }}
                                                        onClick={() => hasRecords && this.handleDownloadCSV()}
                                                    >
                                                        <CloudDownload/>
                                                    </CrudButton>
                                                </span>
                                            </Tooltip>
                                        );
                                    })()
                                    }
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} sm={12} >
                       { this.state.loaderShow && !this.props.noShimmer ? <> <ShimmerDashboard onlyTable={true}/>  </>: 
                        <div className="custom-table-wrapper">
                            <MuiThemeProvider theme={getMuiTheme()}>
                                <div className="dwnloadListTable">
                                <MUIDataTable
                                    className="my-data-table"
                                    data={this.state.data}
                                    columns={isMembersTab ? this.getMembersColumns() : this.columns}
                                    options={options}
                                />
                                </div>
                            </MuiThemeProvider>
                            </div>}
                        </Grid>
                    </Grid>
                </div>



                {/* ----Add user----- modal */}

                <Modal size="lg" show={this.state.addUsermodalShow} onHide={(event) => this.setState({ addUsermodalShow: false, loaderShow: false })} centered backdrop='static'>
                    <Modal.Header style={customStyle.modal_header} closeButton>
                        {
                            sessionStorage.getItem('EMPLOYER_FLOW') === "YES" ?
                                <Modal.Title>Add Employee</Modal.Title>
                                :
                                <Modal.Title>Add Prospect</Modal.Title>
                        }
                    </Modal.Header>
                    <Modal.Body >
                        {
                            this.state.loaderShow ? <Loader></Loader> : ''
                        }
                        <div style={{ flexGrow: 1 }}>
                            <Grid container spacing={2} justify="center" >
                                <Grid item xs={12} sm={2} >
                                    <SampleName setChild={this.setUserValue.bind(this)} name={'prefix'} label={'Prefix'} value={this.state.prefix} disable={false} style={customStyle.textFieldWrpAgent} length={10} fieldType={'noSpaceName'} errMsg={'Enter valid prefix'} parentDetails={{ name: 'prefix' }}></SampleName>
                                </Grid>
                                <Grid item xs={12} sm={5} >
                                    <SampleName setChild={this.setUserValue.bind(this)} reqFlag={true} name={'firstname'} label={'First Name'} value={this.state.fname} disable={false} style={customStyle.textFieldWrpAgent} length={25} fieldType={'fullName'} errMsg={'Enter valid first name'} helperMsg={'First name required'} parentDetails={{ name: 'firstname' }}></SampleName>
                                </Grid>
                                <Grid item xs={12} sm={5} >
                                    <SampleName setChild={this.setUserValue.bind(this)} name={'middleName'} label={'Middle Name'} value={this.state.middleName} disable={false} style={customStyle.textFieldWrpAgent} length={25} fieldType={'noSpaceName'} errMsg={'Enter valid Middle Name'} parentDetails={{ name: 'middleName' }}></SampleName>
                                </Grid>
                                <Grid item xs={12} sm={5} >
                                    <SampleName setChild={this.setUserValue.bind(this)} reqFlag={true} name={'lastname'} label={'Last Name'} value={this.state.lname} disable={false} style={customStyle.textFieldWrpAgent} length={25} fieldType={'fullName'} errMsg={'Enter valid last name'} helperMsg={'Last name required'} parentDetails={{ name: 'lastname' }}></SampleName>
                                </Grid>
                                <Grid item xs={12} sm={2} >
                                    <SampleName setChild={this.setUserValue.bind(this)} name={'suffix'} label={'Suffix'} value={this.state.suffix} disable={false} style={customStyle.textFieldWrpAgent} length={10} fieldType={'noSpaceName'} errMsg={'Enter valid suffix'} parentDetails={{ name: 'suffix' }}></SampleName>
                                </Grid>
                                {sessionStorage.getItem('EMPLOYER_FLOW') === "YES" ?
                                <>
                                <Grid item xs={12} sm={5} >
                                    <Sample setChild={this.setUserValue.bind(this)} reqFlag={false} name={'email'} label={'Email ID'} value={this.state.email} disable={false} style={customStyle.textFieldWrpAgent} length={50} fieldType={'email'} errMsg={'Enter valid email Id'} parentDetails={{ name: 'email' }}></Sample>
                                </Grid>
                                <Grid item xs={12} sm={5} >
                                    <div>
                                        <MuiPhoneNumber
                                            name={"phone"}
                                            id="filled-required"
                                            label={"Mobile No."}
                                            data-cy="user-phone"
                                            variant="filled"
                                            defaultCountry={"us"}
                                            onlyCountries={["us"]}
                                            autoComplete='off'
                                            value={this.state.phone}
                                            length={17}
                                            onChange={(e) => this.setUserValue(e, true, { name: 'phone' })}
                                            disable={false} style={customStyle.textFieldWrpAgent} fieldType={'phone'}
                                            errMsg={'Enter valid mobile no.'} helperMsg={'Mobile no. required'}
                                        />
                                        {(!this.state.phone || this.state.phone.length === 17) ? null : <p class="MuiFormHelperText-root MuiFormHelperText-contained Mui-required mobileErr">Enter valid mobile no.</p>}
                                        {/* <Sample setChild={this.setUserValue.bind(this)} reqFlag={true} name={'phone'} label={'Mobile No.'} value={this.state.phone} disable={false} style={customStyle.textFieldWrpAgent} length={10} fieldType={'phone'} errMsg={'Enter valid mobile no.'} helperMsg={'Mobile no. required'} parentDetails={{ name: 'phone' }}></Sample> */}
                                    </div>
                                </Grid>
                                </>
                                :
                                <>
                                <Grid item xs={12} sm={5} >
                                    <Sample setChild={this.setUserValue.bind(this)} reqFlag={true} name={'email'} label={'Email ID'} value={this.state.email} disable={false} style={customStyle.textFieldWrpAgent} length={50} fieldType={'email'} errMsg={'Enter valid email Id'} helperMsg={"Email is required"} parentDetails={{ name: 'email' }}></Sample>
                                </Grid>
                                <Grid item xs={12} sm={5} >
                                    <div>
                                        <MuiPhoneNumber
                                            name={"phone"}
                                            required id="filled-required"
                                            label={"Mobile No."}
                                            data-cy="user-phone"
                                            variant="filled"
                                            defaultCountry={"us"}
                                            onlyCountries={["us"]}
                                            autoComplete='off'
                                            value={this.state.phone}
                                            length={17}
                                            onChange={(e) => this.setUserValue(e, true, { name: 'phone' })}
                                            disable={false} style={customStyle.textFieldWrpAgent} fieldType={'phone'}
                                            errMsg={'Enter valid mobile no.'} helperMsg={'Mobile no. required'}
                                        />
                                        {(!this.state.phone || this.state.phone.length === 17) ? null : <p class="MuiFormHelperText-root MuiFormHelperText-contained Mui-required mobileErr">Enter valid mobile no.</p>}
                                    </div>
                                </Grid>
                                </>
                            }
                                
                            </Grid>

                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <NextButton style={{ margin: '0', marginRight: '10px', width: '95px', height: '40px' }} disabled={this.state.userValid} onClick={() => this.addUser()}>ADD</NextButton>
                        <CustomButton style={{ height: '40px' }} onClick={() => this.setState({ addUsermodalShow: false, loaderShow: false })}>Cancel</CustomButton>
                    </Modal.Footer>
                </Modal>


                {/*---------------------------- View Details Modal--------------------- */}


                <Modal size="xl" show={this.state.viewDetailsModal} onHide={(event) => this.setState({ viewDetailsModal: false, loaderShow: false, viewUserData: [], transactionData: [], loginData: [], transCount: 0, loginCount: 0, reassignHistoryCount: 0 })} centered backdrop='static'>
                    {/*<Modal.Header style={customStyle.modal_header} closeButton>
                            <Modal.Title>View Details</Modal.Title>
                        </Modal.Header>
                        <Modal.Body >
                            
                            {
                                this.state.loaderShow ? <Loader></Loader> : ''
                            }
                            <div style={{flexGrow:1}}>
                            <Grid container spacing={2} justify="center" >
                            <Grid item xs={12} sm={5} >
                            <Sample setChild={this.setUserValue.bind(this)} reqFlag={true} name={'firstname'} label={'First Name'} value={this.state.fname} disable={false} style={customStyle.textFieldWrpAgent} length={25}  fieldType={'text'} errMsg={'Enter valid first name'} helperMsg={'First name required'} disable={true} parentDetails={{name:'firstname'}}></Sample>
                            </Grid>
                            <Grid item xs={12} sm={5} >
                            <Sample setChild={this.setUserValue.bind(this)} reqFlag={true} name={'lastname'} label={'Last Name'} value={this.state.lname} disable={false} style={customStyle.textFieldWrpAgent} length={25}  fieldType={'text'} errMsg={'Enter valid last name'} helperMsg={'Last name required'} disable={true} parentDetails={{name:'lastname'}}></Sample>
                            </Grid>
                            <Grid item xs={12} sm={5} >
                            <Sample setChild={this.setUserValue.bind(this)} reqFlag={true} name={'email'} label={'Email ID'} value={this.state.email} disable={false} style={customStyle.textFieldWrpAgent} length={50}  fieldType={'email'} errMsg={'Enter valid email Id'} helperMsg={'Email Id required'} disable={true} parentDetails={{name:'email'}}></Sample>
                            </Grid>
                            <Grid item xs={12} sm={5} >
                            <Sample setChild={this.setUserValue.bind(this)} reqFlag={true} name={'phone'} label={'Mobile No.'} value={this.state.phone} disable={false} style={customStyle.textFieldWrpAgent} length={10}  fieldType={'phone'} errMsg={'Enter valid mobile no.'} helperMsg={'Mobile no. required'} disable={true} parentDetails={{name:'phone'}}></Sample>
                            </Grid>
                            <Grid item xs={12} sm={5} >
                                </Grid>                     
                            </Grid>
                            </div>

                        </Modal.Body>
                        <Modal.Footer>
                            <NextButton style={{margin: '0', marginRight : '10px', width: '95px', height: '40px'}} disabled={this.state.userValid} onClick={() => this.setState({viewDetailsModal:false})}>OK</NextButton>
                            
                        </Modal.Footer>*/}
                    <Modal.Body style={{ padding: 0, maxHeight: '450px', overflowX: "hidden" }}>
                    {
                            this.state.activeTab ==1 ?
                            null
                            :
                            this.state.loaderShow ? <Loader></Loader> : ''
                        }
                        <div style={{ flexGrow: 1, height: 'auto', overflowX: 'hidden', overflowY: 'auto', background: "#fff" }}>
                            <Grid container style={{position: "absolute", zIndex:10000}}>
                                <Grid item xs={11} sm={11} md={11} lg={11} >
                                    <AntTabs
                                        value={this.state.activeTab}
                                        onChange={this.handleChange}
                                        indicatorColor="primary"
                                        textColor="primary">
                                        <AntTab label="VIEW DETAILS" className='ant-col-15' style={{ paddingLeft: '0px', fontFamily: 'Roboto, Arial, Helvetica, sans-serif' }} />
                                        <AntTab label="VIEW TRANSACTION DETAILS" disabled={this.state.detailsData.disableFlag} style={{ paddingLeft: '0px', fontFamily: 'Roboto, Arial, Helvetica, sans-serif', lineHeight: 1.5 }} />
                                        <AntTab label="VIEW AGENT HISTORY" disabled = {sessionStorage.getItem('EMPLOYER_FLOW') === "YES"? true : false} style={{ paddingLeft: '0px', fontFamily: 'Roboto, Arial, Helvetica, sans-serif' }} />
                                        {/* <AntTab label="NOTES" style={{ paddingLeft: '0px', fontFamily: 'Roboto, Arial, Helvetica, sans-serif' }} /> */}
                                    </AntTabs>
                                </Grid>
                                <Grid item xs={1} sm={1} md={1} lg={1} style={{ backgroundColor: '#585aa8', padding: '0px' }}>

                                    {/*<div style={{color : '#343a40'}} onClick={(event) => this.setState({viewDetailsModal:false,loaderShow : false})}>X</div>*/}
                                    <Button style={{ color: '#fff', borderRadius: '50%', fontSize: '20px', marginTop:10 }} onClick={(event) => this.setState({ viewDetailsModal: false, loaderShow: false, viewUserData: [], transactionData: [], loginData: [], transCount: 0, loginCount: 0, reassignHistoryCount: 0, detailsData: {} })}><Close/></Button>
                                </Grid>
                            </Grid>
                            {currentScreen}
                        </div>
                    </Modal.Body>
                </Modal>



                {/* -----Edit Prospect------- */}

                <Modal size="lg" show={this.state.editModal} onHide={(event) => this.setState({ editModal: false, loaderShow: false })} centered backdrop='static'>
                    <Modal.Header style={customStyle.modal_header} closeButton>
                        {
                            sessionStorage.getItem('EMPLOYER_FLOW') === "YES" ?
                                <Modal.Title>Edit Employee</Modal.Title>
                                :
                                <Modal.Title>Edit Prospect</Modal.Title>
                        }
                    </Modal.Header>
                    <Modal.Body >
                        {/* {
                                this.state.loaderShow ? <Loader></Loader> : ''
                            } */}
                        <div style={{ flexGrow: 1 }}>

                            <Grid container spacing={2} justify="center" >
                                <Grid item xs={12} sm={2} >
                                    <SampleName setChild={this.setUserValue.bind(this)} name={'prefix'} label={'Prefix'} value={this.state.prefix} disable={false} style={customStyle.textFieldWrpAgent} length={10} fieldType={'noSpaceName'} errMsg={'Enter valid prefix'} parentDetails={{ name: 'prefix' }}></SampleName>
                                </Grid>
                                <Grid item xs={12} sm={5} >
                                    <SampleName setChild={this.setUserValue.bind(this)} reqFlag={true} name={'firstname'} label={'First Name'} value={this.state.fname} disable={false} style={customStyle.textFieldWrpAgent} length={25} fieldType={'fullName'} errMsg={'Enter valid first name'} helperMsg={'First name required'} parentDetails={{ name: 'firstname' }}></SampleName>
                                </Grid>
                                <Grid item xs={12} sm={5} >
                                    <SampleName setChild={this.setUserValue.bind(this)} name={'middleName'} label={'Middle Name'} value={this.state.middleName} disable={false} style={customStyle.textFieldWrpAgent} length={25} fieldType={'noSpaceName'} errMsg={'Enter valid Middle Name'} parentDetails={{ name: 'middleName' }}></SampleName>
                                </Grid>
                                <Grid item xs={12} sm={5} >
                                    <SampleName setChild={this.setUserValue.bind(this)} reqFlag={true} name={'lastname'} label={'Last Name'} value={this.state.lname} disable={false} style={customStyle.textFieldWrpAgent} length={25} fieldType={'fullName'} errMsg={'Enter valid last name'} helperMsg={'Last name required'} parentDetails={{ name: 'lastname' }}></SampleName>
                                </Grid>                                
                                <Grid item xs={12} sm={2} >
                                    <SampleName setChild={this.setUserValue.bind(this)} name={'suffix'} label={'Suffix'} value={this.state.suffix} disable={false} style={customStyle.textFieldWrpAgent} length={10} fieldType={'noSpaceName'} errMsg={'Enter valid suffix'} parentDetails={{ name: 'suffix' }}></SampleName>
                                </Grid>
                                {sessionStorage.getItem('EMPLOYER_FLOW') === "YES"?
                                    <>
                                    <Grid item xs={12} sm={5} >
                                    <Sample setChild={this.setUserValue.bind(this)} reqFlag={false} name={'email'} label={'Email ID'} value={this.state.email} disable={false} style={customStyle.textFieldWrpAgent} length={50} fieldType={'email'} errMsg={'Enter valid email Id'}  parentDetails={{ name: 'email' }}></Sample>
                                    </Grid>
                                    <Grid item xs={12} sm={5} >
                                        <div>
                                            <MuiPhoneNumber
                                                name={"phone"}
                                                id="filled-required"
                                                label={"Mobile No."}
                                                data-cy="user-phone"
                                                variant="filled"
                                                defaultCountry={"us"}
                                                onlyCountries={["us"]}
                                                autoComplete='off'
                                                value={this.state.phone}
                                                length={17}
                                                onChange={(e) => this.setUserValue(e, true, { name: 'phone' })}
                                                disable={false} style={customStyle.textFieldWrpAgent} fieldType={'phone'}
                                                errMsg={'Enter valid mobile no.'} helperMsg={'Mobile no. required'}
                                            />
                                            {(!this.state.phone || this.state.phone.length === 17) ? null : <p class="MuiFormHelperText-root MuiFormHelperText-contained Mui-required mobileErr">Enter valid mobile no.</p>}
                                            {/* <Sample setChild={this.setUserValue.bind(this)} reqFlag={true} name={'phone'} label={'Mobile No.'} value={this.state.phone} disable={false} style={customStyle.textFieldWrpAgent} length={10} fieldType={'phone'} errMsg={'Enter valid mobile no.'} helperMsg={'Mobile no. required'} parentDetails={{ name: 'phone' }}></Sample> */}
                                        </div>
                                    </Grid>
                                    </>
                                    :
                                    <>
                                    <Grid item xs={12} sm={5} >
                                        <Sample setChild={this.setUserValue.bind(this)} reqFlag={true} name={'email'} label={'Email ID'} value={this.state.email} disable={false} style={customStyle.textFieldWrpAgent} length={50} fieldType={'email'} errMsg={'Enter valid email Id'} helperMsg={'Email Id required'} parentDetails={{ name: 'email' }}></Sample> {/* disable={true}  */}
                                    </Grid>
                                    <Grid item xs={12} sm={5} >
                                        <div>
                                            <MuiPhoneNumber
                                                name={"phone"}
                                                required id="filled-required"
                                                label={"Mobile No."}
                                                data-cy="user-phone"
                                                variant="filled"
                                                defaultCountry={"us"}
                                                onlyCountries={["us"]}
                                                autoComplete='off'
                                                value={this.state.phone}
                                                length={17}
                                                onChange={(e) => this.setUserValue(e, true, { name: 'phone' })}
                                                disable={false} style={customStyle.textFieldWrpAgent} fieldType={'phone'}
                                                errMsg={'Enter valid mobile no.'} helperMsg={'Mobile no. required'}
                                            />
                                            {(!this.state.phone || this.state.phone.length === 17) ? null : <p class="MuiFormHelperText-root MuiFormHelperText-contained Mui-required mobileErr">Enter valid mobile no.</p>}
                                        </div>
                                    </Grid>
                                    </>
                                }

                            </Grid>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <NextButton style={{ margin: '0', marginRight: '10px', width: '95px', height: '40px' }} disabled={this.state.userValid} onClick={() => this.updateUser()}>UPDATE</NextButton>
                        {/* disabled={this.state.userValid} */}
                        <CustomButton style={{ height: '40px' }} onClick={() => this.setState({ editModal: false, loaderShow: false })}>Cancel</CustomButton>
                    </Modal.Footer>
                </Modal>

                {/* ----Upload excel---- modal */}

                <Modal size="lg" show={this.state.uploadExcelModal} onHide={(event) => this.setState({ uploadExcelModal: false, uploadFileName:'',fileNameModal:false,invalidMessage:false,validationArr:[], loaderShow: false })} centered backdrop='static'>
                    <Modal.Header style={customStyle.modal_header} closeButton>

                        <Modal.Title>Upload Census</Modal.Title>

                    </Modal.Header>
                    <Modal.Body >
                        {
                            //this.state.loaderShow ? <Loader></Loader> : ''
                            this.state.uploadLoaderShow ? <Loader></Loader> : ''
                        }
                        <div style={{ flexGrow: 1 }}>
                            <Grid container spacing={2} justify="center" >
                                <Grid item xs={12} sm={8} >
                                    <div style={uploadContent}>
                                   
                                       { this.state.downloadDataFlag == true ?
                                       <>
                                        
                                            <p>To update the census, download the current employee records and follow the guidelines below:</p>
                                         </>
                                        
                                        :
                                        <>
                                                <p>To create the census, use the template provided and follow the guidelines below:</p>
                                        </>
                                        }

                                    </div>




                                </Grid>

                                <Grid item xs={12} sm={4} >
                                    {
                                        this.state.downloadDataFlag == true ?
                                        <CustomButton style={{ height: '40px' }} onClick={this.downloadProspectCensus} >
                                             Download Current Census 
                                        </CustomButton>
                                        :
                                        <CustomButton style={{ height: '40px' }} >
                                         <a href={require("../CommonScreens/Employee_Census_Template.xlsx")} download="Employee_Census_Template" className="dwnldBtn">Download Template</a>
                                         </CustomButton>
                                    }
                                    
                                    {/* <CustomButton style={{ height: '40px' }} onClick={() => exportToExcel(this.state.exportToExcelArr)} > */}
                                        {/* <a href={require("../CommonScreens/Employee_Census_Template.xlsx")} download="Employee_Census_Template" className="dwnldBtn">Download Template</a> */}
                                       

                                </Grid>



                            </Grid>
                            <Grid container spacing={2} justify="center">
                            {this.state.downloadDataFlag == true ?
                                       <>
                                            <ul>
                                                <li>
                                                To maintain data integrity across multiple census updates, ensure that the record number mapped to each employee doesn’t change.
                                                </li>
                                                <li>
                                                Data of employees who have already been enrolled is locked for editing and cannot be changed.
                                                </li>
                                            </ul>
                                         </>
                                        
                                        :
                                        <>
                                                <ul>
                                                    <li>Birth gender, age and zip is mandatory for Quick Quote.</li>
                                                    <li>Employee email address along with name, relationship and birth
                                                        date of all household members is mandatory for Enrollment.</li>
                                                    <li> To maintain data integrity across multiple census updates, ensure
                                                        that the record number mapped to each employee doesn’t change.</li>
                                                </ul>
                                        </>
                                        }
                            </Grid>

                            <Grid container spacing={2} justify="center" >
                                <Grid item xs={12} sm={12} >
                                    {/* <ReadExcel /> */}


                                    <div className="uploadWrapContainer">
                                        <div className="drop-it-hot" id="drop-area" onDrop={this.handleDrop} >

                                            <form className="choose-files">
                                                <div className="button-wrapper">
                                                    
                                                    <svg fill="currentColor" height="62" viewBox="0 0 24 24" width="62" xmlns="http://www.w3.org/2000/svg" style={{ color: '#BFBFBF' }}>
                                                        <path d="M0 0h24v24H0z" fill="none" />
                                                        <path d="M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z" />
                                                    </svg>
                                                    <label className="label" for="fileElem" >Drag and drop file or</label>
                                                    <div style={{position:'relative', height:'40px',marginBottom:'15px'}}>
                                                        <button type="button" className="btn">BROWSE</button>
                                                        <input type="file" id="fileElem"  accept=".xlsx,.xls" onChange={this.handleChangeFile} onClick={e => (e.target.value = null)}/>
                                                    </div>
                                                    {/* <lable className="selectedFileLabel"> Selected File : {this.state.uploadFileName}</lable> */}
                                                    
                                                   <div style={{height:'50px'}}>
                                                       
                                                    <Toast show={this.state.fileNameModal} onClose={this.filenameModalClose} style={{maxHeight:'40px', marginBottom:'10px'}}>
                                                            <Toast.Header>
                                                                    <img
                                                                    src="holder.js/20x20?text=%20"
                                                                    alt=""
                                                                    />
                                                                    <div style={{width:'95%',overflow:'hidden',textOverflow:'ellipsis', color:'#C3C3C3'}}>Selected File : {this.state.uploadFileName}</div>
                                                            </Toast.Header>
                                                                {/* <Toast.Body></Toast.Body> */}
                                                        </Toast>
                                                   </div>                                                  


                                                </div>
                                            </form>
                                            <div id="gallery"></div>
                                        </div>
                                    </div>
                                    {
                                        this.state.invalidMessage?
                                        <p style={{color: '#a94442',fontStyle: "italic",fontSize: '14px'}}>Please upload a valid Excel (.xls or .xlsx) file.</p>
                                        :
                                        null
                                    }

                                </Grid>
                            </Grid>

                        </div>

                    </Modal.Body>

                    <Modal.Footer>
                        <CustomButton style={{ height: '40px',padding:'10px 20px',fontWeight:'bold' }} disabled={this.state.fileNameModal==false||this.state.fileNameModal=='false'} onClick={this.uploadButtonClick}>UPLOAD</CustomButton>
                    </Modal.Footer>
                </Modal>

                    {/* ---------------------validation excel modal----------------------- */}
                <Modal size="md" show={this.state.validationExcelModal} onHide={(event) => this.setState({ validationExcelModal: false, loaderShow: false, validationArr:[],fileNameModal :false })} backdrop='static' centered>
                    <Modal.Header style={customStyle.modal_header} closeButton>
                        <Modal.Title>{ this.state.successUpload?"Upload Census": this.state.excelValidation || this.state.duplicateEmail ? "Errors in Census":"Warning !"}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: '15px' }}>
                    {
                            this.state.loaderShow ? <Loader></Loader> : '' 
                        }
                           <div>
                            {
                                this.state.successUpload?
                                <h6>Census imported successfully.</h6>
                                :
                                // this.state.duplicateEmail?
                                // <h6>Uploaded census file contain duplicate email entries. Please verify the email entries again</h6>
                                // :
                                
                                this.state.excelValidation && this.state.validationArr && this.state.validationArr.length > 0 ?
                                    <div className="">
                                        <p>The census could not be imported due to the following errors.</p>
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                <th style={{background:'#F2F2F2'}}>Record</th>
                                                <th style={{background:'#F2F2F2'}}>Relationship</th>
                                                <th style={{background:'#F2F2F2'}}>Message</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.validationArr
                                                    .filter(
                                                    (item, index, self) =>
                                                        index ===
                                                        self.findIndex(
                                                        (t) =>
                                                            t.record === item.record &&
                                                            t.relationship === item.relationship &&
                                                            t.msg === item.msg
                                                        )
                                                    ).map((data)=>{
                                                    return  <tr>
                                                                <td>{data.record}</td>
                                                                <td>{data.relationship}</td>
                                                                <td>{data.msg}</td>
                                                            </tr>
                                                    })
                                                }         
                                            </tbody>
                                        </table>                           
                                    </div>

                                :
                                <>
                                {
                                    this.state.inValidEmailData && this.state.inValidEmailData.length > 0 ?
                                    <>
                                        <h6>The employees listed below are already in the system:</h6>
                                        <ul>
                                        {
                                            this.state.inValidEmailData.map((email,i)=>{
                                                return <li>{email}</li>                                         
                                                    
                                            })
                                        }
                                        </ul>
                                    </>
                                    :
                                    null
                                }

                                {
                                    this.state.inValidRecordData && this.state.inValidRecordData.length > 0 || this.state.duplicateEmail?
                                    <>
                                    {/* {
                                        this.state.duplicateEmail?
                                        <h6>Uploaded census file contain duplicate email entries. Please verify the email entries again </h6>
                                        :
                                        <h6>{this.state.errMsg}</h6>
                                        // <h6>The record number listed below are already in the system:</h6>
                                    } */}
                                         <h6>{this.state.errMsg}</h6>
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                <th style={{background:'#F2F2F2'}}>Record</th>
                                                <th style={{background:'#F2F2F2'}}>Name</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.inValidRecordData.map((rec,i)=>{
                                                    return  <tr>
                                                                <td>{rec.record}</td>
                                                                <td>{rec.firstName} {rec.lastName}</td>
                                                            </tr>
                                                    })
                                                }         
                                            </tbody>
                                        </table>
                                        
                                    </>
                                    :
                                    null
                                } 

                                <br/>
                                {
                                    this.state.duplicateEmail ?
                                    null
                                    :
                                     <p>Click <b>CONTINUE</b> to replace existing data.</p>

                                }



                                </>
                            }

                           
                                
                           
                        </div>
                    </Modal.Body>
                    <Modal.Footer>

                        {
                             this.state.successUpload || this.state.duplicateEmail || this.state.excelValidation ?
                           // <CustomButton style={{ height: '40px',marginRight:'15px' }} onClick={() => this.setState({ validationExcelModal: false, loaderShow: false,validationArr:[], excelValidation: false,inValidRecordData:[]}, ()=>{this.refreshTable})}>Ok</CustomButton>
                            <CustomButton style={{ height: '40px',marginRight:'15px' }} onClick={this.uploadExcelOkBtn}>Ok</CustomButton>
                            :
                            <>
                            <CustomButton style={{ height: '40px',marginRight:'15px' }} onClick={this.invalidOk}>CONTINUE</CustomButton>
                            <CustomButton style={{ height: '40px' }} onClick={() => this.setState({ validationExcelModal: false,validationArr:[], excelValidation: false,inValidRecordData:[],fileNameModal:false, loaderShow: false},()=>this.getUserData(this.state.empid))}>CANCEL</CustomButton>
                            </>
                        }
                       

                    </Modal.Footer>
                </Modal>




                {/*=================================== Message Model ======================================*/}
                <Modal size="md" show={this.state.msgModal} onHide={(event) => this.setState({ msgModal: false, circleloaderShow: false, code: null, reAssignSuccess: false,  emailID:false, inviteStatus:"", phoneNumber:"" },()=>{this.refreshTable()})} backdrop='static' centered>
                    <Modal.Header style={customStyle.modal_header} closeButton>
                        <Modal.Title>Message</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: '15px' }}>
                        {
                            this.state.loaderShow ? <Loader></Loader> : ''
                        }

                        {                       
                            this.state.reAssignSuccess ? 
                            <p><b>{this.state.selecetedAgentName}</b> has been now assigned to assist <b>{this.state.prospectFullName}</b></p>:
                            null
                        }

                        <div style={customStyle.HomeContainer}>
                            <div style={customStyle.HomeMAinChild}>
                                {this.state.errMsg}

                                {
                                    this.state.code === 202 &&
                                    <CopyToClipboard text={configurations.enrollmentURL + '/login'}>
                                        <NextButton style={{ width: '50%', height: '30px', marginBottom: '5px', marginTop: '18px' }} disbled={this.state.agentURL === ''} onClick={() => { document.execCommand("copy"); }}>COPY LOGIN LINK</NextButton>
                                    </CopyToClipboard>
                                }
                            </div>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        {
                            this.state.errModal &&
                            <CustomButton style={{ height: '40px', marginRight: 10 }} onClick={() => this.state.editModal ? this.updateUserObj(this.state.userObject, true) : this.addUserObj(this.state.userObject, true)}>CONFIRM</CustomButton>
                        }
                        <CustomButton style={{ height: '40px' }} onClick={() => this.setState({ msgModal: false, circleloaderShow: false, code: null, reAssignSuccess: false, emailID:false, inviteStatus:"", phoneNumber:"" },()=>this.refreshTable())}>{this.state.emailID || this.state.errModal ? "Cancel" : "Ok"}</CustomButton>
                        {this.state.emailID && <CustomButton style={{ height: '40px', marginLeft:'10px'}} onClick={() => this.sendAuthEmail()}>OK</CustomButton>}
                    </Modal.Footer>
                </Modal>
                {/*=================================== Message Model ======================================*/}


                {/*=================================== Missing Model ======================================*/}
                <Modal size="md" show={this.state.missingModal} onHide={(event) => this.setState({ missingModal: false, loaderShow: false, code: null })} backdrop='static' centered>
                    <Modal.Header style={customStyle.modal_header} closeButton>
                        <Modal.Title>{this.state.missingTitle}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: '15px' }}>
                        {
                            this.state.loaderShow ? <Loader></Loader> : ''
                        }

                        <div style={customStyle.HomeContainer}>
                            <div style={customStyle.HomeMAinChild}>
                                {this.state.errMsg}
                            </div>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <CustomButton style={{ height: '40px' }} onClick={() => this.setState({ missingModal: false, loaderShow: false, code: null })}>Ok</CustomButton>
                    </Modal.Footer>
                </Modal>
                {/*=================================== Message Model ======================================*/}

                        <Modal size="md" show={this.state.isTransitioned} onHide={(event) => this.setState({ isTransitioned: false, loaderShow: false })} backdrop='static' centered>
                    <Modal.Header style={customStyle.modal_header} closeButton>
                        <Modal.Title>Message</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: '15px' }}>
                        {
                            this.state.loaderShow ? <Loader></Loader> : ''
                        }

                        <div style={customStyle.HomeContainer}>
                            <div style={customStyle.HomeMAinChild}>
                                The program you are on does not support any changes to enrollment. For assistance, please call Member Services at {sessionStorage.getItem("customerServiceNo")} Monday through Friday, 8.00am to 8.00pm CST.
                            </div>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <CustomButton style={{ height: '40px' }} onClick={() => this.setState({ isTransitioned: false, loaderShow: false })}>Ok</CustomButton>
                    </Modal.Footer>
                </Modal>



                {/* ==================================Delete Modal============================================== */}

                <Modal size="md" show={this.state.deleteModal} onHide={(event) => this.setState({ deleteModal: false, loaderShow: false, code: null })} backdrop='static' centered>
                    <Modal.Header style={customStyle.modal_header} closeButton>
                        <Modal.Title>Warning</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: '15px' }}>
                        {
                            this.state.loaderShow ? <Loader></Loader> : ''
                        }

                        <div style={customStyle.HomeContainer}>
                            <div style={customStyle.HomeMAinChild}>
                                This operation will delete the entry and you will not be able to create a new entry with the same email address again. Do you really want to delete? If you are unsure, please click CANCEL and call agent support: <span style={{ fontWeight: 'bold' }}>800-921-4505 option 3</span>
                            </div>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <CustomButton style={{ height: '40px', marginRight: '15px' }} onClick={() => this.handleOk()}>CONTINUE WITH DELETE</CustomButton>
                        <CustomButton style={{ height: '40px' }} onClick={() => this.setState({ deleteModal: false, loaderShow: false, code: null, userName: '' })}>CANCEL</CustomButton>
                    </Modal.Footer>
                </Modal>

                {/* ==================================Re-assign Modal============================================== */}

                <Modal
                    size="md"
                    show={this.state.reAssignAgentModal}
                    onHide={(event) => this.setState({ reAssignAgentModal: false, loaderShow: false, circleloaderShow: false, selectedAgent: '', code: null })}
                    backdrop='static'
                    centered
                >
                    <Modal.Header style={customStyle.modal_header} closeButton>
                        <Modal.Title>Re-assign Agent</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: '15px' }}>
                        {
                            this.state.loaderShow ? <Loader></Loader> : ''
                        }
                        <div>
                         <p>Please assign a new agent to assist <b>{this.state.prospectFullName}</b> </p>
                        </div>
                        <div>
                        <CommonDropDwn setChild={this.setAgent.bind(this)}  reqFlag={true} name={'Agent'} label={"Please select agent"} value={this.state.selectedAgent} fieldType={'dropDwn'} disable={false} style={customStyle.dropDown}  List={this.state.agentList}  errMsg={'Select Agent'} helperMsg={'Agent required'} parentDetails={{name:'selectedAgent'}} ></CommonDropDwn>
                        </div>
                       

                    </Modal.Body>
                    <Modal.Footer>
                        <NextButton style={{ margin: '0', marginRight: '10px', width: '95px', height: '40px', boxShadow: 'none' }} disabled={this.state.selectedAgent == ''} onClick={() => this.submitReAssignAgent()}>UPDATE</NextButton>
                        <CustomButton style={{ height: '40px' }} onClick={() => this.setState({ reAssignAgentModal: false, selectedAgent: '', loaderShow: false, circleloaderShow: false })}>Cancel</CustomButton>
                    </Modal.Footer>
                </Modal>

                {/* ==================================Re-assign Modal============================================== */}
               
                {/*<Modal size="xl" show={this.state.modalShow} onHide={(event) => this.setState({modalShow:false,loaderShow : false})} style={{maxWidth:'750px',marginLeft:'20%'}} backdrop='static'>
                        <Modal.Header style={customStyle.modal_header} >
                            <Modal.Title>Add Prospect</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ padding: '15px' }}>
                            {
                                this.state.loaderShow ? <Loader></Loader> : ''
                            }
                            <div style={customStyle.HomeContainer}>
                                <div style={customStyle.HomeMAinChild}>
                                    <div style={customStyle.HomeTextContiner}>
                                        <div style={{width:'320px', margin:'15px'}}>
                                            <Sample setChild={this.setUserValue.bind(this)} reqFlag={true} name={'firstname'} label={'First Name'} value={this.state.fname} disable={false} style={customStyle.textFieldWrpAgent} length={25}  fieldType={'text'} errMsg={'Enter valid first name'} helperMsg={'First name required'}  parentDetails={{name:'firstname'}}></Sample>
                                        </div>
                                        <div style={{width:'320px', margin:'15px'}}>
                                            <Sample setChild={this.setUserValue.bind(this)} reqFlag={true} name={'lastname'} label={'Last Name'} value={this.state.lname} disable={false} style={customStyle.textFieldWrpAgent} length={25}  fieldType={'text'} errMsg={'Enter valid last name'} helperMsg={'Last name required'}  parentDetails={{name:'lastname'}}></Sample>
                                        </div>
                                    </div>
                                    <div style={customStyle.HomeTextContiner}>
                                        <div style={{width:'320px', margin:'15px'}}>
                                            <Sample setChild={this.setUserValue.bind(this)} reqFlag={true} name={'email'} label={'Email ID'} value={this.state.email} disable={false} style={customStyle.textFieldWrpAgent} length={50}  fieldType={'email'} errMsg={'Enter valid email Id'} helperMsg={'Email Id required'}  parentDetails={{name:'email'}}></Sample>
                                        </div>
                                        <div style={{width:'320px', margin:'15px'}}>
                                            <Sample setChild={this.setUserValue.bind(this)} reqFlag={true} name={'phone'} label={'Mobile No.'} value={this.state.phone} disable={false} style={customStyle.textFieldWrpAgent} length={10}  fieldType={'num'} errMsg={'Enter valid mobile no.'} helperMsg={'Mobile no. required'}  parentDetails={{name:'phone'}}></Sample>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </Modal.Body>
                        <Modal.Footer><NextButton style={{margin: '0', marginRight : '10px', width: '95px', height: '40px'}} disabled={this.state.userValid} onClick={() => this.addUser()}>ADD</NextButton>
                            <CustomButton style={{height : '40px'}} onClick={() => this.setState({modalShow:false, loaderShow : false})}>Cancel</CustomButton>
                        </Modal.Footer>
                    </Modal>*/}

                    {/* {this.state.showCommonErrorModal ? <CommonErrorModal showModal={true}/> : null} */}

                    {/* ----Advice list modal---- */}
                    <Modal size={'lg'} show={this.state.showAdviceList} onClose={(event) => this.setState({ showAdviceList: false, adviceListLoading: false })} onHide={(event) => this.setState({ showAdviceList: false, adviceListLoading: false })} centered backdrop='static'>
                        <Modal.Header style={customStyle.modal_header} closeButton>
                            <Modal.Title>Advices</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={this.state.sendQuoteFlag ? customStyle.tableSendquoteErrorList : customStyle.tableSendquote}>
                            {
                                this.state.adviceListLoading ?
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200, padding: 24 }}>
                                        <CircularProgress style={{ color: '#2e3192' }} />
                                    </div>
                                    :
                                !this.state.adviceList[0] ?
                                    <div>
                                        <text>No advices to be shown!</text>
                                    </div>
                                    :
                                    <Grid container>
                                        <Grid item xs={12} sm={12}>
                                            <MuiThemeProvider theme={getMuiTheme()}>
                                                <div className="">
                                                    <MUIDataTable
                                                        data={this.state.adviceList}
                                                        columns={this.adviceColumns}
                                                        options={this.adviceOptions}
                                                    />
                                                </div>
                                            </MuiThemeProvider>
                                        </Grid>
                                    </Grid>
                            }
                        </Modal.Body>
                        <Modal.Footer>
                            <CustomButton style={{ height: '40px' }} onClick={(event) => this.setState({ showAdviceList: false, adviceListLoading: false })}>CLOSE</CustomButton>
                        </Modal.Footer>
                    </Modal>

                    {/* ----Invoice list modal---- */}
                    <Modal size={'lg'} show={this.state.showInvoiceList} onClose={(event) => this.setState({ showInvoiceList: false, invoiceListLoading: false })} onHide={(event) => this.setState({ showInvoiceList: false, invoiceListLoading: false })} centered backdrop='static'>
                        <Modal.Header style={customStyle.modal_header} closeButton>
                            <Modal.Title>Invoices</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={this.state.sendQuoteFlag ? customStyle.tableSendquoteErrorList : customStyle.tableSendquote}>
                            {
                                this.state.invoiceListLoading ?
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200, padding: 24 }}>
                                        <CircularProgress style={{ color: '#2e3192' }} />
                                    </div>
                                    :
                                !this.state.invoiceList[0] ?
                                    <div>
                                        <text>No invoices to be shown!</text>
                                    </div>
                                    :
                                    <Grid container>
                                        <Grid item xs={12} sm={12}>
                                            <MuiThemeProvider theme={getMuiTheme()}>
                                                <div className="">
                                                    <MUIDataTable
                                                        data={this.state.invoiceList}
                                                        columns={this.invoiceColumns}
                                                        options={this.invoiceOptions}
                                                    />
                                                </div>
                                            </MuiThemeProvider>
                                        </Grid>
                                    </Grid>
                            }
                        </Modal.Body>
                        <Modal.Footer>
                            <CustomButton style={{ height: '40px' }} onClick={(event) => this.setState({ showInvoiceList: false, invoiceListLoading: false })}>CLOSE</CustomButton>
                        </Modal.Footer>
                    </Modal>

                    {/* ----Advice viewer modal---- */}
                    <Modal size={'xl'} show={this.state.showAdvice} onClose={(event) => this.setState({ showAdvice: false, loaderShow: false })} onHide={(event) => this.setState({ showAdvice: false, loaderShow: false })} centered backdrop='static'>
                        <Modal.Header style={customStyle.modal_header} closeButton>
                            <Modal.Title>Advice</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={this.state.sendQuoteFlag ? customStyle.tableSendquoteErrorList : customStyle.tableSendquote}>
                            <iframe
                                src={this.state.adviceUrl}
                                title="Advice"
                                style={{
                                    width: '100%',
                                    height: "500px",
                                    border: 'none',
                                    margin: 'auto'
                                }}
                            />
                        </Modal.Body>
                        <Modal.Footer>
                            <CustomButton style={{ height: '40px' }} onClick={(event) => this.setState({ showAdvice: false, loaderShow: false })}>CLOSE</CustomButton>
                        </Modal.Footer>
                    </Modal>

                    {/* ----Invoice viewer modal---- */}
                    <Modal size={'xl'} show={this.state.showInvoice} onClose={(event) => this.setState({ showInvoice: false, loaderShow: false })} onHide={(event) => this.setState({ showInvoice: false, loaderShow: false })} centered backdrop='static'>
                        <Modal.Header style={customStyle.modal_header} closeButton>
                            <Modal.Title>Invoice</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={this.state.sendQuoteFlag ? customStyle.tableSendquoteErrorList : customStyle.tableSendquote}>
                            <iframe
                                src={this.state.invoiceUrl}
                                title="Invoice"
                                style={{
                                    width: '100%',
                                    height: "500px",
                                    border: 'none',
                                    margin: 'auto'
                                }}
                            />
                        </Modal.Body>
                        <Modal.Footer>
                            <CustomButton style={{ height: '40px' }} onClick={(event) => this.setState({ showInvoice: false, loaderShow: false })}>CLOSE</CustomButton>
                        </Modal.Footer>
                    </Modal>

            </div>
        );
    }
}

export default AgentTable;

export const getMuiTheme = () => createMuiTheme({
    overrides: {
        MuiTableHead: {
            root: {
              position: 'sticky',
              top: 0,
              backgroundColor: '#d5d6e9',
              zIndex: 2,
            },
          },
          MuiTableFooter: {
            root: {
              position: 'sticky',
              bottom: 0,
              backgroundColor: '#fff',
              zIndex: 2,
            },
          },
        MUIDataTableBodyCell: {
            root: {
                backgroundColor: "#fff",

                paddingLeft: '7px ',
                // width:'68%',
                // paddingRight:'10px',
                paddingBottom: '0px',
                paddingRight: '3px',
                paddingTop: '0px',
                fontSize: '14px',
                color: '#333333',
                // width:'138px'
                // minWidth:'155px',
                //     wordBreak: 'normal',
                // whiteSpace: 'nowrap',
                // textOverflow: 'ellipsis',
                // width:'150px',
                // fontWeight:'500'
                // lineHeight:'1.5px',
                // letterSpacing:'0.44px'
            },
            responsiveBase: {
                // root:{
                padding: '25px'
                // }
            },

        },
        MUIDataTable: { responsiveBase: { padding: '0' } },
        MuiTableRow: {
            root: {
                '&$selected': {
                    backgroundColor: '#ebf2ff',
                },
                '&$hover': {
                    cursor: 'pointer'
                }

            }
        },

        MuiTypography: { h6: { fontWeight: 'bold', marginBottom: '-28px', marginLeft: '-10px', marginRight: '50px' } },
        MuiToolbar: { gutters: { paddingLeft: '5px' }, regular: { minHeight: '0px' } },
        // MuiPaper:{root:{padding:'30px'}},
        // MuiToolbar:{},
        // MuiTablePagination: {
        //     toolbar: {
        //       backgroundColor: '#e0f7fa',
        //     },
        //   },
          
        MuiTableCell: {
            root: { borderBottom: '1px solid #8283be', padding: '8px' },
            head: {
                backgroundColor: '#d5d6e9',
                position: 'sticky',
                top: 0,
                zIndex: 5,
            },
            footer: { borderBottom: 'none' },
        },
        MuiDataTablePagination: { borderBottom: 'none' },
        MUIDataTableHeadCell: {
            root: {
                backgroundColor: '#d5d6e9',
                fontWeight: 'bold',
                padding:'10px',
                paddingLeft: '14px',
            },

            MUIDataTable: {

                responsiveBase: {
                    // root:{
                    padding: '23px'
                    // }
                },
                // responsiveScroll: {
                //     maxHeight: '380px',

                // },


            },


        },
        MuiTooltip: {
            tooltip: {
                fontSize: '14px',
            },
        },
    }
})